export const thai = {
    global: {
        test: "ทดสอบ",
        next: "ถัดไป",
        name: "ชื่อ",
        email: "อีเมล์",
        view: "ดู",
        edit: "แก้ไข",
        close: "ปิด",
        Close: "ปิด",
        DOWNLOAD: "ดาวน์โหลด",
        submit: "ส่ง",
        ADD: "เพิ่ม",
        CANCEL: "ยกเลิก",
        SAVE: "บันทึก",
        DELETE: "ลบ",
        Delete: "ลบ",
        Duplicate: "ทำซ้ำ",
        SHARE: "แชร์",
        no: "ไม่",
        type: "ประเภท",
        english: "อังกฤษ",
        thai: "ไทย",
        emailEtc: "name@example.com",
        ark_for_help: "ขอความช่วยเหลือ",
        Search: "ค้นหา",
        workspace: "พื้นที่ทำงาน",
        language: "ภาษา",
        logout: "ออกจากระบบ",
        search_results: "ผลการค้นหา",
        Confirm: "ยืนยัน",
        Cancel: "ยกเลิก",
        account_switcher: {
            add_account: "เพิ่มบัญชี",
            log_out: "ออกจากระบบ",
            log_out_of: "ออกจากระบบของ",
            switch_failed: "สลับบัญชีไม่สำเร็จ",
            sign_in_plus_email: "ลงชื่อเข้าใช้ด้วยอีเมล +",
            your_accounts: "บัญชีของคุณ",
            email_address: "ที่อยู่อีเมล",
            sending: "กำลังส่ง...",
            continue: "ดำเนินการต่อ",
            code_sent_to: "ส่งรหัสไปที่",
            verification_code: "รหัสยืนยัน",
            four_digit_code: "รหัส 4 หลัก",
            verifying: "กำลังยืนยัน...",
            different_email: "อีเมลอื่น",
        },
        Save: "บันทึก",
    },
    category: {
        power_skill: {
            empathy: "ความเห็นอกเห็นใจ",
            self_awareness: "การตระหนักรู้ตนเอง",
            leadership: "ภาวะผู้นำ",
            initiative_making: "ความคิดริเริ่ม",
            optimism: "การมองโลกในแง่ดี",
            critical_thinking: "การคิดเชิงวิพากษ์",
        },
        frequency: {
            one_time: "ครั้งเดียว",
            weekly: "รายสัปดาห์",
            monthly: "รายเดือน",
            quarterly: "รายไตรมาส",
            biannually: "ทุก 6 เดือน",
            yearly: "รายปี",
        },
        day_of_week: {
            monday: "วันจันทร์",
            tuesday: "วันอังคาร",
            wednesday: "วันพุธ",
            thursday: "วันพฤหัสบดี",
            friday: "วันศุกร์",
            saturday: "วันเสาร์",
            sunday: "วันอาทิตย์",
        },
        day_of_week_m: {
            mon: "จ.",
            tue: "อ.",
            wed: "พ.",
            thu: "พฤ.",
            fri: "ศ.",
            sat: "ส.",
            sun: "อา.",
        },
        Talent_Types: {
            Starter: "Starter",
            Marginalized: "Marginalized",
            Latent_Potential: "Latent Potential",
            Up_and_coming: "Up-and-coming",
            Supported: "Supported",
            Underutilized: "Underutilized",
            Contributor: "Contributor",
            Rising_Star: "Rising Star",
            High_Contributor: "High Contributor",
            Activated: "Activated",
            Crowd_Favorite: "Crowd Favorite",
            Developing: "Developing",
            Community_Pillar: "Community Pillar",
            Key_Player: "Key Player",
            Respected_Expert: "Respected Expert",
            Distinguished_Talent: "Distinguished Talent",
            Engaged_Contributor: "Engaged Contributor",
            Valued_Contributor: "Valued Contributor",
            Untapped_Potential: "Untapped Potential",
            Emerging_Talent: "Emerging Talent",
            Core_Player: "Core Player",
            High_Performer: "High Performer",
            Hidden_Talent: "Hidden Talent",
            Unsung_Talent: "Unsung Talent",
            High_Potential: "High Potential",
            Solid_Performer: "Solid Performer",
            Superstar: "Superstar",
        },
        Network_type: {
            Low_Network: "Low Network",
            Medium_Inner: "Medium Inner",
            High_Inner: "High Inner",
            Super_Inner: "Super Inner",
            Medium_Outer: "Medium Outer",
            High_Outer: "High Outer",
            Super_Outer: "Super Outer",
            Medium_Network: "Medium Network",
            High_Network: "High Network",
            Super_Network: "Super Network",
        },
    },
    page: {
        awards: "รางวัล",
        awardsDescription: "รับการยอมรับในฐานะนายจ้างชั้นนำด้วยตัวชี้วัดเชิงพฤติกรรม",
        status: "สถานะ",
        timeLine: "ไทม์ไลน์",
        billing: "การเรียกเก็บเงิน",
        billing_description: "ตรวจสอบค่าสมาชิก กิจกรรมรางวัล และการเติมเครดิตแยกตามรอบบิล",
        happilyVillage: "Happily Village",
        happilyVillage_description: "ดูและจัดการการโต้ตอบและประสบการณ์ของ Village",
        overview: "ภาพรวม",
        university: "University",
        townHall: "Town Hall",
        runningTrack: "Running Track",
        battleStadium: "Battle Stadium",
        insights: "อินไซต์",
        insights_description: "ข้อมูลและอินไซต์แบบเรียลไทม์เกี่ยวกับทีมและคนของคุณ",
        skills: "ทักษะ",
        skills_description: "ระบุจุดแข็งและโอกาสในการเรียนรู้และพัฒนา",
        programs: "โปรแกรม",
        programs_description: "ประสบการณ์หลายสัปดาห์ที่ออกแบบไว้สำหรับการต้อนรับพนักงานใหม่ การพัฒนาผู้นำ ความเป็นอยู่ที่ดี และการปฏิบัติตามนโยบาย",
        dashboard: "แดชบอร์ด",
        teams: "ทีม",
        cohorts: "กลุ่ม",
        managers: "ผู้จัดการ",
        people: "พนักงาน",
        reportCard: "รายงานผล",
        integrations: "การเชื่อมต่อ",
        integrations_description: "ซิงค์ข้อมูลพนักงานและเชื่อมต่อกับบริการอื่น",
        HRIS_Sync: "HRIS Sync",
        API: "API",
        members: "สมาชิก",
        members_description: "จัดการสมาชิก ทีม และผู้จัดการของคุณ",
        power_up: "Power-ups",
        power_up_description: "ส่งการชื่นชมให้กับคนที่ยอดเยี่ยม",
        recognition: "การชื่นชม",
        recognition_description: "ส่งการชื่นชมให้กับคนที่ยอดเยี่ยม",
        performance: "ผลงาน",
        performance_description: "ติดตามผลงานตามวัฒนธรรมและเป้าหมาย และเข้าใจจุดที่ต้องโฟกัส",
        focus_areas: "จุดโฟกัส",
        goals: "เป้าหมาย",
        coming_soon: "เร็วๆ นี้...",
        create: "สร้าง",
        outbox: "กล่องส่ง",
        activity: "กิจกรรม",
        questions: "คำถาม",
        questions_description: "จัดการคำถาม เพิ่มคำถามของคุณ และดูคำตอบ",
        standard: "คลังมาตรฐาน",
        custom: "คำถามกำหนดเอง",
        reports: "รายงาน",
        reports_description: "ดูตัวอย่างและดาวน์โหลดรายงานที่สร้างอัตโนมัติ",
        daily: "รายวัน",
        weekly: "รายสัปดาห์",
        monthly: "รายเดือน",
        rewards: "รีวอร์ด",
        rewards_description: "จัดการบัตรของขวัญและรางวัลของบริษัท",
        gift_cards: "บัตรของขวัญ",
        perks: "สิทธิพิเศษ",
        team_building: "สร้างทีม",
        doing_good: "ทำความดี",
        merchandise: "สินค้า",
        "%_merchandise_%": "สินค้า",
        setup_wizard: "ตั้งค่าเริ่มต้น",
        setup_wizard_description: "มาเริ่มตั้งค่ากัน! อีกไม่กี่นาทีคุณก็จะได้ที่ทำงานที่มีความสุขมากขึ้น",
        sparks: "Sparks",
        sparks_description: "เปลี่ยนวิธีที่พนักงานและผู้จัดการรับมือกับปัญหา",
        micro_learning: "Micro-Learning",
        leaderboards: "ลีดเดอร์บอร์ด",
        settings: "ตั้งค่า",
        settings_description: "จัดการบัญชี สมาชิก และการตั้งค่าของคุณ",
        statusPage: "สถานะระบบ",
        statusPage_description: "ตรวจสอบสถานะการทำงานของ Happily แบบเรียลไทม์",
        documentation_dev: "Documentation(Dev)",
        login_title: "เข้าสู่ระบบ",
        pincode_title: "รหัส PIN",
        relationship_mapping: "แผนผังความสัมพันธ์",
        reward_message: "ข้อความรางวัล",
        user_registration: "ลงทะเบียนผู้ใช้",
        nav_groups: {
            analyze: "วิเคราะห์",
            manage: "จัดการ",
            develop: "พัฒนา",
            engage: "การมีส่วนร่วม",
            admin: "ผู้ดูแลระบบ",
        },
    },
    commponents: {
        years: "ปี",
        months: "เดือน",
        days_ago: "วันที่ผ่านมา",
        joined_after: "เข้าร่วมหลัง",
        joined: "เข้าร่วม",
        daily_streak: "Daily Streak",
        achievements: "ความสำเร็จ",
        super_feedback: "Super Feedback",
        MOST_RECENT: "ล่าสุด",
        power: "พลัง",
        badges: "Badges",
        org: "องค์กร",
        relationships: "ความสัมพันธ์",
    },
    setupWizard: {
        stepOne: {
            title: "ยินดีต้อนรับ",
            hi: "สวัสดี",
            header: "ยินดีตอนรับสู่ Happily!",
            contentOne: "คุณสุดยอดมากที่ริเริ่มประสบการณ์เชิงบวกในที่ทำงานของคุณ ด้วย Happily คุณกำลังเปิดโอกาสให้มีฟีดแบ็ก การชื่นชม การเรียนรู้ ชุมชน และอื่นๆ อีกมากมายที่ดียิ่งขึ้น!",
            contentTwo: "ในการเริ่มต้น เราต้องตั้งค่าทีมของคุณ เลือกรางวัล และส่งคำเชิญ มาเริ่มกันเลย!",
            What_are_your: "ค่านิยมหลักของบริษัทคุณคืออะไร?",
        },
        stepTwo: {
            title: "สร้างทีม",
            header: "สร้างทีมขอบคุณ",
            contentOne: "Happily ทำงานเป็นทีมโดยมีผู้จัดการเป็นศูนย์กลาง ฟีดแบ็ก อินไซต์ และรายงานจะถูกส่งไปยังผู้จัดการทีมในแต่ละวันทำงาน เพื่อช่วยให้พวกเขาเข้าใจทีมได้ดียิ่งขึ้นแบบเรียลไทม์ ช่วยเราตั้งค่าทีมของคุณ",
            teamName: "ชื่อทีม",
            teamNameEtc: "ACME Inc",
            managersNameEt: "ชื่อผู้จัดการ",
            email: "อีเมล",
            memberName: "ชื่อสมาชิก",
        },
        stepThree: {
            title: "เลือกของรางวัล",
            contentOne: "ทีมของคุณสามารถใช้ Coins และ Gems ที่ได้รับจากการตอบคำถามประจำวัน (และการมีปฏิสัมพันธ์อื่นๆ) เพื่อแลกรางวัล! เลือกรางวัลของคุณด้านล่าง คุณยังสามารถเพิ่มรางวัลแบบกำหนดเองได้ในภายหลัง",
            SelectOneTitle: "สิทธิพิเศษของบริษัท",
            SelectOneContentOne: "เริ่มต้นด้วยสิทธิประโยชน์ในที่ทำงานที่เราคัดสรรมาเพื่อตอบแทนพนักงานที่มีส่วนร่วมมากที่สุดของคุณ",
            SelectOneContentTwo: "สามารถกำหนดค่ารางวัลได้จากคอนโซลผู้ดูแลระบบของคุณ",
            SelectTwoTitle: "บัตรของขวัญ (ไม่มีให้บริการในช่วงทดลอง)",
            SelectTwoContentOne: "ให้ทีมของคุณแลกบัตรของขวัญจากร้านค้าท้องถิ่นและร้านค้าออนไลน์",
            SelectTwoContentTwo: "ซื้อเครดิตเพื่อเปิดใช้งานบัตรของขวัญ โดยไม่มีค่าธรรมเนียมเพิ่มเติม",
        },
        stepFour: {
            title: "ยื่นยันและเชิญ",
            contentOne: "เกือบเสร็จแล้ว! กำหนดเวลาที่คุณต้องการให้ทีมได้รับคำถาม Daily Pulse เราแนะนำให้เลือกเวลาที่ทีมของคุณเดินทางไปทำงาน",
            quickSettings: "การตั้งค่าด่วน",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "ขั้นตอนถัดไป",
            contentOneWhatHappensNext: "คำเชิญจะถูกส่งไปยังทีมของคุณ และทุกคนจะได้รับชุดคำถาม Daily Pulse ชุดแรกในวันทำงานถัดไป",
            contentTwoWhatHappensNext: "สำรวจคอนโซลผู้ดูแลระบบของคุณเพื่อเพิ่มสมาชิก ดูอินไซต์ สร้างคำถามและรางวัลแบบกำหนดเอง หรือแก้ไขการตั้งค่าบัญชีของคุณ",
        },
    },
    fourZeroFour: {
        looks_like_somehing: "ดูเหมือนมีบางอย่างผิดพลาด",
        the_page_you: "ไม่พบหน้าที่คุณกำลังมองหา!",
        home_page: "หน้าแรก",
    },
    awards: {
        happily_awards: "Happily Awards",
        recognition_driven: "ขับเคลื่อนด้วยการชื่นชม",
        the_practice_of: "การชื่นชมเป็นแนวปฏิบัติที่เสริมแรงเชิงบวกและเป็นสิ่งสำคัญในการสร้างแรงจูงใจให้กับพนักงานคนเก่ง และสร้างทีมที่มีประสิทธิภาพสูง",
        past_thirty_day_participation: "การมีส่วนร่วมใน 30 วันที่ผ่านมา",
        required: "จำเป็น",
        or_higher: "หรือสูงกว่า",
        open_feedback: "ฟีดแบ็กแบบเปิด",
        continuous_feedback_drives: "ฟีดแบ็กอย่างต่อเนื่องขับเคลื่อนการพัฒนาอย่างต่อเนื่อง และเป็นสัญญาณของสภาพแวดล้อมการทำงานที่มีความปลอดภัยทางจิตใจสูง",
        past_thirty_day_open: "อัตราฟีดแบ็กแบบเปิดใน 30 วันที่ผ่านมา",
        active_managers: "ผู้จัดการที่มีส่วนร่วม",
        people_managers_are: "ผู้จัดการคนเป็นผู้ที่อยู่ในตำแหน่งที่ดีที่สุดในการช่วยเหลือ สร้างการมีส่วนร่วม และรักษาพนักงานคนเก่งในทีมของพวกเขาในเชิงรุก",
        past_thirty_day_activity: "กิจกรรมใน 30 วันที่ผ่านมา",
        strong_company_culture: "วัฒนธรรมองค์กรที่แข็งแกร่ง",
        culture_is_a_byproduct: "วัฒนธรรมเป็นผลพลอยได้จากค่านิยมหลักและพฤติกรรม วัฒนธรรมที่แข็งแกร่งทำให้คุณสามารถดำเนินกลยุทธ์ได้อย่างมีประสิทธิภาพและสร้างนวัตกรรม",
        most_recent_culture: "คะแนน Culture Index ล่าสุด",
        high_well_being: "ความเป็นอยู่ที่ดีสูง",
        employee_wellness_and: "สุขภาพและความเป็นอยู่ที่ดีของพนักงานสมควรได้รับความใส่ใจและการดูแล และมีส่วนโดยตรงต่อความยืดหยุ่นขององค์กร",
        most_recent_WHO_5: "คะแนน WHO-5 Index ล่าสุด",
        happiest_workplace: "ที่ทำงานที่มีความสุขที่สุด",
        a_happy_workplace: "ที่ทำงานที่มีความสุขขับเคลื่อนด้วยนิสัยเชิงบวก ไม่ว่าจะเป็นการชื่นชม ฟีดแบ็กแบบเปิด ผู้จัดการที่มีส่วนร่วม วัฒนธรรมที่แข็งแกร่ง และความเป็นอยู่ที่ดีสูง",
        awards_collected: "รางวัลที่ได้รับ",
        collect_all_other: "สะสมรางวัลอื่นๆ ทั้งหมด",
        share_your_award: "แชร์รางวัลของคุณ",
        share_your_award_with: "แชร์รางวัลของคุณกับผู้อื่น รางวัลของคุณถูกเผยแพร่แล้วและพร้อมให้ดูที่ลิงก์ด้านล่าง",
        coppy: "คัดลอก",
        embed_code: "โค้ดสำหรับฝัง",
        preview_link_in: "ดูตัวอย่างลิงก์ในแท็บใหม่",
        to_embed_this: "หากต้องการฝังรางวัลนี้บนเว็บไซต์ของคุณ เพียงคัดลอกและวางโค้ดด้านล่างลงในโค้ด HTML ของเว็บไซต์",
        all_time: "ตลอดเวลา",
        consistency: "ความสม่ำเสมอ",
        current_streak: "สตรีคปัจจุบัน",
        start_date: "วันที่เริ่มต้น",
        january_one: "1 มกราคม",
        today: "วันนี้",
        highlighted_are_periods: "ช่วงที่ไฮไลต์คือช่วงเวลาที่การมีส่วนร่วมในการชื่นชมอยู่ที่",
        days: "วัน",
        required_collect_all: "จำเป็น: สะสมรางวัลอื่นๆ ทั้งหมด",
    },
    billing: {
        BILLING_SUMMARY: "สรุปการเรียกเก็บเงิน",
        SUBSCRIPTION: "การสมัครสมาชิก",
        REWARDS_CHARGES: "ค่าใช้จ่ายรางวัล",
        REWARD_CREDIT_BALANCE: "ยอดเครดิตรางวัล",
        REWARDS_PENDING: "รางวัลรอดำเนินการ",
        active_members: "สมาชิกที่ใช้งาน",
        credit_balance: "ยอดเครดิต",
        credit_remaining: "เครดิตคงเหลือ",
        Date: "วันที่",
        Category: "หมวดหมู่",
        Description: "รายละเอียด",
        Amount: "จำนวนเงิน",
        Status: "สถานะ",
        seats_charged: "ที่นั่งที่เรียกเก็บ",
        export: "ส่งออก",
        top_up_credits: "เครดิตเติมเงิน",
        bill_sent: "ส่งบิลแล้ว",
        all: "ทั้งหมด",
        copy: "คัดลอก",
        copied_to_clipboard: "คัดลอกแล้ว",
        no_data_to_copy: "ไม่มีข้อมูลให้คัดลอก",
        failed_to_copy: "คัดลอกไม่สำเร็จ",
        unable_to_load: "ไม่สามารถโหลดข้อมูลการเรียกเก็บเงินได้",
        try_again: "ลองอีกครั้ง",
        account_billing: "การเรียกเก็บเงินของบัญชี",
        billing_period: "รอบการเรียกเก็บเงิน",
        export_summary: "ส่งออกสรุป",
        live_calculation_note: "หน้านี้คำนวณแบบเรียลไทม์จากกิจกรรมที่บันทึกไว้และกฎการเรียกเก็บเงินปัจจุบัน ใบแจ้งหนี้ฉบับสุดท้ายจัดทำโดยทีมเรียกเก็บเงินของ Happily",
        period_overview: "ภาพรวมรอบบิล",
        how_charges_add_up: "ที่มาของค่าใช้จ่าย",
        pending_separate: "รายการรางวัลที่รอดำเนินการจะแสดงแยกและยังไม่รวมในค่าใช้จ่ายที่คำนวณได้",
        recorded_charges: "ค่าใช้จ่ายที่คำนวณได้",
        charge_calculation: "ค่าสมัครสมาชิกบวกค่ารางวัลบวกการเติมเครดิตเท่ากับยอดรวมที่คำนวณได้",
        subscription_label: "ค่าสมัครสมาชิก",
        rewards_charged: "รางวัลที่เรียกเก็บ",
        credit_top_ups: "การเติมเครดิต",
        recorded_total: "ยอดรวมที่คำนวณได้",
        available_reward_credit: "เครดิตรางวัลที่ใช้ได้",
        available_reward_credit_help: "เครดิตที่พร้อมใช้สำหรับแลกรางวัลในขณะนี้",
        pending_reward_commitments: "รางวัลที่รอดำเนินการ",
        pending_reward_commitments_help: "มูลค่ารางวัลที่ขอแล้วแต่ยังไม่เสร็จสิ้นหรือเรียกเก็บ",
        no_charges: "ไม่มีค่าใช้จ่ายที่คำนวณได้",
        no_charges_help: "ไม่มีค่าสมัครสมาชิก ค่ารางวัล หรือการเติมเครดิตในรอบนี้",
        seat_evidence: "การใช้งานของสมาชิก",
        Country: "ประเทศ",
        member_usage_country: "สมาชิกที่ใช้งานแยกตามประเทศ",
        country_usage_help: "ดูการกระจายของสมาชิกที่ใช้งานในแต่ละประเทศสำหรับรอบบิลนี้ ค่าใช้จ่ายด้านบนจัดกลุ่มตามสกุลเงินที่เรียกเก็บ",
        share_of_usage: "สัดส่วนสมาชิกที่ใช้งาน",
        last_activity: "กิจกรรมล่าสุด",
        view_members: "ดูสมาชิก",
        no_member_activity: "ไม่มีกิจกรรมของสมาชิก",
        no_member_activity_help: "ไม่พบสมาชิกที่ใช้งานในรอบบิลนี้",
        charge_details: "รายละเอียดค่าใช้จ่าย",
        billing_activity: "รายการเรียกเก็บเงิน",
        billing_activity_help: "ดูรายการที่ใช้คำนวณรอบบิลนี้ โดยจัดกลุ่มตามประเภทค่าใช้จ่าย",
        subscription_charges: "ค่าสมาชิก",
        subscription_charges_help: "ค่าสมาชิกคำนวณจากสมาชิกที่ใช้งานและจำนวนที่นั่งขั้นต่ำตามข้อตกลง",
        reward_credit_topups: "การเติมเครดิตรางวัล",
        reward_credit_topups_help: "เครดิตที่เพิ่มเข้ากระเป๋ารางวัลในรอบบิลนี้",
        reward_redemptions: "การแลกรางวัล",
        reward_redemptions_help: "คำขอแลกรางวัลของสมาชิก รวมรายการที่เรียกเก็บแล้ว รอดำเนินการ และยกเลิก เฉพาะรายการที่เรียกเก็บแล้วเท่านั้นที่รวมอยู่ในยอดคำนวณด้านบน",
        member_subscription: "ค่าสมาชิก",
        reward_credit_topup: "เติมเครดิตรางวัล",
        reward_redemption: "แลกรางวัล",
        other_billing_activity: "รายการเรียกเก็บเงินอื่น ๆ",
        other_billing_activity_help: "รายการเรียกเก็บเงินเพิ่มเติมที่ไม่อยู่ในหมวดค่าสมาชิก การเติมเครดิต หรือการแลกรางวัล",
        less_than_one_percent: "<1%",
        entry: "รายการ",
        entries: "รายการ",
        no_activity: "ไม่มีรายการเรียกเก็บเงิน",
        no_activity_help: "ไม่มีรายการเรียกเก็บเงินในรอบนี้",
        copy_list: "คัดลอกรายชื่อ",
        download_csv: "ดาวน์โหลด CSV",
        current_period: "รอบปัจจุบัน",
        period_range_pending: "ช่วงวันที่จะแสดงเมื่อโหลดกิจกรรมแล้ว",
        calculating: "กำลังคำนวณ",
        finalised: "สรุปแล้ว",
        in_progress: "กำลังดำเนินการ",
        waiting_for_activity: "กำลังรอข้อมูลการเรียกเก็บเงิน",
        updated_at: "อัปเดต",
        all_countries: "ทุกประเทศ",
        billable_member_activity: "กิจกรรมสมาชิก",
        not_available: "ไม่มีข้อมูล",
        pending: "รอดำเนินการ",
        charged: "เรียกเก็บแล้ว",
        paid: "ชำระแล้ว",
        canceled: "ยกเลิกแล้ว",
        allow_popups: "โปรดอนุญาตป๊อปอัปเพื่อเปิดไฟล์ส่งออก",
        load_error_help: "รีเฟรชข้อมูลหรือลองอีกครั้งในอีกสักครู่",
    },
    happilyVillage: {
        reels: {
            reel: "รีล", reels: "รีล", posts: "โพสต์", townhall_content: "เนื้อหา Town Hall",
            new_reel: "สร้างรีล", close: "ปิดตัวแก้ไข", back_to_reels: "กลับไปที่รีล", starter: "เทมเพลต HR", upload_video: "อัปโหลดวิดีโอ", build_reel: "สร้างรีล",
            templates: { company_update: "อัปเดตบริษัท", welcome_team: "ต้อนรับเพื่อนร่วมทีมใหม่", recognition: "ชื่นชมหรือฉลองความสำเร็จ", leadership_message: "ข้อความจากผู้นำ", event: "เตือนหรือสรุปกิจกรรม", policy: "นโยบายหรือกำหนดเวลา", blank: "รีลเปล่า" },
            storyboard: "สตอรี่บอร์ด", scenes: "ฉาก", preview: "ตัวอย่าง", edit: "แก้ไข", editor_sections: "ส่วนต่าง ๆ ของตัวแก้ไขรีล",
            drag_scene: "ลากฉาก {n}", move_up: "เลื่อนขึ้น", move_down: "เลื่อนลง", duplicate_scene: "ทำสำเนาฉาก", delete_scene: "ลบฉาก", add_scene: "เพิ่มฉาก", untitled_scene: "ฉากที่ยังไม่มีชื่อ", one_scene_required: "รีลต้องมีอย่างน้อยหนึ่งฉาก", scene_moved: "ย้าย {title} ไปตำแหน่ง {n} จาก {total} แล้ว", editing_scene: "กำลังแก้ไขฉาก {n}: {title}", scene_of: "ฉาก {current} จาก {total}", scene_type: "ประเภทฉาก",
            total_duration: "ความยาวทั้งหมด", recommended_duration: "แนะนำ 30–60 วินาที", preview_reel: "ตัวอย่าง · รีล", preview_hint: "นี่คือหน้าตาที่จะแสดงในแอปมือถือ", preview_title_fallback: "บอกเรื่องสำคัญให้ทีมของคุณ", top_safe_zone: "พื้นที่ปลอดภัยด้านบน", bottom_safe_zone: "พื้นที่ปลอดภัยด้านล่าง", play: "เล่น", pause: "หยุดชั่วคราว", mute: "ปิดเสียง", live_preview: "ตัวอย่างสด", scene_label: "ฉาก", preview_scenes: "ฉากในตัวอย่าง", unmute: "เปิดเสียง", scene_content: "ข้อความ", look_and_timing: "รูปแบบและเวลา",
            text: "ข้อความ", photo: "รูปภาพ", video: "วิดีโอ", media: "สื่อ", no_media: "ยังไม่ได้เลือกสื่อ", choose: "เลือก", replace: "เปลี่ยน", headline: "หัวข้อ", supporting_text: "ข้อความเสริม", visual_style: "สไตล์ภาพ", layout: "การจัดวาง", styles: { brand: "แบรนด์", midnight: "มิดไนท์", spotlight: "สปอตไลต์", fresh: "สดใส", paper: "กระดาษ" }, layouts: { statement: "ข้อความเด่น", center: "กึ่งกลาง", lower_third: "ด้านล่าง", editorial: "บทความ" }, text_effect: "เอฟเฟกต์ข้อความ", text_effects: { none: "นิ่ง", "soft-rise": "ลอยขึ้น", "side-reveal": "เลื่อนด้านข้าง", focus: "โฟกัส", stagger: "ทีละส่วน", highlight: "ไฮไลต์" }, text_effect_descriptions: { none: "แสดงข้อความตลอดโดยไม่มีการเคลื่อนไหว", "soft-rise": "ข้อความค่อย ๆ ลอยขึ้นอย่างนุ่มนวล", "side-reveal": "เลื่อนเข้าจากด้านข้างอย่างมั่นใจ", focus: "ขยายเข้ามาเบา ๆ เพื่อเน้นข้อความ", stagger: "แสดงหัวข้อก่อน แล้วตามด้วยรายละเอียด", highlight: "วาดเส้นเน้นก่อนแสดงข้อความ" }, effect: "เอฟเฟกต์สื่อ", effects: { natural: "ธรรมชาติ", studio: "สตูดิโอ", cinematic: "ซีนีมาติก", sunlit: "แสงอุ่น", vibrant: "สีสด", mono: "ขาวดำ" }, effect_descriptions: { natural: "ภาพต้นฉบับ ไม่เติมเอฟเฟกต์", studio: "คมสะอาด ดูมืออาชีพ", cinematic: "คอนทราสต์ลึก ค่อย ๆ ซูม", sunlit: "โทนอุ่น เลื่อนอย่างนุ่มนวล", vibrant: "สีสันชัด เคลื่อนขึ้นเล็กน้อย", mono: "ขาวดำคลาสสิก" }, effect_hint: "แต่ละพรีเซ็ตปรับโทนและการเคลื่อนไหวพร้อมกัน กดเล่นเพื่อดูการเคลื่อนไหว", duration: "ระยะเวลา", fit: "การจัดภาพ", contain: "แสดงครบ", cover: "เต็มกรอบ", focal_point: "จุดโฟกัส", horizontal: "แนวนอน", vertical: "แนวตั้ง", focal_point_help: "เลือกส่วนที่ต้องคงอยู่ในภาพเมื่อสื่อแสดงเต็มกรอบ", poster_frame: "ภาพหน้าปก", poster_auto: "อัตโนมัติ", poster_choose_frame: "เลือกเฟรม", poster_at: "เฟรมที่", transition: "การเปลี่ยนฉาก", crossfade: "ค่อย ๆ เปลี่ยน", none: "ไม่มี",
            finished_video: "วิดีโอสำเร็จรูป", upload_finished_video: "อัปโหลดรีลที่ทำเสร็จแล้ว", upload_limits: "MP4 หรือ MOV · สูงสุด 500 MB และ 3 นาที", choose_video: "เลือกวิดีโอ", video_too_large: "กรุณาเลือกวิดีโอที่เล็กกว่า 500 MB", video_too_long: "กรุณาเลือกวิดีโอที่ยาวไม่เกิน 3 นาที",
            global_audio: "เสียงทั้งหมด", clip_audio: "เสียงจากคลิป", optional_track: "เพลงหรือเสียงบรรยายเพิ่มเติม", choose_audio: "เลือกไฟล์เสียง", reel_details: "รายละเอียดรีล", title: "ชื่อ", caption: "คำบรรยาย", tags: "แท็ก", add_tag: "เพิ่มแท็ก", subtitles_accessibility: "คำบรรยายและการเข้าถึง", subtitle_help: "หากรีลมีเสียงพูด ให้เพิ่มไฟล์ SRT หรือ VTT คำบรรยายจะอยู่เหนือพื้นที่ปลอดภัยของมือถือ", choose_subtitles: "เลือกไฟล์คำบรรยาย",
            audience: "ผู้ชม", all_employees: "พนักงานทุกคน", selected_groups: "กลุ่มที่เลือก", notification: "การแจ้งเตือน", push: "การแจ้งเตือนแบบพุช", push_notice: "จะส่งการแจ้งเตือนแบบพุช", push_notice_help: "ผู้ชมจะได้รับแจ้งเมื่อรีลเผยแพร่", publish_when: "เวลาที่เผยแพร่", now: "ตอนนี้", schedule: "ตั้งเวลา", pick_date: "เลือกวันที่และเวลา", save_close: "บันทึกและปิด", publish_reel: "เผยแพร่รีล", schedule_reel: "ตั้งเวลารีล",
            draft: "ฉบับร่าง", saving: "กำลังบันทึก…", draft_saved: "บันทึกฉบับร่างแล้ว", save_failed: "บันทึกไม่สำเร็จ", retry: "ลองอีกครั้ง", save_changes: "บันทึกการเปลี่ยนแปลงไหม", close_prompt: "บันทึกรีลนี้เป็นฉบับร่างหรือทิ้งการแก้ไข", discard: "ทิ้ง", fix_before_publish: "แก้ไขรายการต่อไปนี้ก่อนเผยแพร่:", template_applied: "ใช้เทมเพลตแล้ว ทุกอย่างแก้ไขได้", published_success: "รีลเผยแพร่แล้ว", scheduled_success: "ตั้งเวลารีลแล้ว", publish_failed: "เผยแพร่รีลไม่สำเร็จ กรุณาลองใหม่", unpublished: "ยกเลิกเผยแพร่",
            filter_reels: "กรองรีล", filters: { all: "ทั้งหมด", draft: "ฉบับร่าง", rendering: "กำลังประมวลผล", scheduled: "ตั้งเวลาแล้ว", published: "เผยแพร่แล้ว", failed: "ต้องตรวจสอบ", archived: "เก็บถาวร" }, search_reels: "ค้นหารีลหรือ #แท็ก", no_reels: "ยังไม่มีรีล", no_reels_help: "สร้างอัปเดตบริษัท ต้อนรับเพื่อนร่วมทีมใหม่ หรืออัปโหลดวิดีโอที่ทำเสร็จแล้ว", create_first: "สร้างรีลแรก", untitled_reel: "รีลที่ยังไม่มีชื่อ", no_caption: "ยังไม่มีคำบรรยาย", reel_actions: "การทำงานของรีล", retry_render: "ประมวลผลอีกครั้ง", cancel_render: "ยกเลิกการประมวลผล", cancel_render_prompt: "หยุดเตรียมรีลนี้หรือไม่ ฉบับร่างและสื่อที่อัปโหลดจะยังคงอยู่", cancel_schedule: "ยกเลิกเวลา", unpublish: "ยกเลิกเผยแพร่", unpublish_reel: "ยกเลิกเผยแพร่รีล", unpublish_prompt: "นำรีลนี้ออกจาก Town Hall หรือไม่ ประวัติการมีส่วนร่วมจะยังคงอยู่ และคุณแก้ไขหรือเผยแพร่อีกครั้งได้", archive: "เก็บถาวร", archive_reel: "เก็บรีลถาวร", archive_prompt: "ย้ายรีลนี้ไปยังรายการเก็บถาวรหรือไม่ หากกำลังเผยแพร่ รีลจะถูกนำออกจาก Town Hall แต่ประวัติการมีส่วนร่วมจะยังอยู่", archived_help: "รีลนี้ถูกเก็บถาวรและซ่อนจากรายการที่ใช้งานอยู่ ประวัติการมีส่วนร่วมยังดูได้", restore: "กู้คืน", view_engagement: "ดูการมีส่วนร่วม", refresh_metrics: "รีเฟรชตัวชี้วัด", metrics_failed: "รีเฟรชตัวชี้วัดการมีส่วนร่วมไม่สำเร็จ", scheduled_for: "กำหนดเผยแพร่", render_failed_help: "เตรียมรีลไม่สำเร็จ ฉบับร่างและสื่อของคุณยังปลอดภัย", rendering_help: "กำลังเตรียมวิดีโอมือถือ คุณออกจากหน้านี้ได้", select_reel: "เลือกรีล", select_reel_help: "เลือกรีลเพื่อดูตัวอย่างและจัดการการเผยแพร่", updated: "อัปเดต", not_set: "ยังไม่ได้ตั้ง", performance: "ผลลัพธ์", engagement_summary: "สรุปการมีส่วนร่วม", mobile_activity: "กิจกรรมบนมือถือ", views: "การดู", completions: "ดูจบ", reactions: "รีแอ็กชัน", completion_rate: "อัตราดูจบ", finish_publish: "ตรวจสอบและเผยแพร่", review_schedule: "ตรวจสอบเวลา", duplicate_reel: "ทำสำเนารีล",
            delete_reel: "ลบรีล", delete_prompt: "ลบรีลและสื่อฉบับร่างนี้หรือไม่ การดำเนินการนี้ย้อนกลับไม่ได้", deleted: "ลบรีลแล้ว", load_failed: "โหลดรีลไม่สำเร็จ กรุณาลองใหม่", action_failed: "อัปเดตรีลไม่สำเร็จ กรุณาลองใหม่", actions: { duplicate: "ทำสำเนารีลแล้ว", retry: "ส่งประมวลผลอีกครั้งแล้ว", cancel_render: "ยกเลิกการประมวลผลแล้ว", cancel_schedule: "ยกเลิกเวลาแล้ว", unpublish: "ยกเลิกเผยแพร่รีลแล้ว", archive: "เก็บรีลถาวรแล้ว", restore: "กู้คืนรีลแล้ว" },
            errors: { title_required: "เพิ่มชื่อรีล", caption_required: "เพิ่มคำบรรยายสั้น ๆ เพื่อให้เข้าใจได้แม้ไม่มีเสียง", title_too_long: "ชื่อต้องไม่เกิน 80 ตัวอักษร", caption_too_long: "คำบรรยายต้องไม่เกิน 280 ตัวอักษร", upload_required: "อัปโหลดวิดีโอที่ทำเสร็จแล้ว", scenes_required: "เพิ่มอย่างน้อยหนึ่งฉาก", too_many_scenes: "รีลมีได้สูงสุด 10 ฉาก", too_long: "รีลที่สร้างเองยาวได้สูงสุด 90 วินาที", scene_media_required: "เพิ่มรูปหรือวิดีโอที่ขาดในฉาก {scenes} หรือเปลี่ยนเป็นฉากข้อความ" },
            starter_prompt: "การใช้เทมเพลตอื่นจะแทนที่ฉากปัจจุบันของคุณ ดำเนินการต่อไหม", apply_starter: "ใช้เทมเพลต", video_unsupported: "อ่านไฟล์วิดีโอนี้ไม่ได้ กรุณาเลือกไฟล์ MP4 หรือ MOV",
            motion_effects: "การเคลื่อนไหวและเอฟเฟกต์", soundtrack: "เพลงประกอบ", your_audio: "เสียงของคุณ", music_hint: "เพลงประกอบจะถูกผสมเมื่อเตรียมวิดีโอสำหรับมือถือ",
            tracks: { none: "ไม่มีเพลง", uplift: "สดใส", calm: "ผ่อนคลาย", energy: "พลังงานสูง", warm: "อบอุ่น", focus: "มินิมอล" },
            track_descriptions: { none: "เฉพาะเสียงพูดและเสียงคลิป", uplift: "สว่างและมองโลกในแง่ดี", calm: "นุ่มนวลและสม่ำเสมอ", energy: "เร็วและหนักแน่น", warm: "เป็นกันเองและอบอุ่น", focus: "เรียบง่ายและทันสมัย" },
            show_branding: "แบรนด์บริษัท", show_branding_help: "แสดงโลโก้และชื่อบริษัทบนรีล"
        },
        Session_Type: "ประเภท",
        Live: "ถ่ายทอดสด",
        Video: "วิดีโอ",
        Mission_Entries: "รายการภารกิจ",
        Mission: "ภารกิจ",
        add_mission: "เพิ่มภารกิจ",
        Order: "ลำดับ",
        Mission_Name_and: "ชื่อและคำอธิบายภารกิจ",
        Entries: "รายการ",
        Winner: "ผู้ชนะ",
        Status: "สถานะ",
        Week: "สัปดาห์",
        entries: "รายการ",
        Live: "กำลังดำเนินการ",
        Completed: "เสร็จสิ้น",
        Unskip_Mission: "ยกเลิกการข้ามภารกิจ",
        Skip_Mission: "ข้ามภารกิจ",
        Edit: "แก้ไข",
        Delete: "ลบ",
        Upcoming: "กำลังจะมาถึง",
        View_Details: "ดูรายละเอียด",
        Preview_on_Mobile: "ดูตัวอย่างบนมือถือ",
        New_Mission: "ภารกิจใหม่",
        Exntry_XP: "XP ต่อรายการ",
        PLAY: "เล่น",
        VOTE: "โหวต",
        Name_of_Mission: "ชื่อภารกิจ",
        Please_input_Name: "กรุณากรอกชื่อ",
        Name_of_your_Mission: "ชื่อภารกิจของคุณ (เช่น ถ่ายเซลฟี่กลุ่มที่ดีที่สุด)",
        Name_of_your_Mission_th: "ชื่อภารกิจของคุณ (ภาษาไทย)",
        Description: "คำอธิบาย",
        A_sentence_or_two: "หนึ่งหรือสองประโยคเกี่ยวกับหัวข้อนี้",
        Please_input_Description: "กรุณากรอกคำอธิบาย",
        Please_input_Session_Minimum: "กรุณากรอกจำนวนขั้นต่ำของเซสชัน",
        A_sentence_or_two_th: "หนึ่งหรือสองประโยคอธิบายรายละเอียดภารกิจ (ภาษาไทย)",
        Mission_Type: "ประเภทภารกิจ",
        Please_input_Mission_Type: "กรุณาเลือกประเภทภารกิจ",
        Entry_Bonus_XP: "โบนัสต่อรายการ (XP)",
        Please_input_Entry_Bonus: "กรุณากรอกโบนัสต่อรายการ",
        Please_input_Order: "กรุณากรอกลำดับ",
        Select: "เลือก",
        Please_input_Status: "กรุณาเลือกสถานะ",
        CREATE_MISSION: "สร้างภารกิจ",
        SAVE_MISSION: "สร้างภารกิจ",
        HAPPILY_HOUSES: "HAPPILY HOUSES",
        THIS_WEEK: "สัปดาห์นี้",
        This_Week: "สัปดาห์นี้",
        This_Month: "เดือนนี้",
        Last_Week: "สัปดาห์ที่แล้ว",
        Last_Month: "เดือนที่แล้ว",
        All_time: "ทั้งหมด",
        Level: "เลเวล",
        total_members: "สมาชิกทั้งหมด",
        House_XP: "XP ของ House",
        XP: "XP",
        person: "คน",
        Distance: "ระยะทาง",
        km: "กม.",
        km_per_person: "กม. / คน",
        participation: "การเข้าร่วม",
        university: "Happily University",
        A_count_of_how_many_learning: "จำนวนการมีปฏิสัมพันธ์ด้านการเรียนรู้และกิจกรรมที่เกิดขึ้นจากเซสชันของ Happily University",
        Learning_and_Activity: "ปฏิสัมพันธ์ด้านการเรียนรู้และกิจกรรม",
        See_more: "ดูเพิ่มเติม",
        town_hall: "Town Hall",
        A_count_of_how_many_comments: "จำนวนคอมเมนต์และการตอบกลับที่เริ่มต้นผ่านหัวข้อและโพลใน Town Hall",
        Knowledge_Sharing_Interactions: "ปฏิสัมพันธ์ด้านการแบ่งปันความรู้",
        running_track: "ลู่วิ่ง",
        A_count_of_distance_traveled: "ระยะทางสะสมจากการเดินและวิ่งบนลู่วิ่ง รวมถึงผลของ Boosters",
        km_Distance_Traveled: "กม. ระยะทางสะสม",
        BATTLE_STADIUM: "BATTLE STADIUM",
        A_count_of_how_many_entries: "จำนวนรายการที่ส่งเข้าภารกิจรายสัปดาห์ใน Battle Stadium",
        House_of: "House of",
        members: "สมาชิก",
        making_up: "คิดเป็น",
        of_Happily_Village: "ของ Happily Village",
        Distance_Traveled: "ระยะทางสะสม",
        Running_Track_Leaderboard: "ลีดเดอร์บอร์ดลู่วิ่ง",
        Today: "วันนี้",
        Rank: "อันดับ",
        Name: "ชื่อ",
        results_from: "ผลลัพธ์จาก",
        results: "ผลลัพธ์",
        This_week: "สัปดาห์นี้",
        No_Active_Boosters: "ไม่มี Boosters ที่ใช้งานอยู่",
        This_month: "เดือนนี้",
        Quick_ranges: "Quick ranges",
        Specific_month: "Specific month",
        Export_this_view: "Export this view",
        Export_complete: "Export complete.",
        months_short: {
          jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr",
          may: "May", jun: "Jun", jul: "Jul", aug: "Aug",
          sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
        },
        Town_Hall_Topics: "หัวข้อ Town Hall, โพล และเช็กลิสต์กลุ่ม",
        Create: "สร้าง",
        New_Topic: "หัวข้อใหม่",
        New_Poll: "โพลใหม่",
        New_Checklist: "เช็กลิสต์ใหม่",
        Creator: "ผู้สร้าง",
        Type: "ประเภท",
        View: "ดู",
        Views: "การเข้าชม",
        Engagement: "การมีส่วนร่วม",
        Date_and_Time: "วันที่และเวลา",
        Duplicate: "ทำสำเนา",
        comment: "คอมเมนต์",
        comments: "คอมเมนต์",
        votes: "โหวต",
        By: "โดย",
        Topic_Creator: "ผู้สร้างหัวข้อ",
        Share_with: "แชร์กับ",
        Huddle_selection_is: "การเลือก Huddle สามารถใช้งานได้เฉพาะในแอปมือถือเท่านั้น",
        Coming_soon_to: "เร็ว ๆ นี้บนคอนโซล My Happily",
        Team_or_Name: "ทีมหรือชื่อผู้รับ",
        Title_of_Topic: "ชื่อหัวข้อ",
        Title_of_Poll: "ชื่อโพล",
        Short_but_descriptive: "สั้นแต่สื่อความหมาย",
        A_sentence_or_two_poll: "หนึ่งหรือสองประโยคเกี่ยวกับโพลนี้",
        Item_label: "ชื่อรายการ",
        Comments_enabled: "เปิดใช้งานคอมเมนต์",
        UPLOAD_MEDIA: "อัปโหลดสื่อ",
        Save_Changes: "บันทึก",
        CREATE_TOPIC: "สร้างหัวข้อ",
        by: "โดย",
        Summary: "สรุป",
        items: "รายการ",
        You_are_completed: "คุณทำเสร็จแล้ว",
        Weekly_reminders_to: "เปิดการแจ้งเตือนรายสัปดาห์ให้อัปเดตความคืบหน้าแล้ว",
        Group_Checklist_Creator: "ผู้สร้างเช็กลิสต์กลุ่ม",
        Select_Creator: "เลือกผู้สร้าง",
        Title_of_Checklist: "ชื่อเช็กลิสต์",
        Please_input_title: "กรุณากรอกชื่อ",
        Checklist_Item: "รายการในเช็กลิสต์",
        Description_of_Checklist: "Description",
        Checklist_item_type: "Item type",
        Item_type_simple: "Simple",
        Item_type_acknowledge: "Acknowledge",
        Item_type_link: "Link",
        Item_required: "Required",
        Acknowledge_what: "What should they acknowledge?",
        Link_placeholder: "https://...",
        Due_date: "Due date (optional)",
        Remind_7_days_before: "Remind 7 days before",
        Remind_1_day_before: "Remind 1 day before",
        Tags: "Tags",
        Add_tag: "Add a tag",
        ADD_OPTION: "เพิ่มตัวเลือก",
        Show_respondents_in_results: "แสดงผู้ตอบในผลลัพธ์",
        Weekly_Reminders_off: "ปิดการแจ้งเตือนรายสัปดาห์",
        Every_week_on: "ทุกสัปดาห์วัน",
        at: "เวลา",
        if_checklist_is: "หากเช็กลิสต์ยังไม่เสร็จ ส่งการแจ้งเตือน",
        CREATE_CHECKLIST: "สร้างเช็กลิสต์",
        CREATE_POLL: "สร้างโพล",
        Poll_Creator: "ผู้สร้างโพล",
        Poll_Title: "ชื่อโพล",
        Option: "ตัวเลือก",
        Option_label: "ชื่อตัวเลือก",
        Search: "ค้นหา",
        learning_and_activity_interactions: "ปฏิสัมพันธ์ด้านการเรียนรู้และกิจกรรม",
        University_Sessions: "เซสชัน Happily University",
        add_session: "เพิ่มเซสชัน",
        campaigns: "แคมเปญ",
        Create_Campaign: "สร้างแคมเปญ",
        Campaign_Title: "ชื่อแคมเปญ",
        Icon: "ไอคอน",
        Theme: "ธีม",
        Input_Type: "ประเภทข้อมูล",
        Timing: "ช่วงเวลา",
        Goal: "เป้าหมาย",
        Reward: "รางวัล",
        Entry_Cost: "ค่าเข้าร่วม",
        Daily: "รายวัน",
        Weekly: "รายสัปดาห์",
        Instant_Coins: "Coins ทันที",
        Charged_Coins_On_Completion: "หัก Coins เมื่อทำเสร็จ",
        Prize_Pool_Split_At_End: "เงินรางวัลรวม (แบ่งเมื่อจบ)",
        Individual_Goal: "เป้าหมายส่วนบุคคล",
        Group_Goal: "เป้าหมายกลุ่ม",
        Start_Date: "วันที่เริ่มต้น",
        End_Date: "วันที่สิ้นสุด",
        Participants: "ผู้เข้าร่วม",
        All: "ทั้งหมด",
        Sign_ups: "การลงทะเบียน",
        name: "ชื่อ",
        Topic: "หัวข้อ",
        Price: "ราคา",
        coins: "Coins",
        Free: "ฟรี",
        Led_by: "นำโดย",
        SIGN_UPS: "การลงทะเบียน",
        spots_available: "ที่นั่งคงเหลือ",
        PRICE: "ราคา",
        Coming_soon_to_the: "เร็ว ๆ นี้บนคอนโซล My Happily",
        Name_of_Session: "ชื่อเซสชัน",
        Short_but_descriptive_eg: "สั้นแต่สื่อความหมาย (เช่น Excel Analysis 101)",
        A_sentence_or_two_about: "หนึ่งหรือสองประโยคเกี่ยวกับเซสชันนี้",
        When: "เมื่อไร",
        Please_input_Date: "กรุณากรอกวันที่และเวลา",
        Duration_minutes: "ระยะเวลา (นาที)",
        How_long: "นานเท่าไร?",
        Please_input_Duration: "กรุณากรอกระยะเวลา",
        Location: "สถานที่",
        Please_input_Location: "กรุณากรอกสถานที่",
        Session_Limit: "จำนวนที่นั่งของเซสชัน",
        Where: "ที่ไหน",
        How_many: "จำนวนเท่าไร?",
        Please_input_Session_Limit: "กรุณากรอกจำนวนที่นั่ง",
        Price_coins: "ราคา (Coins)",
        Please_input_rice: "กรุณากรอกราคา",
        How_much: "เท่าไร?",
        Add_to_Topic: "เพิ่มไปยังหัวข้อ",
        Comment_Permissions: "สิทธิ์ในการคอมเมนต์",
        CREATE_SESSION: "สร้างเซสชัน",
        Created_by: "สร้างโดย",
        sign_ups_of: "ลงทะเบียนจาก",
        available_spots: "ที่นั่งคงเหลือ",
        No_one_sign_up: "ยังไม่มีผู้ลงทะเบียน",
        campaign_form: {
            preview_notice: "ฟีเจอร์อาจเปลี่ยนแปลงก่อนเปิดตัวอย่างเป็นทางการ",
            content_language: "ภาษาเนื้อหา",
            translation_mode_title: "แสดงเฉพาะช่องที่แปลได้ด้านล่าง",
            translation_mode_hint: "สลับเป็นภาษาอังกฤษเพื่อแก้ไขการตั้งค่าแคมเปญทั้งหมด",
            use_english_empty: "ใช้ภาษาอังกฤษสำหรับช่องที่ว่าง",
            use_english: "ใช้ภาษาอังกฤษ",
            live_lock_title: "การแก้ไขแคมเปญที่กำลังใช้งานมีข้อจำกัด",
            live_lock_body: "คุณยังอัปเดตช่องแสดงผล เช่น หมวดหมู่ หัวข้อ คำอธิบาย ไอคอน ธีม และสิทธิ์การแสดงความคิดเห็นได้ แต่การตั้งเวลา เป้าหมาย รางวัล กลุ่มเป้าหมาย การเข้าร่วม และเนื้อหากิจกรรมจะถูกล็อกหลังแคมเปญเริ่ม",
            translatable_content: "เนื้อหาที่แปลได้",
            campaign_overview: "ภาพรวมแคมเปญ",
            category: "หมวดหมู่",
            category_placeholder: "เช่น ความรู้ผลิตภัณฑ์ สุขภาพ",
            activity_type: "ประเภทกิจกรรม",
            activity_type_placeholder: "เลือกประเภทกิจกรรม",
            title: "หัวข้อ",
            title_placeholder: "ใส่หัวข้อหรือคำถามของแคมเปญ",
            description: "คำอธิบาย",
            description_placeholder: "อธิบายว่าแคมเปญนี้เกี่ยวกับอะไรและผู้เข้าร่วมต้องทำอะไร...",
            description_hint: "คำอธิบายนี้จะแสดงให้ผู้เข้าร่วมเห็นเมื่อเข้าร่วมแคมเปญ",
            translation_required: "ต้องระบุคำแปล",
            validation_category: "กรุณาระบุหมวดหมู่แคมเปญ",
            validation_title: "กรุณาระบุหัวข้อแคมเปญ",
            validation_icon: "กรุณาเลือกไอคอน",
            color_theme: "ธีมสี",
            activity_settings: "การตั้งค่ากิจกรรม",
            locked_after_start: "ถูกล็อกหลังแคมเปญเริ่ม",
            success_answer: "คำตอบที่ถือว่าสำเร็จ",
            yes_is_correct: "ใช่ คือคำตอบที่ถูกต้อง",
            no_is_correct: "ไม่ คือคำตอบที่ถูกต้อง",
            input_settings: "การตั้งค่าการกรอก",
            allow_decimals: "อนุญาตค่าทศนิยม",
            allow_decimals_hint: "เปิดใช้งานสำหรับน้ำหนัก ระยะทาง หรือตัวชี้วัดที่ต้องการความละเอียด (เช่น 1.5, 0.8)",
            tracking_mode: "โหมดการติดตาม",
            incremental: "สะสมต่อครั้ง",
            incremental_hint: "แต่ละรายการเป็นอิสระต่อกัน (เช่น \"ลดน้ำหนัก 1.5 ปอนด์สัปดาห์นี้\")",
            cumulative: "สะสมรวม",
            cumulative_hint: "แต่ละรายการเป็นยอดรวมตั้งแต่เริ่มแคมเปญ (เช่น \"ลดน้ำหนักรวม 5 ปอนด์\")",
            campaign_duration: "ระยะเวลาแคมเปญ",
            duration_locked: "เวลาเริ่มและสิ้นสุดถูกล็อกหลังแคมเปญเริ่ม",
            select_frequency: "เลือกความถี่",
            day_of_week: "วันในสัปดาห์",
            select_day: "เลือกวัน",
            select_start_date: "เลือกวันที่เริ่ม",
            number_of_days: "จำนวนวัน",
            number_of_weeks: "จำนวนสัปดาห์",
            ends: "สิ้นสุด",
            unit_translation: "คำแปลหน่วย",
            unit_of_measurement: "หน่วยวัด",
            unit_placeholder: "เช่น ชิ้น ก้าว นาที",
            unit_hint: "หน่วยนี้จะแสดงกับเป้าหมายทั้งหมด (เช่น \"10 ชิ้น\", \"1000 ก้าว\")",
            goals: "เป้าหมาย",
            goals_locked: "การตั้งค่าเป้าหมายถูกล็อกหลังแคมเปญเริ่ม",
            limit: "ขีดจำกัด",
            required: "จำเป็น",
            optional: "ไม่บังคับ",
            target: "เป้าหมาย",
            max_allowed: "สูงสุดที่อนุญาต",
            max_total: "ยอดรวมสูงสุด",
            target_total: "ยอดรวมเป้าหมาย",
            max_combined: "ยอดรวมทีมสูงสุด",
            target_combined: "ยอดรวมทีมเป้าหมาย",
            individual_overall_goal: "เป้าหมายรวมรายบุคคล",
            individual_overall_limit: "ขีดจำกัดรวมรายบุคคล",
            group_overall_goal: "เป้าหมายรวมกลุ่ม",
            group_overall_limit: "ขีดจำกัดรวมกลุ่ม",
            recommended: "แนะนำ",
            weeks: "สัปดาห์",
            days: "วัน",
            yesno_desc_daily: "ผู้เข้าร่วมจะสำเร็จเมื่อตอบถูกต้องในแต่ละวัน",
            yesno_desc_weekly: "ผู้เข้าร่วมจะสำเร็จเมื่อตอบถูกต้องในแต่ละสัปดาห์",
            reward_locked: "กลไกรางวัลถูกล็อกหลังแคมเปญเริ่มเพื่อป้องกันการจ่ายรางวัล",
            earn_per_item: "ได้รับรางวัลต่อรายการที่ทำสำเร็จเมื่อถึงเป้าหมายรายวัน",
            earn_on_daily_goal: "ได้รับรางวัลเมื่อถึงเป้าหมายรายวันเท่านั้น",
            charged_coins: "Coins แบบเรียกเก็บ",
            prize_pool: "กองรางวัล",
            prize_pool_description: "ค่าเข้าร่วม + Coins แบบเรียกเก็บจะรวมเป็นกอง แบ่งเท่า ๆ กันให้ผู้ชนะ",
            access_participation: "การเข้าถึงและการเข้าร่วม",
            access_locked: "การตั้งค่ากลุ่มเป้าหมายและการเข้าร่วมถูกล็อกหลังแคมเปญเริ่ม",
            audience: "กลุ่มเป้าหมาย",
            select_commenter: "เลือกผู้ที่แสดงความคิดเห็นได้",
            who_can_comment: "ผู้ที่แสดงความคิดเห็นได้",
            coins_to_join: "Coins ที่ใช้เข้าร่วม",
            entry_limit: "ขีดจำกัดการเข้าร่วม",
            no_limit: "ไม่จำกัด",
            set_participant_limit: "กำหนดจำนวนผู้เข้าร่วม",
            checklist_items: "รายการเช็กลิสต์",
            add_checklist_hint: "เพิ่มรายการให้ผู้เข้าร่วมทำเครื่องหมาย",
            translate_checklist_hint: "แปลรายการเช็กลิสต์แต่ละรายการ",
            enter_checklist_item: "ใส่รายการเช็กลิสต์",
            add_first_item: "เพิ่มรายการแรก",
            add_another_item: "เพิ่มรายการใหม่",
            no_checklist_to_translate: "ไม่มีรายการให้แปล กรุณาเพิ่มรายการเป็นภาษาอังกฤษก่อน",
            quiz_questions: "คำถามแบบทดสอบ",
            translate_quiz_hint: "แปลคำถามและตัวเลือกคำตอบแต่ละข้อ",
            question: "คำถาม",
            remove: "นำออก",
            enter_question: "ใส่คำถามของคุณ",
            no_quiz_to_translate: "ไม่มีคำถามให้แปล กรุณาเพิ่มคำถามเป็นภาษาอังกฤษก่อน",
            add_question: "เพิ่มคำถาม",
            add_first_question: "เพิ่มคำถามแรก",
            update_campaign: "บันทึกการเปลี่ยนแปลง",
            create_campaign: "สร้างแคมเปญ",
            launch: "เปิดใช้งาน",
            launch_now: "เปิดใช้งานทันที",
            launch_now_sub: "เริ่มเมื่อบันทึก",
            schedule_later: "กำหนดเวลาภายหลัง",
            schedule_later_sub: "เลือกวันและเวลา",
            launch_datetime: "วันและเวลาเปิดใช้งาน",
            pick_datetime: "เลือกวันและเวลา",
            scheduled_must_be_future: "เวลาที่กำหนดต้องเป็นอนาคต",
            launch_locked: "ไม่สามารถเปลี่ยนเวลาเปิดใช้งานหลังจากแคมเปญเริ่มแล้ว",
            launch_campaign: "เปิดใช้งานแคมเปญ",
            schedule_campaign: "กำหนดเวลาแคมเปญ",
        },
        Actions: "การดำเนินการ",
        Topic_actions: "การดำเนินการหัวข้อ",
        Session_actions: "การดำเนินการเซสชัน",
        No_topics_or_polls: "ไม่มีหัวข้อหรือโพล",
        No_results_found: "ไม่พบผลลัพธ์...",
        No_sessions: "ไม่มีเซสชัน",
        No_session_found: "ไม่พบเซสชัน...",
        Caption: "คำบรรยาย",
        Download_Results: "ดาวน์โหลดผลลัพธ์",
        Be_the_first_to_comment: "เป็นคนแรกที่แสดงความคิดเห็นในเธรดนี้",
        Reply: "ตอบกลับ",
        Likes: "ถูกใจ",
        Reply_here: "ตอบกลับที่นี่...",
        Comment_here: "แสดงความคิดเห็นที่นี่...",
        Sessions_tab: "เซสชัน",
        Campaigns_tab: "แคมเปญ",
        Session_Minimum: "ขั้นต่ำต่อเซสชัน",
        Session_Maximum: "ขั้นสูงต่อเซสชัน",
        one_coin: "1 Coin",
        no_signups_yet: "ยังไม่มีผู้สมัคร",
        signups_empty_hint: "ผู้ใช้จะปรากฏที่นี่เมื่อสมัครเข้าร่วมแคมเปญนี้",
        signed_up_count: "สมัครแล้ว",
        signed_up_badge: "สมัครแล้ว",
        signed_up_label: "สมัครแล้ว",
        no_participants_yet: "ยังไม่มีผู้เข้าร่วม",
        participants_empty_hint: "ผู้เข้าร่วมจะปรากฏที่นี่เมื่อเข้าร่วมแคมเปญ",
        achieved_goal: "บรรลุเป้าหมาย",
        Achieved_Goal: "บรรลุเป้าหมาย",
        coins_awarded: "Coins ที่มอบให้",
        starts_tomorrow: "เริ่มพรุ่งนี้",
        starts_in: "เริ่มใน",
        days: "วัน",
        days_left: "วันที่เหลือ",
        last_day: "วันสุดท้าย",
        no_data_yet: "ยังไม่มีข้อมูล",
        summary_empty_hint: "สรุปจะปรากฏเมื่อมีผู้เข้าร่วมแคมเปญ",
        investment_and_impact: "การลงทุนและผลกระทบ",
        per_active_participant: "ต่อผู้เข้าร่วมที่ใช้งาน",
        via: "ผ่าน",
        daily_goals_lower: "เป้าหมายรายวัน",
        entry_fees_collected: "ค่าสมัครที่เก็บได้",
        free_entry: "เข้าร่วมฟรี",
        coins_distributed: "Coins ที่แจกจ่าย",
        coins_committed: "Coins ที่ผูกไว้",
        in_escrow: "อยู่ในบัญชีพักเงิน",
        returned_to_system: "ส่งคืนระบบ",
        didnt_meet_goal: "ไม่บรรลุเป้าหมาย",
        daily_goals_hit: "เป้าหมายรายวันที่ทำได้",
        total_actions: "การกระทำทั้งหมด",
        limited_data_notice: "ข้อมูลจำกัด การคาดการณ์จะแม่นยำขึ้นเมื่อแคมเปญดำเนินไป",
        projected_total_investment: "การลงทุนรวมที่คาดการณ์:",
        Active: "ใช้งาน",
        achievement_rate_lower: "อัตราการบรรลุเป้าหมาย",
        reward_breakdown: "รายละเอียดรางวัล",
        coins_per_daily_goal: "Coins ต่อเป้าหมายรายวัน",
        daily_target: "เป้าหมายรายวัน",
        daily_goals_achieved: "เป้าหมายรายวันที่บรรลุ",
        total_actions_recorded: "การกระทำที่บันทึกทั้งหมด",
        total_coins_invested: "Coins ที่ลงทุนทั้งหมด",
        total_coins_committed: "Coins ที่ผูกไว้ทั้งหมด",
        earned_by: "ได้รับโดย",
        who_met_goal: "ที่บรรลุเป้าหมาย",
        returned_from: "ส่งคืนจาก",
        who_didnt: "ที่ไม่บรรลุ",
        in_escrow_until_end: "อยู่ในบัญชีพักเงินจนจบแคมเปญ",
        total_pool_size: "ขนาดรางวัลรวม",
        current_winners: "ผู้ชนะปัจจุบัน",
        prize_per_winner: "รางวัลต่อผู้ชนะ",
        no_winners_yet: "ยังไม่มีผู้ชนะ",
        campaign_results: "ผลแคมเปญ",
        progress: "ความคืบหน้า",
        achievement_rate: "อัตราการบรรลุเป้าหมาย",
        avg_score: "คะแนนเฉลี่ย",
        participation_rate: "อัตราการเข้าร่วม",
        drop_off: "อัตราผู้เลิก",
        view_leaderboard: "ดูลีดเดอร์บอร์ด",
        Close: "ปิด",
        coins_committed_to_behavior: "Coins ที่ผูกไว้เพื่อเปลี่ยนพฤติกรรม",
        coins_earned_through_behavior: "Coins ที่ได้จากการเปลี่ยนพฤติกรรม",
        type_quiz: "ควิซ",
        type_count: "นับจำนวน",
        type_auto_sync: "ซิงก์อัตโนมัติ",
        type_steps: "ก้าว",
        type_sleep: "การนอน",
        type_screen_time: "เวลาหน้าจอ",
        type_exercise: "ออกกำลังกาย",
        type_distance: "ระยะทาง",
        type_multiple_selection: "เลือกหลายข้อ",
        type_yes_no: "ใช่/ไม่",
        status_active: "ใช้งาน",
        status_upcoming: "กำลังจะมา",
        status_scheduled: "กำหนดเวลาแล้ว",
        status_ended: "สิ้นสุดแล้ว",
        status_archived: "เก็บถาวร",
        challenge_default: "ชาเลนจ์",
        preview_day: "วันที่",
        preview_streak: "สตรีค",
        preview_select_answer: "เลือกคำตอบที่ถูกต้อง",
        preview_todays_activity: "จำนวนกิจกรรมวันนี้",
        preview_daily_goal: "เป้าหมายรายวัน",
        preview_keep_going: "สู้ต่อไป! ทำได้ดีมาก!",
        preview_submit_count: "ส่งจำนวน",
        preview_goal_label: "เป้าหมาย",
        preview_last_sync: "ซิงก์ล่าสุด: 2 นาทีที่แล้ว",
        preview_manually_edit: "แก้ไขด้วยตนเอง",
        preview_continue: "ดำเนินการต่อ",
        preview_morning_routine: "ทำกิจวัตรตอนเช้าให้ครบ",
        preview_done_for_now: "เสร็จแล้วสำหรับตอนนี้",
        preview_yesno_question: "คุณทำเป้าหมายวันนี้ครบหรือยัง?",
        preview_charging: "กำลังสะสม",
        early_preview: "พรีวิวรุ่นแรก",
        early_preview_hint: "คุณเข้าถึงก่อนใคร! ฟีเจอร์นี้จะเปิดให้ทุกคนเร็วๆ นี้",
        no_campaigns: "ไม่มีแคมเปญ",
        period: "ช่วงเวลา",
        campaign_actions: "การดำเนินการแคมเปญ",
        archive: "เก็บถาวร",
        delete_disabled_hint: "ลบ (เฉพาะที่ไม่มีผู้เข้าร่วม)",
    },
    insights: {
        HAPPINESS_VS_RISK_RATE: "ความสุข เทียบกับ ความเสี่ยง และกิจกรรม",
        Duration: "ช่วงเวลา",
        Last_30_days: "30 วันล่าสุด",
        Last_60_days: "60 วันล่าสุด",
        Last_13_weeks: "13 สัปดาห์ล่าสุด",
        Last_26_weeks: "26 สัปดาห์ล่าสุด",
        Last_52_weeks: "52 สัปดาห์ล่าสุด",
        Last_24_months: "24 เดือนล่าสุด",
        HAPPINESS: "ความสุข",
        RISK: "ความเสี่ยง",
        ACTIVE_USERS: "ผู้ใช้งาน",
        COHORT_STATUS: "สถานะกลุ่ม",
        Sort_by: "เรียงตาม",
        Cohorts: "กลุ่มคอฮอร์ต",
        Satisfaction: "ความพึงพอใจ",
        Co_Alignment: "Co. Alignment",
        Score_Distribution: "การกระจายคะแนน",
        Engagement_and_Impact: "การมีส่วนร่วมและอิมแพ็ก",
        Highlighting_key_engagement_metrics: "แสดงตัวชี้วัดการมีส่วนร่วมที่สำคัญ เช่น คะแนน eNPS, NPS, Wellness, Culture และ Employee Resilience Index รวมถึงภาพรวมอิมแพ็กของแต่ละบุคคลและกิจกรรมของผู้จัดการ.",
        high_impact: "อิมแพ็กสูง",
        contributors: "ผู้มีส่วนร่วม",
        People: "บุคลากร",
        managers: "ผู้จัดการ",
        non_active: "ไม่ได้ใช้งาน",
        active: "ใช้งาน",
        Managers: "ผู้จัดการ",
        eNPS: "eNPS",
        Report_Card: "ใบรายงานผล",
        Promoters: "Promoters",
        Passives: "Passives",
        Detractors: "Detractors",
        Excellent: "ยอดเยี่ยม",
        Fair: "พอใช้",
        Critical: "วิกฤต",
        Poor: "ต่ำ",
        point_same_benchmark: "จุดเท่ากับเกณฑ์มาตรฐาน",
        points: "จุด",
        above_benchmark: "สูงกว่าเกณฑ์มาตรฐาน",
        below_benchmark: "ต่ำกว่าเกณฑ์มาตรฐาน",
        Happiness_Rate: "คะแนนความสุข",
        Risk_Rate: "อัตราความเสี่ยง",
        View_by_team: "ดูแยกตามทีม",
        Open_ended_Feedback: "ฟีดแบ็กแบบปลายเปิด",
        How_would_you_like: "คุณอยากให้",
        manager_to_be_more: "ผู้จัดการของคุณมีส่วนร่วมมากขึ้นอย่างไร?",
        Activity: "กิจกรรม",
        Adoption: "การใช้งาน",
        Members: "สมาชิก",
        Monthly_Active_Users: "ผู้ใช้งานรายเดือน",
        Weekly_Active_Users: "ผู้ใช้งานรายสัปดาห์",
        ACTIVITY_THIS_WEEK: "กิจกรรมสัปดาห์นี้",
        WEEKLY_ACTIVE_USERS: "ผู้ใช้งานรายสัปดาห์",
        HAPPINESS_RATE: "คะแนนความสุข",
        RISK_RATE: "อัตราความเสี่ยง",
        FEEDBACK_RESPONSE_RATE: "อัตราการตอบฟีดแบ็ก",
        By_Job_Tenure: "ตามอายุงาน",
        Engagement_Trend: "แนวโน้มการมีส่วนร่วม",
        Engagement_Trend_Desc: "การเปลี่ยนแปลงของการมีส่วนร่วมในช่วง 3 เดือน วัดโดย Dynamic Engagement Behavioral Index (DEBI) สำหรับภาพรวมบริษัท ผู้จัดการ และผู้นำ.",
        A_breakdown_of_your: "รายละเอียดกิจกรรมและอัตราต่าง ๆ แยกตามอายุงาน หรือระยะเวลาที่พนักงานทำงานกับบริษัท",
        Real_time_Activity: "กิจกรรมแบบเรียลไทม์",
        PAST_12_HOURS: "12 ชั่วโมงที่ผ่านมา",
        BY_HOUR: "รายชั่วโมง",
        TOP_ACTIVITIES: "กิจกรรมยอดนิยม",
        TIMES: "ครั้ง",
        Interactions_caption: "การโต้ตอบ",
        No_activity_yet: "ไม่มีกิจกรรมในช่วง 12 ชั่วโมงที่ผ่านมา",
        Key_Teams_and_Cohorts: "ทีมและกลุ่มที่สำคัญ",
        Highlighting_key_groups: "แสดงกลุ่มสำคัญที่มีคะแนนสูงหรือต่ำในด้านความสุข ความเสี่ยง อัตราการให้ฟีดแบ็ก หรือกิจกรรม",
        TONE_ANALYZER: "Tone Analyzer",
        BETA: "BETA",
        TALKING_POINTS: "ประเด็นสนทนา",
        show_timeline: "แสดงไทม์ไลน์",
        Success_Score: "คะแนนความสำเร็จ",
        Dimension: "มิติ",
        Status_no_teams: "สุขภาพทีม",
        teams_below_healthy: "ทีมที่ต่ำกว่าระดับดี",
        no_team_data: "ยังไม่มีข้อมูลทีม",
        Critical_teams: "ทีมที่วิกฤติ",
        No_critical_teams: "ไม่มีทีมที่วิกฤติในมิตินี้",
        Loading_teams: "กำลังโหลดทีม…",
        responses: "การตอบกลับ",
        Positive: "เชิงบวก",
        Neutral: "เป็นกลาง",
        Close: "ปิด",
        ENGAGEMENT_BREAKDOWN_BY_TEAM: "การมีส่วนร่วมแยกตามมิติ",
        Most_teams_red: "ทีมที่วิกฤติมากที่สุด",
        Biggest_drop: "ลดลงมากที่สุด",
        Lowest_Success_Score: "คะแนนความสำเร็จต่ำสุด",
        Highest_Success_Score: "คะแนนความสำเร็จสูงสุด",
        DIMENSION_DETAILS: "รายละเอียดมิติ",
        Lowest_Happiness: "ความสุขต่ำสุด",
        Highest_Happiness: "ความสุขสูงสุด",
        Lowest_Risk: "ความเสี่ยงต่ำสุด",
        Highest_Risk: "ความเสี่ยงสูงสุด",
        ACTIVITY_OVERVIEW: "ภาพรวมกิจกรรม",
        ACTIVE: "ตอบสนองดี",
        PASSIVE: "ปานกลาง",
        INACTIVE: "น้อยมาก",
        DAILY_INSIGHTS_OPENED: "การเปิดอินไซต์รายวัน",
        WEEKLY_INSIGHTS_OPENED: "การเปิดอินไซต์รายสัปดาห์",
        FEEDBACK_REPLY_RATE: "อัตราการตอบกลับฟีดแบ็ก",
        BY_MANAGER: "การโต้ตอบของผู้จัดการ",
        Managers_activity_in: "กิจกรรมของผู้จัดการในการเปิดอินไซต์และตอบกลับฟีดแบ็กของทีมในช่วง 30 วันที่ผ่านมา",
        Insights_Open_Rate: "อัตราการเปิดอินไซต์",
        Team_Size: "ขนาดทีม",
        Feedback_Reply_Rate: "อัตราการตอบกลับฟีดแบ็ก",
        All_Activity_Types: "กิจกรรมทุกประเภท",
        Active: "ตอบสนองดี",
        Passive: "ปานกลาง",
        Inactive: "น้อยมาก",
        Insights_Opened: "อินไซต์ที่เปิด",
        Feedback: "ฟีดแบ็ก",
        Relational: "ความสัมพันธ์",
        Team_Challenges: "ความท้าทายของทีม",
        Date: "วันที่",
        Score: "คะแนน",
        Challenge: "ความท้าทาย",
        Status: "สถานะ",
        Profile: "โปรไฟล์",
        Daily: "รายวัน",
        Weekly: "รายสัปดาห์",
        Reply: "ตอบกลับ",
        Super: "Super",
        Talent_Type: "ประเภทบุคลากร",
        Excels_At: "โดดเด่นด้าน",
        Network_Type: "ประเภทเครือข่าย",
        Critical_Areas: "พื้นที่วิกฤต",
        critical_area: "พื้นที่วิกฤต",
        results_from: "ผลลัพธ์จาก",
        results: "ผลลัพธ์",
        Lower: "ต่ำกว่า",
        Upper: "สูงกว่า",
        SAVE: "บันทึก",
        CANCEL: "ยกเลิก",
        Select_all: "เลือกทั้งหมด",
        Clear: "ล้าง",
        Talent_Types_are_tagged: "ประเภทบุคลากรจะถูกแท็กตามระดับความมีประสิทธิภาพในเครือข่าย (การทำงานร่วมกันและการมีส่วนร่วมของแต่ละบุคคลต่อองค์กร) และการประเมินจากผู้จัดการ ได้แก่ Low, Rising, High, หรือ Super",
        Cancel: "ยกเลิก",
        Okay: "ตกลง",
        Power_Skills: "Power Skills",
        OUTER_NETWORK: "เครือข่ายภายนอก",
        NETWORK_EFFECTIVENESS: "ประสิทธิภาพเครือข่าย",
        PEOPLE_INTELLIGENCE: "People Intelligence",
        INDIVIDUAL_PERFORMANCE: "ผลงานรายบุคคล",
        INNER_NETWORK: "เครือข่ายภายใน",
        Sort_By: "เรียงตาม",
        Highest_Risk_Level: "ระดับความเสี่ยงสูงสุด",
        Lowest_Risk_Level: "ระดับความเสี่ยงต่ำสุด",
        Highest_Star_Count: "จำนวนดาวสูงสุด",
        Lowest_Star_Count: "จำนวนดาวต่ำสุด",
        Highest_Impact_Rating: "คะแนนอิมแพ็กสูงสุด",
        Lowest_Impact_Rating: "คะแนนอิมแพ็กต่ำสุด",
        Super_Network_Effectiveness: "⬆️ Super Network Effectiveness ",
        Rising_Network_Effectiveness: "⏫ Rising Network Effectiveness",
        High_Network_Effectiveness: "🔼 High Network Effectiveness",
        Low_Network_Effectiveness: "🔽 Low Network Effectiveness",
        Super_Individual_Rating: "⬆️ Super Individual Rating",
        Rising_Individual_Rating: "⏫ Rising Individual Rating",
        High_Individual_Rating: "🔼 High Individual Rating",
        Low_Individual_Rating: "🔽 Low Individual Rating",
        No_Description: "ไม่มีคำอธิบาย",
        Problem_Areas: "พื้นที่ที่มีปัญหา",
        People_Impact_and: "อิมแพ็กของบุคลากรและแนวโน้มความเสี่ยง",
        RISK_LEVELS: "ระดับความเสี่ยง",
        AVG_IMPACT_RATING: "คะแนนอิมแพ็กเฉลี่ย",
        view_list: "ดูรายการ",
        Excels_at: "โดดเด่นด้าน",
        profiles: "โปรไฟล์",
        were_tagged_by: "ถูกแท็กโดยเพื่อนร่วมงานในคุณสมบัตินี้",
        Name_Team_and: "ชื่อ, ทีม และความสุข",
        Talent_is_classified: "บุคลากรถูกจัดประเภทตามความถี่และคุณภาพของการชื่นชม",
        coins_and_gems: "(Coins และ Gems) ที่ได้รับ Coins เป็นตัววัด",
        Network: "เครือข่าย",
        Effectiveness: "ประสิทธิภาพ",
        Gems_are_a_measure: "Gems เป็นตัววัด",
        Individual_Performance: "ผลงานรายบุคคล",
        Low: "ต่ำ",
        Low_frequency: "ความถี่ต่ำ",
        Uptake: "การรับเข้า",
        A_recent_increase_in: "ความถี่เพิ่มขึ้นเมื่อเร็ว ๆ นี้",
        High: "สูง",
        High_frequency: "ความถี่สูง",
        High_frequency_and_high: "ความถี่สูงและคุณภาพสูง",
        Read_more_here: "อ่านเพิ่มเติมที่นี่",
        Impact_Rating: "คะแนนอิมแพ็ก",
        Based_on_manager_and: "อ้างอิงจากการชื่นชมจากหัวหน้าและเพื่อนร่วมงานในช่วง 6 เดือนที่ผ่านมา",
        Based_on_connections_created: "อ้างอิงจากสายสัมพันธ์ (connection) ที่สร้างขึ้นผ่านการให้ peer feedback การชื่นชม และการส่งของขวัญให้แก่กันในช่วง 6 เดือนที่ผ่านมา",
        Engagement_Group: "กลุ่มการมีส่วนร่วม",
        Based_on_the_quality_and: "อ้างอิงจากคุณภาพและความพยายามในพฤติกรรมการมีส่วนร่วมที่เกิดขึ้นในเดือนที่ผ่านมา",
        Truly_Outstanding: "Truly Outstanding",
        Truly_Outstanding_ratings: "ผลคะแนนโดดเด่นน่าจับตามองผ่านการได้รับ Peer Feedback ในช่วง 6 เดือนที่ผ่านมา",
        Medals: "เหรียญเกียรติยศ",
        Medals_received_in_the: "การได้รับเหรียญเกียรติยศในช่วง 6 เดือนที่ผ่านมา",
        Star_Performer: "Star Performer",
        Number_of_weeks_qualified: "จำนวนสัปดาห์ที่ได้เป็น Star Performer ในช่วง 6 เดือนที่ผ่านมา",
        Talent_is_classified_by: "บุคลากรถูกจัดประเภทตามจำนวนการเชื่อมต่อภายในและภายนอก",
        connections_as_determined: "(ตามที่กำหนดโดยโครงสร้างองค์กร) จาก",
        recognition_and_peer: "ข้อมูลการชื่นชมและ peer feedback",
        Low_Network: "เครือข่ายต่ำ",
        Low_inner_and_outer: "การเชื่อมต่อภายในและภายนอกต่ำ",
        High_Inner: "เครือข่ายภายในสูง",
        High_Inner_but_low: "การเชื่อมต่อภายในสูงแต่ภายนอกต่ำ",
        High_Outer: "เครือข่ายภายนอกสูง",
        Low_inner_but_high: "การเชื่อมต่อภายในต่ำแต่ภายนอกสูง",
        High_Network: "การเชื่อมต่อภายในและภายนอกสูง",
        Achievements: "ความสำเร็จ",
        Risk_Level: "ระดับความเสี่ยง",
        Talent_that_are_retention: "บุคลากรที่มีความเสี่ยงในการลาออก ตรวจพบจากความถี่",
        of_Not_Great_and: "ของคำตอบ “Not Great” และ “Unhappy” ในคำถาม “How are",
        you_feeling_today: "you feeling today?”",
        Twice_last_week: "สองครั้งในสัปดาห์ที่ผ่านมา",
        Medium: "ปานกลาง",
        More_than_twice: "มากกว่าสองครั้งในสัปดาห์ที่ผ่านมา",
        More_than_twice_last_and: "มากกว่าสองครั้งในสัปดาห์ที่ผ่านมาและสัปดาห์ก่อนหน้า",
        Highlighting_key_accomplishments: "แสดงความสำเร็จสำคัญด้านการมีส่วนร่วมและการชื่นชมจากเพื่อนร่วมงานและผู้จัดการ",
        Highly_Moderately_Somewhat_Under: "กลุ่มการมีส่วนร่วม Highly, Engaged, Somewhat, Under Engaged หรือ In-active ถูกกำหนดตามตัวชี้วัดเชิงพฤติกรรม.",
        Recognized_with_a_Leadership: "ได้รับการยอมรับด้วย Leadership Medal of Excellence.",
        Recognized_as_Truly_Outstanding: "ได้รับการยอมรับเป็น Truly Outstanding จากการโต้ตอบ Peer Feedback.",
        A_star_is_earned: "ดาวจะได้รับเมื่อมีคุณสมบัติเป็น Star Performer โดยจบอันดับใน Top 15% ของผู้ได้รับการชื่นชมในสัปดาห์นั้น ๆ.",
        A_score_that_represents: "คะแนนที่แสดงให้เห็นถึงการมีอิมแพ็กของปัจเจกบุคคลต่อองค์กร และเพื่อนร่วมงานรอบตัว โดยกำหนดจาก",
        TEAMS: "ทีม",
        COHORTS: "กลุ่มคอฮอร์ต",
        REPORT_CARD_BY_TEAM: "ใบรายงานผลแยกตามทีม",
        REPORT_CARD_BY_COHORTS: "ใบรายงานผลแยกตามกลุ่ม",
        Highest_Scores: "คะแนนสูงสุด",
        Lowest_Score: "คะแนนต่ำสุด",
        Scores_are_updated_on: "คะแนนจะถูกอัปเดตทุกไตรมาส และสามารถดูเปรียบเทียบกับคะแนนก่อนหน้าได้",
        SCORE_HISTORY: "ประวัติคะแนน",
        Max_Change: "การเปลี่ยนแปลงสูงสุด",
        Most_Recent: "ล่าสุด",
        NPS: "NPS",
        NPS_Details: "รายละเอียด NPS",
        WHO_5: "WHO-5",
        eRes: "eRes",
        Culture: "วัฒนธรรม",
        DEBI: "DEBI",
        Index: "ดัชนี",
        Alignment: "ความสอดคล้อง",
        Variance: "ความเป็นหนึ่งเดียว",
        Net_Promoter_Score_c_NPS: "Net Promoter Score ® (NPS)",
        Engagement_Score: "คะแนนการมีส่วนร่วม",
        Engagement_Score_is: "Dynamic Engagement Behavioral Index (DEBI) เป็นแนวทางแบบองค์รวมในการวัดการมีส่วนร่วมของพนักงาน ซึ่งก้าวข้ามข้อมูลที่รายงานตนเอง ไปสู่การประเมินที่อ้างอิงจากพฤติกรรมมากขึ้น.",
        Strategic_Alignment: "Strategic Alignment",
        Strategic_Alignment_is: "Strategic Alignment Index วัดระดับความเข้าใจและการปฏิบัติตามลำดับความสำคัญของทีมใน 4 มิติหลัก ได้แก่ Understanding & Clarity, Execution & Confidence, Resource & Support และ Impact & Contribution คะแนนที่สูงขึ้น (0-100) บ่งบอกถึงความสอดคล้องที่แข็งแกร่งระหว่างงานประจำวันกับวัตถุประสงค์ขององค์กร Consistency Score สะท้อนถึงความสม่ำเสมอของความเข้าใจในทีม โดยคะแนนที่สูงขึ้นแสดงถึง Strategic Alignment ที่สอดคล้องกันมากขึ้น.",
        DEBI_report_card_label: "Dynamic Engagement Behavior Index ที่วัดการมีส่วนร่วมที่แท้จริง",
        Culture_Resilience_Well: "ดัชนีวัฒนธรรม ความยืดหยุ่น และความเป็นอยู่ที่ดี",
        Net_Promotor_Score_is: "Net Promoter Score คำนวณจาก Promoters, Passives และ Detractors โดยมีค่าอยู่ระหว่าง -100 ถึง +100.",
        Net_Promoter_Net_Promoter: "Net Promoter, Net Promoter System, Net Promoter Score, NPS และอีโมติคอนที่เกี่ยวข้องกับ NPS เป็นเครื่องหมายการค้าจดทะเบียนของ Bain & Company, Inc., Fred Reichheld และ Satmetrix Systems, Inc.",
        A_collection_of_indexes: "ชุดดัชนีที่ช่วยให้เข้าใจวัฒนธรรมองค์กร ความยืดหยุ่น และความเป็นอยู่ที่ดีได้ดียิ่งขึ้น.",
        The_Culture_Index_is: "Culture Index คำนวณจากการวัดพฤติกรรมที่บ่งชี้ถึงความแข็งแกร่งของวัฒนธรรมองค์กร.",
        The_Employee_Resilience_Index: "Employee Resilience Index เป็นตัวชี้วัดความสามารถในการฟื้นตัวจากอุปสรรคและตอบสนองต่อความท้าทาย.",
        The_WHO_5_Index_from: "WHO-5 Index จากองค์การอนามัยโลก เป็นมาตรวัดความเป็นอยู่ที่ดีในระดับสากล.",
        Loyal_employees_who_are: "พนักงานที่ภักดีและภูมิใจในการทำงานร่วมกับคุณ คือทรัพย์สินที่สำคัญที่สุดในการดึงดูดคนเก่ง และช่วยให้ผ่านพ้นความท้าทายในช่วงวิกฤตได้.",
        Company_alignment_provides: "Company alignment ช่วยให้ผู้จัดการและผู้นำเข้าใจว่าบุคลากรของตนสามารถมีส่วนร่วมต่อวัตถุประสงค์ของบริษัทได้ดีเพียงใด หากมีความไม่สอดคล้อง จะเป็นการใช้ทรัพยากรไม่เต็มศักยภาพ ซึ่งเป็นอุปสรรคต่อการเติบโต การพัฒนา และการมีส่วนร่วมของพนักงานที่เกี่ยวข้อง.",
        Feedback_has_significant: "ฟีดแบ็กมีศักยภาพอย่างมากในการเป็นประโยชน์ต่อพนักงาน ทั้งในด้านผลงานของบุคคลและทีม พนักงานต้องการความเข้าใจที่ชัดเจนว่าจะพัฒนาตนเองได้อย่างไร การสื่อสารอย่างต่อเนื่องจึงเป็นสิ่งสำคัญยิ่ง",
        Recent_studies: "งานวิจัยล่าสุด",
        focus_on_how_mindset: "เน้นถึงบทบาทสำคัญของกรอบความคิด (mindset) ในการปลดล็อกการมีส่วนร่วมของพนักงาน.",
        Social_educational_and: "จิตวิทยาสังคม การศึกษา และองค์กร แสดงให้เห็นว่ากรอบความคิดเป็นทรัพยากรส่วนบุคคลที่อาจส่งผลต่อการมีส่วนร่วมของพนักงาน ผ่านความกระตือรือร้นในการพัฒนา การตีความความพยายาม การจดจ่อ การรับรู้ต่ออุปสรรค และการปฏิสัมพันธ์ระหว่างบุคคล.",
        Managers_play_an_importan: "ผู้จัดการมีบทบาทสำคัญในการบริหารและหล่อหลอมกรอบความคิดของทีม.",
        Employees_need_to_feel_that_they_are: "พนักงานจำเป็นต้องรู้สึกว่าตนเองกำลังเติบโตและเรียนรู้อยู่ตลอดเวลา ทั้งในด้านส่วนตัวและอาชีพ ผู้จัดการมีบทบาทในการเป็นโค้ช และชี้แนะโอกาสในการเรียนรู้ให้กับทีม อีกทั้งต้องทำให้โอกาสในการพัฒนาเส้นทางอาชีพชัดเจนและโปร่งใส.",
        Employees_need_to_feel_taht_their_work: "พนักงานต้องรู้สึกว่างานของตนเป็นที่รับรู้ของคนอื่น และความพยายามของพวกเขาได้รับการยอมรับอย่างสมควร การชื่นชมถือเป็น 1 ใน 5 กิจกรรมหลักที่พิสูจน์แล้วว่าเป็นตัวทำนายการมีส่วนร่วมของพนักงาน.",
        The_support_that_employees: "การสนับสนุนที่พนักงานได้รับจากเพื่อนร่วมงานมีความเชื่อมโยงอย่างมากกับความสามารถในการจัดการความเครียด (wellness).",
        Studies: "งานวิจัย",
        show_that_satisfaction_with: "แสดงให้เห็นว่าความพึงพอใจต่อเพื่อนร่วมงานมีความสัมพันธ์อย่างมีนัยสำคัญกับการมีส่วนร่วม.",
        The: "ยิ่ง",
        more_embedded_a_person: "บุคคลยึดโยงกับงานของตนมากเท่าใด",
        is_in_their_job: "ก็ยิ่งมีแนวโน้มน้อยลงที่จะลาออก หากมีความขัดแย้งหรือปัญหาระหว่างเพื่อนร่วมงานและสมาชิกในทีม ผู้จัดการและผู้นำต้องสามารถดำเนินการได้ทันที.",
        Managers_set_standards_for: "ผู้จัดการกำหนดมาตรฐานให้กับทีม และลูกทีมก็ต้องการสร้างความประทับใจ! เพื่อความสัมพันธ์ที่มีประสิทธิภาพ ผู้จัดการควรมีปฏิสัมพันธ์ที่มีคุณค่ากับลูกทีมแต่ละคนอย่างน้อยทุก ๆ 2 สัปดาห์ พนักงานที่มีการประชุมกับผู้จัดการอย่างสม่ำเสมอ มีแนวโน้มที่จะรู้สึกมีส่วนร่วมและเติบโตในงานมากกว่าถึงสามเท่า.",
        Apart_from_pay_challenging: "นอกเหนือจากค่าตอบแทน งานที่ท้าทายถือเป็นแรงจูงใจสำคัญของพนักงาน พนักงานต้องรู้สึกว่ากำลังใช้ชีวิตในเส้นทางอาชีพที่เติมเต็ม และทำงานที่มีระดับความท้าทายที่เหมาะสม ตามทฤษฎี Flow - The Psychology of Optimal Experience ของ Mihaly Csikszentmihalyi.",
        Employees_need_work_life: "พนักงานต้องการสมดุลระหว่างงานและชีวิตเพื่อรักษาประสิทธิภาพและการมีส่วนร่วมในงาน งานวิจัยชี้ให้เห็นว่าความเครียดและภาวะหมดไฟในที่ทำงานมีผลต่อการมีส่วนร่วมของพนักงาน โดยพิจารณาทั้งสุขภาพกายและสุขภาพจิต.",
        Before: "ก่อน",
        After: "หลัง",
        Compare: "เปรียบเทียบ",
        There_is_no_happiness: "ยังไม่มีข้อมูลความสุข ความเสี่ยง หรือกิจกรรมที่จะแสดง กรุณากลับมาตรวจสอบอีกครั้งในวันพรุ่งนี้!",
        SPOTLIGHT: "Spotlight",
        Most_Engaged: "มีส่วนร่วมมากที่สุด",
        Teams_with_highest_engagement: "ทีมที่มีคะแนนการมีส่วนร่วมสูงสุด คะแนนนี้เป็นค่ารวมจาก 9 มิติของการมีส่วนร่วม.",
        No_most_engaged_at: "ยังไม่มีทีมที่มีส่วนร่วมมากที่สุดในขณะนี้",
        Retention_Risks: "ความเสี่ยงในการรักษาพนักงาน",
        Teams_with_highest_retention: "ทีมที่มีคะแนนความเสี่ยงในการรักษาพนักงานสูงสุด คะแนนนี้เป็นค่ารวมจากมิติที่เกี่ยวข้องกับการลาออก.",
        No_retention_risks_at: "ยังไม่มีความเสี่ยงในการรักษาพนักงานในขณะนี้",
        Teams_that_show_the_most: "ทีมที่มีพัฒนาการดีที่สุดในช่วง 2 สัปดาห์ที่ผ่านมา คะแนนนี้แสดงถึงการเพิ่มขึ้นของคะแนนการมีส่วนร่วม.",
        No_most_improved_at: "ยังไม่มีทีมที่พัฒนามากที่สุดในขณะนี้",
        Most_Critical: "วิกฤตมากที่สุด",
        Teams_that_are_most_critical: "ทีมที่อยู่ในภาวะวิกฤตมากที่สุดในช่วง 2 สัปดาห์ที่ผ่านมา คะแนนนี้แสดงถึงการลดลงของคะแนนการมีส่วนร่วม.",
        Most_Improved: "พัฒนามากที่สุด",
        No_most_critical: "ยังไม่มีทีมที่วิกฤตในขณะนี้",
        TEAM_STATUS: "สถานะทีม",
        Team: "ทีม",
        Happi_Rate: "คะแนนความสุข",
        Wellness: "Wellness",
        Rel_Manager: "สัมพันธ์กับหัวหน้า",
        Recognition: "การชื่นชม",
        Ambassadorship: "ความเป็นแอมบาสเดอร์",
        Rel_Colleagues: "สัมพันธ์เพื่อนร่วมงาน",
        Personal_Growth: "การเติบโตส่วนบุคคล",
        Strategic_Alignment_Details: "รายละเอียด Strategic Alignment",
        Strategic_Alignment_Breakdown: "รายละเอียดย่อย Strategic Alignment",
        Strongly_Agree: "เห็นด้วยอย่างยิ่ง",
        Agree: "เห็นด้วย",
        Disagree: "ไม่เห็นด้วย",
        Strongly_Disagree: "ไม่เห็นด้วยอย่างยิ่ง",
        WHO_5_Breakdown: "รายละเอียด WHO-5",
        WHO_5_Details: "รายละเอียด WHO-5",
        Culture_Index_Details: "รายละเอียด Culture Index",
        Culture_Index_Breakdown: "รายละเอียดย่อย Culture Index",
        Scoped: "เฉพาะกลุ่ม",
        Global: "ทั้งหมด",
        Current_Filtered_List: "รายการที่กรองปัจจุบัน",
        Entire_Company: "ทั้งบริษัท",
        people_impact: "ผลกระทบของบุคลากร",
        workplace_culture_impact: "ผลกระทบต่อวัฒนธรรมองค์กร",
        people_impact_tooltip_desc: "อิงตามการวิเคราะห์พฤติกรรมและการมีส่วนร่วมของแต่ละบุคคลต่อวัฒนธรรมองค์กร",
        high_impact_label: "ผลกระทบสูง",
        high_impact_desc: "ขับเคลื่อนวัฒนธรรมเชิงบวก ชื่นชมผู้อื่น และมีส่วนร่วมสม่ำเสมอ",
        moderate_impact_label: "ผลกระทบปานกลาง",
        moderate_impact_desc: "ผู้สนับสนุนที่มั่นคง มีส่วนร่วมสม่ำเสมอ และสนับสนุนผู้อื่น",
        low_impact_label: "ผลกระทบต่ำ",
        low_impact_desc: "การมีส่วนร่วมจำกัด อาจต้องการการสนับสนุนเพิ่มเติม",
        people_impact_target: "เป้าหมาย: ≥70% รวมผลกระทบสูงและปานกลางเพื่อประสิทธิภาพสูงสุด",
        manager_activity: "กิจกรรมของผู้จัดการ",
        manager_feedback_responsiveness: "การตอบสนองต่อฟีดแบ็กของผู้จัดการ",
        manager_activity_tooltip_desc: "อิงตามอัตราการตอบกลับฟีดแบ็กของทีม",
        manager_responsive_label: "ตอบสนองดี",
        manager_responsive_desc: "ตอบกลับฟีดแบ็กของทีมอย่างสม่ำเสมอเพื่อรักษาการมีส่วนร่วม",
        manager_moderate_label: "ปานกลาง",
        manager_moderate_desc: "ตอบกลับเป็นประจำแต่อาจพลาดฟีดแบ็กบางส่วน",
        manager_minimal_label: "น้อย",
        manager_minimal_desc: "ตอบกลับไม่บ่อย อาจต้องการการโค้ชเรื่องการให้ฟีดแบ็ก",
        manager_activity_target: "เป้าหมาย: ≥80% อัตราตอบกลับของผู้จัดการเพื่อประสิทธิภาพสูงสุด",
        focus_and_goal_alignment: "Focus & Goal Alignment",
        focus_alignment_tooltip: "ติดตามว่าจุดโฟกัสของทีมสอดคล้องกับเป้าหมายองค์กรเพียงใด",
        focus_coverage_tooltip_bullet: "• Focus Coverage: ภาพรวมแบบเรียลไทม์",
        goal_alignment_tooltip_bullet: "• Goal Alignment: 90 วันล่าสุด",
        learning_section_title: "การเรียนรู้",
        learning_tooltip: "ติดตามความคืบหน้าการเรียนรู้และพัฒนาทักษะของทีม",
        learning_progress_tooltip_bullet: "• Learning Progress: 6 เดือนที่ผ่านมา",
        focus_coverage: "Focus Coverage",
        focus_areas: "Focus Areas",
        last_week: "สัปดาห์ที่แล้ว",
        people_with_focus_connector: "จาก",
        people_with_focus_suffix: "คน มีจุดโฟกัส",
        goal_alignment: "Goal Alignment",
        goals_label: "เป้าหมาย",
        aligned_suffix: "สอดคล้อง",
        unaligned_suffix: "ไม่สอดคล้อง",
        unknown_label: "ไม่ทราบ",
        unknown_suffix: "รายการที่ยังไม่ทราบความสอดคล้อง",
        setup_goals_empty_state: "ตั้งค่าเป้าหมายเพื่อติดตามความสอดคล้อง",
        alignment_not_available: "ข้อมูลโฟกัสยังไม่เพียงพอสำหรับประเมินความสอดคล้อง",
        learning_progress: "Learning Progress",
        learning_journeys: "Learning Journeys",
        members_upskilling: "สมาชิกกำลังพัฒนาทักษะ",
        completed_label: "เสร็จสิ้น",
        tenure_empty_state: "ข้อมูล tenure ของคุณจะแสดงหลังวันแรกที่คุณเริ่มงานกับ Happily เพื่อให้เราแสดงรูปแบบทีมที่มีความหมาย",
        overall_label: "รวม",
        leadership_label: "ผู้นำ",
        pending_data: "รอข้อมูล",
        communication_health: "สุขภาพการสื่อสาร",
        show_all_teams_prefix: "ดูทั้งหมด",
        show_all_teams_suffix: "ทีม",
        show_less: "ดูน้อยลง",
        Select: "เลือก",
        All_Cohorts: "ทุกกลุ่ม",
        All_Teams: "ทุกทีม",
        Search_cohorts_placeholder: "ค้นหากลุ่ม...",
        No_data_for_time_period: "ไม่มีข้อมูลให้แสดงในช่วงเวลาที่เลือก",
        Happiness_Rate_tooltip: "อัตราการตอบ \"มีความสุขมาก\" หรือ \"ค่อนข้างดี\" ต่อคำถามเช็กอินประจำวัน \"วันนี้คุณรู้สึกอย่างไร?\"",
        Risk_Rate_tooltip: "อัตราการตอบ \"ไม่ค่อยดี\" หรือ \"แย่มาก\" ต่อคำถามเช็กอินประจำวัน \"วันนี้คุณรู้สึกอย่างไร?\"",
        Avg_Impact: "Impact เฉลี่ย",
        Avg_Impact_tooltip: "คะแนน Impact เฉลี่ยของสมาชิกในกลุ่ม คำนวณจากผลรวมคะแนนรายบุคคลหารด้วยจำนวนสมาชิก",
        DEBI_Score: "DEBI Score",
        DEBI_Score_tooltip: "Dynamic Engagement Behavioral Index (DEBI) ของแต่ละกลุ่มคำนวณจากหลายปัจจัย: ความถี่ในการเช็กอินและการตอบของสมาชิก คุณภาพของฟีดแบ็ก การชื่นชมเพื่อนร่วมงาน และความสอดคล้องกับค่านิยมหลักขององค์กร",
        ENGAGEMENT_SCORE: "ENGAGEMENT SCORE",
        DEBI_by_role: "Dynamic Engagement Behavioral Index แยกตามบทบาท",
        Manager: "ผู้จัดการ",
        Leader: "ผู้นำ",
        Six_mo_Retention: "Retention 6 เดือน",
        Six_mo_Retention_tooltip: "อัตรา Retention 6 เดือน คิดเป็นเปอร์เซ็นต์ของสมาชิกในกลุ่มที่ยังเป็นพนักงาน สูตร: ขนาดกลุ่มปัจจุบัน ÷ (ขนาดกลุ่มปัจจุบัน + พนักงานที่ถูกเก็บถาวรใน 6 เดือนที่ผ่านมา) × 100",
        ARCHIVED_MEMBERS_HISTORY: "ประวัติสมาชิกที่เก็บถาวร",
        Number_of_archived_by_month: "จำนวนสมาชิกที่เก็บถาวรรายเดือน",
        Terminated: "เลิกจ้าง",
        Resigned: "ลาออก",
        Preparing_cohort_data: "กำลังเตรียมข้อมูลกลุ่ม กรุณารอสักครู่...",
        Organizational_Network: "เครือข่ายองค์กร",
        Organizational_Network_desc: "แสดงความเชื่อมโยงที่เกิดจากการชื่นชมระหว่างเพื่อน/ผู้จัดการ การแลกเปลี่ยนฟีดแบ็ก และปฏิสัมพันธ์ที่มีความหมายใน 6 เดือนที่ผ่านมา",
        Focusing: "กำลังโฟกัส",
        Nodes: "Nodes",
        Attribute: "คุณลักษณะ",
        Links: "การเชื่อมโยง",
        Relationships: "ความสัมพันธ์",
        Relationship_Attributes: "คุณลักษณะความสัมพันธ์",
        Relationship_Power: "พลังความสัมพันธ์",
        Filter_by_power_rating: "กรองตามกลุ่มการจัดระดับพลัง",
        Signature: "Signature",
        Filter_by_signature: "กรองตามค่า Signature ที่ถูกแท็กในความสัมพันธ์",
        Connections: "การเชื่อมโยง",
        Engagement: "การมีส่วนร่วม",
        Signatures: "Signatures",
        Name_Team: "ชื่อ, ทีม",
        No_signatures_available: "ไม่มี Signature",
        All_Signatures: "Signature ทั้งหมด",
        more_suffix: "เพิ่มเติม",
        Focus_in_relationship_map: "โฟกัสในแผนที่ความสัมพันธ์",
        Total: "รวม",
        Manager_Responsiveness: "การตอบสนองของผู้จัดการ",
        Manager_Activity_Details: "รายละเอียดกิจกรรมผู้จัดการ",
        Managers_play_central_role: "ผู้จัดการมีบทบาทสำคัญในการเชื่อมโยงเป้าหมายเข้ากับการลงมือทำและผลลัพธ์",
        Performance_Metrics: "เมตริกประสิทธิภาพ",
        Feedback_Rate: "อัตราฟีดแบ็ก",
        Reply_Rate: "อัตราการตอบกลับ",
        Performance_Boosts_On_Track: "Performance Boosts ตามแผน",
        Insights_and_Nudges: "อินไซต์และการกระตุ้น",
        Daily_Insights: "อินไซต์รายวัน",
        Weekly_Insights: "อินไซต์รายสัปดาห์",
        Coaching_Suggestions: "คำแนะนำการโค้ช",
        Coaching_Suggestions_desc: "รายการสิ่งที่ต้องทำที่สร้างโดย AI ถูกส่งให้ผู้จัดการในรายงานรายสัปดาห์ในช่วง 4 สัปดาห์ที่ผ่านมา คำแนะนำเฉพาะบุคคลเหล่านี้ช่วยให้ผู้จัดการปรับปรุงการมีส่วนร่วมและประสิทธิภาพของทีม",
        Individual_Manager_Analysis: "การวิเคราะห์ผู้จัดการรายบุคคล",
        Manager_Scorecard: "สกอร์การ์ดผู้จัดการ",
        Manager_Scorecard_desc: "สกอร์การ์ดนี้แสดงภาพรวมของกิจกรรมและเมตริกประสิทธิภาพหลักของผู้จัดการ โดยเน้นการมีปฏิสัมพันธ์กับลูกทีม เพื่อให้เข้าใจว่าผู้จัดการเป็นแบบอย่างของพฤติกรรมสำคัญ ผลักดันประสิทธิภาพ และสร้างการมีส่วนร่วมของทีมได้ดีเพียงใด",
        Manager_Scorecard_definition: "Manager effectiveness, 0–100. A weighted score of the leadership behaviors and team outcomes your company values most.",
        Scorecard_Settings: "Scorecard settings",
        Performance_reviews_enabled: "Performance reviews enabled",
        Category_Weights: "Category weights",
        Advanced_weights: "Advanced: weight individual metrics",
        Show_composite_as: "Show composite as",
        Save_settings: "Save settings",
        Reset: "Reset",
        Performance_Group: "กลุ่มประสิทธิภาพ",
        All_Performance_Groups: "กลุ่มประสิทธิภาพทั้งหมด",
        Elite_Managers: "ผู้จัดการระดับยอดเยี่ยม",
        High_Performers: "ผู้ทำผลงานสูง",
        Rising_Stars: "ดาวรุ่ง",
        Feedback_Champions: "แชมป์ฟีดแบ็ก",
        At_Risk_Managers: "ผู้จัดการกลุ่มเสี่ยง",
        Ghost_Managers: "ผู้จัดการที่ไม่มีกิจกรรม",
        Conv_Initiated: "การสนทนา",
        Conv_Initiated_tooltip: "เปอร์เซ็นต์ของการสนทนาที่ผู้จัดการรายนี้เริ่มต้นกับผู้จัดการของตนเอง แสดงถึงการสื่อสารเชิงรุกกับหัวหน้า",
        Peer_Feedback: "ฟีดแบ็กจากเพื่อนร่วมงาน",
        Peer_Feedback_tooltip: "จำนวนครั้งที่ผู้จัดการขอฟีดแบ็กจากเพื่อนร่วมงานเพื่อพัฒนาตนเอง แสดงถึงความมุ่งมั่นในการพัฒนาตนเอง",
        Boosts_On_Track: "Boosts ตามแผน",
        Boosts_On_Track_tooltip: "เปอร์เซ็นต์ของ performance boosts ที่เสร็จสมบูรณ์หรือรอดำเนินการและยังไม่เกินกำหนด",
        Goals_Progress: "ความคืบหน้าเป้าหมาย",
        Goals_Progress_tooltip: "ความคืบหน้าโดยรวมของลูกทีม ประเมินจากการรีวิวประสิทธิภาพ",
        Culture_Contr: "การสร้างวัฒนธรรม",
        Culture_Contr_tooltip: "ลูกทีมมีส่วนร่วมในการสร้างวัฒนธรรมองค์กรได้ดีเพียงใด ประเมินจากการรีวิวประสิทธิภาพ",
        Reply_Rate_tooltip: "เปอร์เซ็นต์ของฟีดแบ็กจากทีมที่ผู้จัดการตอบกลับในช่วง 30 วันที่ผ่านมา",
        Reply_Rate_short: "อัตราการตอบกลับ",
        Reply_Rate_line1: "อัตรา",
        Reply_Rate_line2: "การตอบกลับ",
        Insights_Opened_tooltip: "เปอร์เซ็นต์ของอินไซต์ผู้จัดการที่เปิดจากอีเมล หมายเหตุ: อาจไม่แม่นยำหากการติดตามอีเมลถูกบล็อก",
        Insights_Opened_short: "อินไซต์ที่เปิด",
        Team_DEBI: "DEBI ทีม",
        Team_DEBI_line1: "DEBI",
        Team_DEBI_line2: "ทีม",
        DEBI_Score_col_tooltip: "Dynamic Engagement Behavior Index ของทีมผู้จัดการรายนี้ โดยอ้างอิงจากลูกทีมโดยตรง นี่คือดัชนีพฤติกรรม DEBI จึงอาจแตกต่างจากคะแนน Engagement แบบรวมใน People Intelligence",
        Action_Items_line1: "รายการ",
        Action_Items_line2: "ที่ต้องทำ",
        Manager_Coaching_Interactions: "การโค้ชของผู้จัดการ",
        Manager_Classification_Settings: "ตั้งค่าการจัดกลุ่มผู้จัดการ",
        View_detailed_breakdown: "ดูรายละเอียด",
        Proactivity_Rating_Breakdown: "รายละเอียดคะแนน Proactivity",
        Psychological_Safety_Breakdown: "รายละเอียด Psychological Safety",
        People_Risk_Recovery_Trends: "แนวโน้มความเสี่ยงและการฟื้นตัวของพนักงาน",
        Click_any_week_for_details: "คลิกที่สัปดาห์ใดก็ได้เพื่อดูรายละเอียด",
        Recovery: "การฟื้นตัว",
        AVG: "เฉลี่ย",
        Percentile: "เปอร์เซ็นไทล์",
        Name_and_Team: "ชื่อและทีม",
        Health_Indicator: "ตัวชี้วัดสุขภาพ",
        Contributions: "การมีส่วนร่วม",
        Talent_and_Network: "ทาเลนต์และเครือข่าย",
        Organizational_Positioning: "ตำแหน่งในองค์กร",
        Medals_and_Peer_Ratings: "เหรียญและคะแนนจากเพื่อนร่วมงาน",
        Skills_and_Values: "ทักษะและค่านิยม",
        Overall_Score: "คะแนนรวม",
        col_name_team_tooltip: "ชื่อพนักงาน แผนก และสถานะความเป็นอยู่ปัจจุบันจากฟีดแบ็กล่าสุด",
        col_contributions_tooltip: "การชื่นชมจากเพื่อนร่วมงานและการประเมินผลโดยผู้จัดการ",
        col_talent_network_tooltip: "การจัดกลุ่มทาเลนต์ของพนักงานและการเชื่อมโยงเครือข่ายในองค์กร",
        col_achievements_tooltip: "การชื่นชมที่ได้รับผ่านเหรียญและคะแนนฟีดแบ็กจากเพื่อนร่วมงานในระดับสูง",
        col_alignment_tooltip: "การประเมินความสามารถในทักษะหลักของพนักงานและความสอดคล้องกับค่านิยมขององค์กร",
        col_impact_rating_tooltip: "คะแนนประสิทธิภาพโดยรวมพร้อมตัวชี้วัดการเปลี่ยนแปลงรายสัปดาห์",
        Support: "การสนับสนุน",
        Performance: "ประสิทธิภาพ",
        Performance_subtitle: "KR หรืออัตราเจม",
        Performance_subtitle_kr: "KR · {progress}%",
        Performance_subtitle_gem: "อัตราเจม",
        Performance_dataNote_kr: "ค่าเฉลี่ยของความคืบหน้า KR และสถานะ KR สำหรับเป้าหมายที่บุคคลนี้ดูแล",
        Performance_dataNote_gem: "อัตราเจม (วัฒนธรรมและเป้าหมายได้คะแนน 3+ ทั้งคู่) ถ่วงน้ำหนักด้วยจำนวนการมีปฏิสัมพันธ์ ในช่วง 6 เดือนที่ผ่านมา",
        Happiness: "ความสุข",
        Happiness_subtitle: "เช็คอินรายวัน",
        Happiness_dataNote: "รูปแบบการตอบสนองความสุขรายวันจากการเช็คอิน สะท้อนอารมณ์ล่าสุด แยกจากความเป็นอยู่ที่ดี (Wellbeing) ซึ่งใช้ดัชนี WHO-5",
        Wellbeing: "ความเป็นอยู่ที่ดี",
        Wellbeing_subtitle: "สัญญาณรายไตรมาส",
        Wellbeing_dataNote: "สัญญาณความเป็นอยู่ที่ดีล่าสุดจากการเช็คอินรายวัน WHO-5 (เกณฑ์มาตรฐานความเป็นอยู่ที่ดี) แสดงในแผงขยายเมื่อมีข้อมูล",
        Impact_Rating_dataNote: "คะแนนรวมการมีส่วนร่วม รวมพฤติกรรมความผูกพันและผลกระทบต่อองค์กร อัปเดตรายสัปดาห์ คะแนนสูงกว่า 70 บ่งบอกถึงความผูกพันที่แข็งแกร่ง",
        Flight_Risk: "ความเสี่ยงลาออก",
        Flight_Risk_subtitle: "สัญญาณ 90 วัน",
        Flight_Risk_Low: "ต่ำ",
        Flight_Risk_Moderate: "ปานกลาง",
        Flight_Risk_High: "สูง",
        Flight_Risk_Safe: "ปลอดภัย",
        Flight_Risk_Watch: "เฝ้าระวัง",
        Flight_Risk_At_risk: "เสี่ยง",
        Engagement_subtitle: "30 วันที่ผ่านมา",
        Performance_subtitle_v2: "เป้าหมายและคำติชม",
        Peer_Trust_subtitle_v2: "ความไว้วางใจ · เครือข่าย",
        Band_Excellent: "ยอดเยี่ยม",
        Band_Good: "ดี",
        Band_Fair: "พอใช้",
        Band_Watch: "เฝ้าระวัง",
        Band_Poor: "ต่ำ",
        No_data: "ไม่มีข้อมูล",
        Performance_no_reviews: "ยังไม่มีรีวิว",
        Recognized_By: "ได้รับการชื่นชมจาก",
        Recognized_as_outstanding_by: "ได้รับการยกย่องว่าโดดเด่นโดย",
        Recognized_as_outstanding: "ได้รับการยกย่องว่าโดดเด่น",
        Peer_single: "คน",
        Past_6_mo: "6 เดือนล่าสุด",
        Past_6_months: "6 เดือนล่าสุด",
        Medals: "เหรียญรางวัล",
        Giving: "การให้",
        Receiving: "การได้รับ",
        Vs_team_median_6mo: "เทียบกับค่ามัธยฐานของทีม (6 เดือน)",
        Band_top_quartile: "25% บน",
        Band_above_median: "สูงกว่าค่าเฉลี่ย",
        Band_typical: "ปกติ",
        Band_below_typical: "ต่ำกว่าค่าเฉลี่ย",
        Truly_Outstanding: "ยอดเยี่ยมอย่างแท้จริง",
        Exceeding_Expectations: "เกินความคาดหมาย",
        Skill_band_developing: "กำลังพัฒนา",
        Skill_band_building: "กำลังสร้าง",
        Skill_band_applying: "นำไปใช้",
        Skill_band_integrated: "บูรณาการ",
        Skill_band_mastery: "เชี่ยวชาญ",
        Values_band_strong: "สอดคล้องอย่างแข็งแกร่ง",
        Values_band_aligned: "สอดคล้อง",
        Values_band_mixed: "ผสมผสาน",
        Values_band_emerging: "กำลังเกิดขึ้น",
        Values_split_given_label: "ให้",
        Values_split_received_label: "ได้รับ",
        Values_tooltip_intro: "วิเคราะห์ด้วย AI จากกิจกรรมการยอมรับของเพื่อนร่วมงาน",
        Values_tooltip_events_suffix: "กิจกรรมการยอมรับ (60 วันที่ผ่านมา)",
        Not_measured: "ยังไม่ได้วัด",
        More: "เพิ่มเติม",
        Flight_Risk_dataNote: "อิงจากรูปแบบการเช็คอินที่ไม่มีความสุขในช่วง 90 วันที่ผ่านมา ตัวเลขสูงกว่า = ความเสี่ยงต่อการขาดความผูกพันมากกว่า",
        Peer_Trust: "ความไว้วางใจจากเพื่อนร่วมงาน",
        Peer_Trust_subtitle_short: "คะแนน · เพื่อนร่วมงาน",
        Peer_Trust_dataNote: "รวมการให้ฟีดแบ็กจากเพื่อนร่วมงาน การยอมรับซึ่งกันและกัน ความลึกของเครือข่าย และคุณภาพของการได้รับการยอมรับ ในช่วง 6 เดือนที่ผ่านมา",
        Peers: "เพื่อนร่วมงาน",
        Coins: "เหรียญ",
        Gems: "อัญมณี",
        Engagement: "ความผูกพัน",
        Checkin_consistency: "ความสม่ำเสมอของการเช็คอิน",
        Giving_recognition: "การให้การยอมรับ",
        Receiving_recognition: "การได้รับการยอมรับ",
        Manager_responsiveness: "การตอบสนองของผู้จัดการ",
        No_manager_assigned: "ยังไม่ได้มอบหมายผู้จัดการ",
        Risk_reason: "เหตุผลความเสี่ยง",
        Goals: "เป้าหมาย",
        Power_Skills: "ทักษะพลัง",
        Empathy: "ความเห็นอกเห็นใจ",
        Self_Awareness: "การรู้จักตนเอง",
        Critical_Thinking: "การคิดเชิงวิพากษ์",
        Leadership: "ภาวะผู้นำ",
        Initiative: "ความริเริ่ม",
        Optimism: "การมองโลกในแง่ดี",
        Positioning_and_Achievements: "ตำแหน่ง & ความสำเร็จ",
        Engagement_and_Contributions: "ความผูกพัน & การมีส่วนร่วม",
        Context_and_Power_Skills: "บริบท & ทักษะพลัง",
        Show_details_for: "แสดงรายละเอียดของ {name}",
        col_happiness_tooltip: "รูปแบบการตอบสนองความสุขรายวันจากการเช็คอิน WHO-5 เป็นเกณฑ์มาตรฐานด้านความเป็นอยู่ที่ดีเมื่อมีข้อมูล",
        col_wellbeing_tooltip: "สัญญาณความเป็นอยู่ที่ดีล่าสุดจากการเช็คอินรายวัน WHO-5 (เกณฑ์มาตรฐานความเป็นอยู่ที่ดี) แสดงในแผงขยายเมื่อมีข้อมูล",
        col_engagement_tooltip: "คะแนนรายบุคคลอ้างอิงจาก 30 วันของเช็คอิน ฟีดแบ็ก การยอมรับ และกิจกรรมกับเพื่อนร่วมงาน\nมุมมอง DEBI อื่นอาจรวมไดนามิกความสัมพันธ์และเครือข่ายของทีม",
        col_flight_risk_tooltip: "ความเป็นไปได้ของการขาดความผูกพันตามรูปแบบการเช็คอินในช่วง 90 วันที่ผ่านมา",
        col_performance_tooltip: "ความคืบหน้า KR เมื่อมีการดูแลเป้าหมาย มิฉะนั้นเป็นอัตราเจมที่ประเมินโดยเพื่อนร่วมงาน",
        col_peer_trust_tooltip: "ความไว้วางใจที่ได้รับจากเพื่อนร่วมงาน รวมถึงความกว้างของความสัมพันธ์",
        Engagement_dataNote: "ผสมตัวชี้วัด 6 ตัวรายเดือน: เช็คอินรายวัน (30%) ฟีดแบ็กแบบเปิด (20%) กิจกรรมการยอมรับ (20%) ฟีดแบ็กจากผู้จัดการ (10%) คุณภาพการยอมรับ (10%) และฟีดแบ็กจากเพื่อนร่วมงาน (10%) อิงจากเดือนล่าสุด",
        Skills: "ทักษะ",
        Values: "ค่านิยม",
        Values_Alignment: "ความสอดคล้องกับค่านิยม",
        Talent_Group: "กลุ่มทาเลนต์",
        All_People: "พนักงานทั้งหมด",
        risk_drilldown: {
            title: "เจาะลึกความเสี่ยง",
            high: "สูง",
            med: "กลาง",
            low: "ต่ำ",
            recovered: "ฟื้นตัวแล้ว",
            recovered_lc: "ฟื้นตัว",
            no_change: "ไม่เปลี่ยนแปลง",
            selected: "ที่เลือก",
            col_name: "ชื่อ",
            col_frequency: "ความถี่",
            col_history: "ประวัติ",
            exited: "ลาออก",
            weeks_short: "/ 8 สัปดาห์",
            at_risk: "มีความเสี่ยง",
            week_of: "สัปดาห์ของ",
            recurring: "เกิดซ้ำ",
            first_time: "ครั้งแรก",
        },
        spotlight: {
            highlighting_teams: "เน้นทีมที่น่าสนใจประจำสัปดาห์ของ",
            most_engaged: "มีส่วนร่วมมากที่สุด",
            most_engaged_desc: "ทีมที่มีคะแนนการมีส่วนร่วมสูงสุด คะแนนรวมจาก 9 มิติของการมีส่วนร่วม",
            retention_risks: "ความเสี่ยงการรักษาพนักงาน",
            retention_risks_desc: "ทีมที่มีคะแนนความเสี่ยงการรักษาพนักงานสูงสุด คะแนนรวมจากมิติที่เกี่ยวข้องกับการลาออก",
            most_improved: "พัฒนามากที่สุด",
            most_improved_desc: "ทีมที่พัฒนามากที่สุดใน 2 สัปดาห์ที่ผ่านมา คะแนนแสดงการเพิ่มขึ้นของคะแนนการมีส่วนร่วม",
            most_critical: "วิกฤตที่สุด",
            most_critical_desc: "ทีมที่อยู่ในสถานะวิกฤตที่สุดใน 2 สัปดาห์ที่ผ่านมา คะแนนแสดงการลดลงของคะแนนการมีส่วนร่วม",
            team: "ทีม",
            score: "คะแนน",
        },
    },
    goals: {
        team_goals: "เป้าหมายทีม",
        goals_description: "จัดการและติดตามเป้าหมายของแต่ละทีม",
        add_goals: "เพิ่มเป้าหมาย",
        edit_goals: "แก้ไขเป้าหมาย",
        save: "บันทึก",
        cancel: "ยกเลิก",
        team_name: "ทีม",
        goals_label: "เป้าหมายทีม",
        goals_placeholder: "ระบุเป้าหมายและวัตถุประสงค์ของทีม โดยแยกแต่ละข้อเป็นบรรทัดใหม่...",
        goals_hint: "เป้าหมายเหล่านี้จะถูกนำไปใช้ในการวิเคราะห์และให้คำแนะนำแก่ผู้จัดการและทีมของพวกเขา",
        add_goals_title: "เพิ่มเป้าหมายทีม",
        edit_goals_title: "แก้ไขเป้าหมายทีม",
        no_teams: "ไม่พบทีม",
        no_goals: "ยังไม่ได้ตั้งเป้าหมาย",
        save_success: "บันทึกเป้าหมายสำเร็จ",
        save_error: "เกิดข้อผิดพลาดในการบันทึกเป้าหมาย กรุณาลองอีกครั้ง",
        kr_templates: {
            revenue_mrr_title: "เพิ่มรายได้ประจำรายเดือน",
            revenue_mrr_reasoning: "เป้าหมายที่เน้นรายได้ควรติดตามการเติบโตของรายได้เป็นผลลัพธ์ที่วัดได้",
            revenue_deals_title: "ปิดดีลใหม่ในไตรมาสนี้",
            revenue_deals_reasoning: "จำนวนดีลเป็นตัวชี้วัดนำของการเติบโตของรายได้",
            revenue_deal_size_title: "เพิ่มขนาดดีลเฉลี่ย",
            revenue_deal_size_reasoning: "ดีลที่ใหญ่ขึ้นช่วยเพิ่มรายได้โดยไม่ต้องเพิ่มความพยายามตามสัดส่วน",
            customer_nps_title: "บรรลุเป้าหมายคะแนน NPS",
            customer_nps_reasoning: "NPS วัดความพึงพอใจและความภักดีของลูกค้าโดยตรง",
            customer_churn_title: "ลดอัตราการเลิกใช้ของลูกค้า",
            customer_churn_reasoning: "อัตราการเลิกใช้ที่ต่ำลงสะท้อนประสบการณ์ลูกค้าและการรักษาลูกค้าที่ดีขึ้น",
            customer_support_title: "เพิ่มความเร็วในการแก้ไขตั๋วซัพพอร์ต",
            customer_support_reasoning: "การแก้ไขที่เร็วขึ้นส่งผลต่อความพึงพอใจของลูกค้าโดยตรง",
            hire_fill_title: "เติมตำแหน่งที่ว่าง",
            hire_fill_reasoning: "ติดตามความคืบหน้าของจำนวนพนักงานเทียบกับแผนการจ้าง",
            hire_time_title: "ลดระยะเวลาในการจ้างงาน",
            hire_time_reasoning: "การจ้างงานที่เร็วขึ้นช่วยเพิ่มความเร็วของทีมและลดต้นทุนค่าเสียโอกาส",
            hire_retention_title: "อัตราการรักษาพนักงานใหม่ 90 วัน",
            hire_retention_reasoning: "การรักษาพนักงานในช่วงต้นที่สูงสะท้อนการออนบอร์ดที่มีประสิทธิภาพและความเหมาะสมของบทบาท",
            ship_features_title: "ส่งมอบฟีเจอร์ตามแผนตรงเวลา",
            ship_features_reasoning: "จำนวนฟีเจอร์ที่ส่งมอบช่วยติดตามการทำงานตามโรดแมปผลิตภัณฑ์",
            ship_bugs_title: "ลดอัตราบั๊กที่หลุดไปโปรดักชัน",
            ship_bugs_reasoning: "อัตราบั๊กที่หลุดน้อยลงแสดงถึงคุณภาพที่ดีขึ้นก่อนเผยแพร่",
            ship_adoption_title: "บรรลุการใช้งานฟีเจอร์ใหม่ของผู้ใช้",
            ship_adoption_reasoning: "การใช้งานยืนยันว่าฟีเจอร์ที่ส่งมอบแก้ปัญหาของผู้ใช้จริง",
            engage_score_title: "เพิ่มคะแนนการมีส่วนร่วมของทีม",
            engage_score_reasoning: "คะแนนการมีส่วนร่วมสะท้อนสุขภาพโดยรวมและแรงจูงใจของทีม",
            engage_participation_title: "เพิ่มการเข้าร่วมให้ฟีดแบ็ก",
            engage_participation_reasoning: "อัตราการเข้าร่วมที่สูงขึ้นบ่งชี้ถึงความปลอดภัยทางจิตใจและการมีส่วนร่วม",
            engage_turnover_title: "ลดอัตราการลาออกโดยสมัครใจ",
            engage_turnover_reasoning: "อัตราการลาออกที่ต่ำลงสะท้อนวัฒนธรรมและความพึงพอใจของพนักงานที่ดีขึ้น",
            generic_milestones_title: "บรรลุเหตุการณ์สำคัญหลัก",
            generic_milestones_reasoning: "การติดตามเหตุการณ์สำคัญให้จุดตรวจสอบความคืบหน้าที่ชัดเจนสำหรับเป้าหมายนี้",
            generic_completion_title: "บรรลุอัตราการทำสำเร็จตามเป้าหมาย",
            generic_completion_reasoning: "เปอร์เซ็นต์การทำสำเร็จโดยรวมให้มุมมองเดียวของความคืบหน้าเป้าหมาย",
            generic_improvement_title: "ส่งมอบการปรับปรุงที่วัดผลได้",
            generic_improvement_reasoning: "การวัดผลการปรับปรุงทำให้ความคืบหน้ามองเห็นได้และสร้างแรงจูงใจ",
            unit_deals: " ดีล",
            unit_hires: " คน",
            unit_days: " วัน",
            unit_features: " ฟีเจอร์",
            unit_milestones: " เหตุการณ์",
            unit_percent_within_sla: "% ภายใน SLA",
            unit_percent_of_users: "% ของผู้ใช้",
        },
    },
    integrations: {
        API_DOCUMENTATION: "เอกสาร API",
        Reference_and_instructional: "คู่มืออ้างอิงและคำแนะนำสำหรับการใช้งาน API ที่มีอยู่",
        Go_to_API_Doc: "ไปที่เอกสาร API",
        PRODUCTION_TOKEN: "PRODUCTION TOKEN",
        This_is_your_production: "นี่คือ production token ของคุณ ควรเก็บรักษา API token อย่างปลอดภัยเช่นเดียวกับรหัสผ่าน",
        Generate_a_Token: "สร้าง Token",
        API_LOG: "API LOG",
        A_log_of_API_activity: "บันทึกกิจกรรม API ที่สร้างโดย API token ที่เชื่อมโยงกับบัญชีของคุณ ซึ่งระบุวันที่ การดำเนินการ API สถานะ และประเภทการใช้งานของธุรกรรม API",
        results_from: "ผลลัพธ์จาก",
        results: "ผลลัพธ์",
        SELECT_SYNC_METHOD: "เลือกวิธีการซิงค์",
        INTEGRATION_PARAMETERS: "พารามิเตอร์การเชื่อมต่อ",
        Webhook: "Webhook",
        Sort_by_Name: "เรียงตามชื่อ",
        Token: "Token",
        Webhook_Endpoint: "Webhook Endpoint",
        Sync_Type: "ประเภทการซิงค์",
        Staged_Syncing: "ซิงค์แบบขั้นตอน",
        Your_members_are_queued_up: "สมาชิกของคุณจะถูกจัดคิวและเตรียมพร้อมสำหรับการเพิ่มหรือปิดการใช้งาน วิธีนี้ให้โอกาสคุณตรวจสอบการเปลี่ยนแปลงด้วยตนเองก่อนที่จะดำเนินการ",
        Normal_Syncing: "ซิงค์แบบปกติ",
        Users_can_be_added: "ผู้ใช้สามารถเพิ่มเข้า Happily ได้โดยตรง และจะถูกเพิ่มหรือปิดการใช้งานโดยอัตโนมัติตามสถานะในข้อมูลที่ส่ง",
        Syncing: "กำลังซิงค์",
        All_users_who_are: "ผู้ใช้ทั้งหมดที่อยู่ใน Happily แต่ไม่อยู่ในข้อมูลที่ส่งมาจะถูกปิดการใช้งาน",
        Options: "ตัวเลือก",
        Abbreviate_Team_Name: "ย่อชื่อทีม",
        Automatically_abbreviate_long_team: "ย่อชื่อทีมที่ยาวโดยอัตโนมัติเพื่อให้รายงานและอินไซต์อ่านง่ายขึ้น",
        Enable: "เปิดใช้งาน",
        Enable_web_hook: "เปิดใช้งาน web hook",
        Any_data_that: "ข้อมูลใดๆ ที่คุณส่งไปยัง web hook จะถูกซิงค์กับเครือข่ายของคุณ",
        Save_Changes: "บันทึก",
        WEBHOOK_LOGS: "WEBHOOK LOGS",
        Sync_users_using_your: "ซิงค์ผู้ใช้โดยใช้ HRIS ของคุณ รายการนี้แสดงคำขอ HRIS Webhook ล่าสุด 50 รายการ คุณสามารถ",
        Simulate_Changes: "จำลองการเปลี่ยนแปลง",
        to_see_how_the: "เพื่อดูว่าข้อมูลจะส่งผลต่อเครือข่ายของคุณอย่างไร โดยใช้การตั้งค่าซิงค์ HRIS Webhook ปัจจุบันของคุณ",
        Date: "วันที่",
        Webhook_Content: "เนื้อหา Webhook",
        Integration_Status: "สถานะการเชื่อมต่อ",
        Actions: "การดำเนินการ",
        View_Changes: "ดูการเปลี่ยนแปลง",
        No_webhook_activity: "ไม่มีกิจกรรม webhook ที่บันทึกไว้",
        Members: "สมาชิก",
        INTEGRATION_STATUS: "สถานะการเชื่อมต่อ",
        HRIS_Sync: "HRIS Sync",
        Sync_your_employee_data: "ซิงค์ข้อมูลพนักงานของคุณกับ HRIS เพื่อการจัดการสมาชิกในขั้นตอนเดียว",
        Connected: "เชื่อมต่อแล้ว",
        Setup: "ตั้งค่า",
        Developer_API: "Developer API",
        Activate_your_developer: "เปิดใช้งานโปรแกรมสำหรับนักพัฒนาและรับข้อมูลรับรองเพื่อเข้าถึงบริการ API",
        SSO_Title: "Single Sign-On (SSO)",
        SSO_Desc: "เปิดใช้งาน SSO เป็นวิธีการยืนยันตัวตนและจัดเตรียมบัญชีสำหรับสมาชิก",
        Directory_Sync: "Directory Sync",
        Endpoint: "Endpoint",
        Enable_Directory_Sync: "เปิดใช้งาน Directory Sync",
        Directory_Sync_Desc: "ข้อมูลใดๆ ที่ส่งโดย directory ของคุณจะถูกซิงค์กับบัญชี Happily ของคุณ",
        slack: {
            loadingConfig: "กำลังโหลดการตั้งค่า Slack...",
            connectTitle: "เชื่อมต่อ Happily กับ Slack",
            connectDescription: "นำการชื่นชม อินไซต์ และการมีส่วนร่วมเข้าสู่ workspace Slack ของทีมคุณโดยตรง",
            feature: {
                recognitionTitle: "การประกาศชื่นชม",
                recognitionDesc: "แชร์การชื่นชมในช่อง Slack โดยอัตโนมัติ",
                reportsTitle: "สรุปรายงานสำหรับผู้จัดการ",
                reportsDesc: "อินไซต์รายวันและรายสัปดาห์ส่งผ่าน DM",
                nudgesTitle: "แจ้งเตือนเช็กอิน",
                nudgesDesc: "การแจ้งเตือนเบาๆ เพื่อกระตุ้นการมีส่วนร่วม",
                reactionTitle: "ซิงก์รีแอ็กชัน",
                reactionDesc: "รีแอ็กชันจาก Slack ซิงก์กลับมาที่ Happily",
            },
            connecting: "กำลังเชื่อมต่อ...",
            connectButton: "เชื่อมต่อกับ Slack",
            redirectNote: "ระบบจะพาไปที่ Slack เพื่ออนุญาตให้ Happily เข้าถึง",
            comingSoon: "กำลังตั้งค่าระบบ Slack integration กรุณากลับมาตรวจสอบอีกครั้ง",
            connectedTo: "เชื่อมต่อกับ",
            connectedOn: "เชื่อมต่อเมื่อ",
            byUser: "โดย",
            test: "ทดสอบ",
            disconnect: "ตัดการเชื่อมต่อ",
            featuresSection: "ฟีเจอร์",
            toggle: {
                recognitionDesc: "โพสต์การชื่นชมไปยังช่อง Slack",
                dailyReportTitle: "สรุปรายงานรายวัน",
                dailyReportDesc: "อินไซต์ยามเช้าสำหรับผู้จัดการ",
                weeklyReportTitle: "สรุปรายงานรายสัปดาห์",
                weeklyReportDesc: "สรุปรายสัปดาห์ทุกวันจันทร์",
                nudgesDesc: "กระตุ้นการมีส่วนร่วมด้วยการแจ้งเตือนเบาๆ",
                reactionDesc: "ติดตามรีแอ็กชันของ Slack ใน Happily",
            },
            channelSettings: "ตั้งค่าช่อง",
            recognitionChannel: "ช่องสำหรับชื่นชม",
            selectChannel: "เลือกช่อง",
            teamChannels: "โพสต์ไปยังช่องของแต่ละทีมด้วย",
            dmRecipients: "ส่ง DM ไปยังผู้รับโดยตรง",
            nudgeSettings: "ตั้งค่าการแจ้งเตือน",
            triggerAfter: "เริ่มหลังจาก",
            daysWithoutCheckin: "วันที่ไม่ได้เช็กอิน",
            maxPerWeek: "สูงสุดต่อสัปดาห์",
            nudgesPerPerson: "ครั้งต่อคน",
            saving: "กำลังบันทึก...",
        },
        sso: {
            selectMethod: "เลือกวิธี SSO",
            general: "ทั่วไป",
            providerId: "SSO Provider ID",
            providerIdPlaceholder: "Provider ID",
            connectionName: "ชื่อการเชื่อมต่อ",
            connectionNamePlaceholder: "ตัวระบุสำหรับการเชื่อมต่อ",
            entityId: "Entity ID",
            signInUrl: "Sign In URL",
            certificate: "ใบรับรอง",
            certificatePlaceholder: "Public key ของเซิร์ฟเวอร์ SAMLP ในรูปแบบ PEM หรือ CER",
            syncProfileAttributes: "ซิงก์ข้อมูลโปรไฟล์",
            syncAtLogin: "ซิงก์ข้อมูลโปรไฟล์ผู้ใช้ทุกครั้งที่ล็อกอิน",
            syncAtLoginDesc: "อัปเดตชื่อ นามสกุล และรูปโปรไฟล์ในทุกการล็อกอิน",
            setupInfo: "ข้อมูลการตั้งค่า",
            authCallbackUrl: "Auth Callback URL",
            on: "เปิด",
            off: "ปิด",
            ssoEnabledLabel: "SSO ถูกเปิดใช้งานเป็นวิธีการลงชื่อเข้าใช้",
            dangerZone: "โซนอันตราย",
            deleteConnection: "ลบการเชื่อมต่อ",
            deleteConnectionDesc: "เมื่อยืนยันแล้วจะไม่สามารถย้อนกลับได้ การล็อกอินของสมาชิกจะกลับไปใช้ OTP",
            removeConnection: "นำการเชื่อมต่อนี้ออก",
        },
    },
    login: {
        sign_in_to: "เข้าสู่ระบบ",
        please_enter_your: "กรุณากรอกอีเมลของคุณ",
        keep_me_logged: "จดจำการเข้าสู่ระบบ",
        terms_and_Conditions: "ข้อกำหนดและเงื่อนไข",
        sign_in: "เข้าสู่ระบบ",
        your_account_access: "บัญชีของคุณถูกบล็อก อยู่นอกพารามิเตอร์การเข้าถึงที่อนุญาต",
        your_IP: "IP ของคุณ",
    },
    members: {
        ORGANIZATION_CHART_VIEW: "ผังองค์กร",
        the_org_chart: "ผังองค์กรในมุมมองปัจจุบันมีขนาดใหญ่เกินไปที่จะส่งออกเป็นไฟล์รูปภาพ",
        Members: "สมาชิก",
        incomplete_profiles: "โปรไฟล์ไม่สมบูรณ์",
        Archived: "เก็บถาวร",
        ADD_MEMBER: "เพิ่มสมาชิก",
        EXPORT_ALL: "ส่งออกทั้งหมด",
        REVIEW_UPDATES: "ตรวจสอบการอัปเดต",
        members_selected: "สมาชิกที่เลือก",
        RE_ASSIGN_MANAGER: "เปลี่ยนหัวหน้า",
        EDIT_TEAM: "แก้ไขทีม",
        ADD: "เพิ่ม",
        EDIT: "แก้ไข",
        ARCHIVE: "เก็บถาวร",
        SEND_INVITE: "ส่งคำเชิญ",
        RE_ASSIGN: "เปลี่ยน",
        IGNORE: "ข้าม",
        Invited: "เชิญแล้ว",
        Active: "ใช้งาน",
        Inactive: "ไม่ได้ใช้งาน",
        All: "ทั้งหมด",
        New: "ใหม่",
        Team: "ทีม",
        Member: "สมาชิก",
        Assign_Team: "กำหนดทีม",
        Assign_Manager: "กำหนดหัวหน้า",
        Coins: "Coins",
        Gems: "Gems",
        Permission: "สิทธิ์",
        Status: "สถานะ",
        results_from: "ผลลัพธ์จาก",
        results: "ผลลัพธ์",
        coins: "coins",
        gems: "gems",
        years: "ปี",
        months: "เดือน",
        days_ago: "วันที่แล้ว",
        joined_after: "เข้าร่วมหลังจาก",
        Joined: "เข้าร่วม",
        Daily_Streak: "Daily Streak",
        Achievements: "ความสำเร็จ",
        Super_Feedback: "Super Feedback",
        Problem_Areas: "จุดที่ต้องปรับปรุง",
        MOST_RECENT: "ล่าสุด",
        Powers: "Powers",
        Badges: "Badges",
        Knowledge: "ความรู้",
        Initiative: "ความคิดริเริ่ม",
        Contributor: "ผู้มีส่วนร่วม",
        Leadership: "ภาวะผู้นำ",
        Health: "สุขภาพ",
        Org: "องค์กร",
        Relationships: "ความสัมพันธ์",
        Are_you_sure_would: "คุณแน่ใจหรือไม่ที่จะเก็บถาวรสมาชิกรายนี้?",
        Once_archived_the_member: "เมื่อเก็บถาวรแล้ว สมาชิกจะถูกออกจากระบบ Happily โดยอัตโนมัติ และจะไม่สามารถเข้าสู่ระบบได้อีก",
        Archived_members_can_be: "สมาชิกที่เก็บถาวรสามารถกู้คืนได้ในภายหลัง",
        CANCEL: "ยกเลิก",
        First_Name: "ชื่อ",
        Last_Name: "นามสกุล",
        Email: "อีเมล",
        Manager: "หัวหน้า",
        Select_a_Manager: "เลือกหัวหน้า",
        Select_a_Team: "เลือกทีม",
        will_be_created_as_a: "จะถูกสร้างเป็นทีมใหม่",
        User_role: "บทบาทผู้ใช้",
        emoji_Member: "👩🏻 สมาชิก",
        Limited_Access: "สิทธิ์จำกัด",
        emoji_Admin: "✍🏻  Admin",
        integrations: "การเชื่อมต่อ",
        Manage_Account_Email_Notifications: "จัดการบัญชี, การแจ้งเตือนอีเมล",
        emoji_HR: "👩🏻‍💻  HR",
        Manage_Account_Insights: "จัดการบัญชี, อินไซต์",
        emoji_Leader: "👩🏻‍💼 Leader",
        Insights_Medals: "อินไซต์, เหรียญ",
        emoji_Super_Leader: "🦸🏻‍♀️ Super Leader",
        Manage_Account_Insights_Medals: "จัดการบัญชี, อินไซต์, เหรียญ",
        emoji_Super_Admin: "🙆🏻‍♀️ Super Admin",
        Manage_Account_Insights_Email: "จัดการบัญชี, อินไซต์, การแจ้งเตือนอีเมล",
        Language: "ภาษา",
        Country: "ประเทศ",
        English: "อังกฤษ",
        Thai: "ไทย",
        BahasaMalay: "มาเลย์",
        ChineseHK: "จีน (ดั้งเดิม, ฮ่องกง)",
        BrazilianPortuguese: "โปรตุเกสบราซิล",
        Burmese: "พม่า",
        SAVE_CHANGES: "บันทึก",
        Automatically_send_an: "ส่งอีเมลเชิญไปยังสมาชิกใหม่โดยอัตโนมัติ",
        Archive_employee: "เก็บถาวรพนักงาน",
        Archived_Type: "ประเภทการเก็บถาวร",
        Direct_Reports: "ลูกทีม",
        Re_Assign_Manager: "เปลี่ยนหัวหน้า",
        Search_manager_name: "ค้นหาชื่อหัวหน้า",
        Suggestions_based_on_member: "คำแนะนำจากการเลือกสมาชิกหรือช่องค้นหา",
        SUBMIT: "ส่ง",
        Archived_Employee: "พนักงานที่เก็บถาวร",
        Edit_Team: "แก้ไขทีม",
        Edit_Manager: "แก้ไขหัวหน้า",
        members: "สมาชิก",
        Top_Most: "บนสุด",
        UNARCHIVE: "กู้คืน",
        DELETE: "ลบ",
        delete_all: "ลบทั้งหมด",
        Unarchive: "กู้คืน",
        Delete: "ลบ",
        Search_team_name: "ค้นหาชื่อทีม",
        Complete_manager_assignment: ">กำหนดหัวหน้าให้เรียบร้อย",
        is_missing_a_direct: "ยังไม่มีหัวหน้าโดยตรง กรุณาเลือกหัวหน้าเพื่อให้สายการบังคับบัญชาสมบูรณ์",
        SELECT_DIRECT_MANAGER: "เลือกหัวหน้าโดยตรง",
        Re_assign_a_manager: "เปลี่ยนหัวหน้าเพื่อแทนที่",
        the_archived_manager: "หัวหน้าที่เก็บถาวร",
        has_been_archived_leaving: "ถูกเก็บถาวรแล้ว เหลือ",
        members_without_a_direct: "สมาชิกที่ไม่มีหัวหน้าโดยตรง กรุณาเปลี่ยนหัวหน้าเพื่อให้สายการบังคับบัญชาสมบูรณ์",
        Teams: "ทีม",
        powers: "powers",
        CREATE_TEAM: "สร้างทีม",
        badges: "badges",
        Information: "ข้อมูล",
        Sort_by_Direct_Reports: "เรียงตามลูกทีม",
        duplicate_teams: "ทีมที่ซ้ำกัน",
        Sort_by_Name: "เรียงตามชื่อ",
        ADD_TEAM: "เพิ่มทีม",
        Sort_by_Parent: "เรียงตามทีมแม่",
        Team_Manager: "หัวหน้าทีม",
        Parent_Team: "ทีมแม่",
        Team_Name: "ชื่อทีม",
        Auto_assignment: "กำหนดอัตโนมัติ",
        Color_Tag: "แท็กสี",
        A_unique_team_name: "ต้องระบุชื่อทีมที่ไม่ซ้ำกัน",
        A_parent_team_and: "ทีมแม่และหัวหน้าจะถูกกำหนดอัตโนมัติตามความสัมพันธ์ของสมาชิกในทีมกับหัวหน้า",
        Select_a_color_tag: "เลือกแท็กสีเพื่อจัดระเบียบทีมของคุณแบบมองเห็นได้ เช่น ตามหน่วยธุรกิจ/สายงาน",
        No_team_members: "ไม่มีสมาชิกในทีม",
        Managers: "หัวหน้า",
        Search: "ค้นหา",
        managers_selected: "หัวหน้าที่เลือก",
        Cohorts: "กลุ่ม",
        CREATE: "สร้าง",
        duplicate_cohorts: "กลุ่มที่ซ้ำกัน",
        ADD_COHORT: "เพิ่มกลุ่ม",
        Cohort_Name: "ชื่อกลุ่ม",
        Select_Member: "เพิ่มด้วยชื่อ อีเมล หรือทีม",
        Select_Leaders: "กำหนดผู้นำตามชื่อ (ไม่บังคับ)",
        Auto_generated: "สร้างอัตโนมัติ",
        Bulk_add_by_inputing: "เพิ่มทีเดียวโดยใส่ที่อยู่อีเมลคั่นด้วยจุลภาค",
        Add_members_to_this: "เพิ่มสมาชิกเข้ากลุ่มนี้",
        No_Cohort_members: "ไม่มีสมาชิกในกลุ่ม",
        Cohort_Leader: "ผู้นำกลุ่ม",
        Leader_description: "ผู้นำกลุ่มจะได้รับอินไซต์รายวันและรายสัปดาห์",
        Cohort_Type: "ประเภทกลุ่ม",
        Manual: "กำหนดเอง",
        Dynamic: "แบบไดนามิก",
        Configure_Dynamic_Rules: "ตั้งค่ากฎไดนามิก",
        Dynamic_cohort_description: "สมาชิกจะถูกเพิ่มหรือลบโดยอัตโนมัติตามกฎที่คุณตั้งค่าด้านล่าง",
        Preview: "ดูตัวอย่าง",
        Please_add_at_least_one_valid_rule: "กรุณาเพิ่มกฎที่ใช้งานได้อย่างน้อยหนึ่งข้อสำหรับกลุ่มไดนามิก",
        Error_previewing_cohort: "เกิดข้อผิดพลาดในการแสดงตัวอย่างกลุ่ม กรุณาลองอีกครั้ง",
        No_members_match: "ไม่มีสมาชิกที่ตรงกับกฎปัจจุบัน",
        team_audit: {
            title: "ตรวจสอบความสัมพันธ์ของทีม",
            teams_analyzed: "ทีมที่วิเคราะห์",
            discrepancies_found: "ความไม่สอดคล้องที่พบ",
            analyzing: "กำลังวิเคราะห์ความสัมพันธ์ของทีม...",
            all_valid: "ความสัมพันธ์ระหว่างทีมแม่และทีมลูกถูกต้องทั้งหมด!",
            fix: "แก้ไข",
            manual_review_tooltip: "ไม่สามารถแก้ไขอัตโนมัติได้ ต้องตรวจสอบด้วยตนเอง",
            manual_review: "ตรวจสอบด้วยตนเอง",
            team_manager: "ผู้จัดการทีม",
            multiple_managers: "มีผู้จัดการหลายคน",
            unassigned: "ยังไม่ได้กำหนด",
            managers_boss: "หัวหน้าของผู้จัดการ",
            no_boss_top_level: "ไม่มีหัวหน้า (ระดับบนสุด)",
            team_hierarchy: "ลำดับชั้นของทีม",
            current_structure: "โครงสร้างปัจจุบัน",
            recommended: "แนะนำ",
            no_parent_team: "ไม่มีทีมแม่",
            should_have_no_parent: "ไม่ควรมีทีมแม่",
            new_badge: "ใหม่",
            fix_all_issues: "แก้ไขปัญหาทั้งหมด",
            rerun_audit: "ตรวจสอบอีกครั้ง",
            failed_run: "ไม่สามารถตรวจสอบได้",
            fixed_relationship_for: "แก้ไขความสัมพันธ์ทีมแม่สำหรับ",
            failed_fix: "ไม่สามารถแก้ไข",
            fixed_prefix: "แก้ไข",
            fixed_suffix: "ความสัมพันธ์ของทีม",
            some_failed: "ไม่สามารถแก้ไขความสัมพันธ์บางรายการได้",
        },
        search_by_name_or_team: "ค้นหาด้วยชื่อหรือทีม",
        preparing_org_chart_download: "กำลังเตรียมผังองค์กรสำหรับดาวน์โหลด กรุณารอสักครู่...",
        cohorts: {
            main_conditions: "เงื่อนไขหลัก",
            nested_group: "กลุ่มย่อย",
            members_must_match: "สมาชิกต้องตรงตามเงื่อนไข",
            add_rules_or_groups_below: "เพิ่มกฎหรือกลุ่มด้านล่าง",
            add_rule: "เพิ่มกฎ",
            add_group: "เพิ่มกลุ่ม",
            select_attribute: "เลือกแอตทริบิวต์",
            select_operator: "เลือกตัวดำเนินการ",
            select_value: "เลือกค่า",
            select_values: "เลือกค่า",
            type_to_search: "พิมพ์เพื่อค้นหา",
            min: "ต่ำสุด",
            max: "สูงสุด",
            and: "ถึง",
        },
        relationship_mapping: {
            outer_network: "เครือข่ายภายนอก",
            inner_network: "เครือข่ายภายใน",
        },
        profile: {
            view_personal_context: "ดูข้อมูลส่วนบุคคล",
            download_photo: "ดาวน์โหลดรูปภาพ",
            personal_context_suffix: " — ข้อมูลส่วนบุคคล",
            personal_context_subtitle: "การวิเคราะห์จากรูปแบบการสื่อสารและฟีดแบ็ก เพื่อทำความเข้าใจในเชิงลึก",
            personal_values: "ค่านิยมส่วนบุคคล",
            skills_competencies: "ทักษะและความสามารถ",
            personality_communication: "บุคลิกภาพและการสื่อสาร",
            personality_traits: "บุคลิกภาพ",
            communication_style: "สไตล์การสื่อสาร",
            role_focus: "ขอบเขตของบทบาท",
            recent_challenges: "ความท้าทายล่าสุด",
            activity_timeline: "ไทม์ไลน์กิจกรรม",
            loading_happiness_data: "กำลังโหลดข้อมูลความสุข...",
            happiness_history_90d: "ประวัติความสุข 90 วัน",
            recent_happiness_suffix: " — ความสุขล่าสุด",
            happy_label: "มีความสุข:",
            okay_label: "ปกติ:",
            not_great_label: "ไม่ค่อยดี:",
            recovery_progress: "ความคืบหน้าการฟื้นตัว",
            risk_flags_summary: "สรุปสัญญาณความเสี่ยง",
            recent_timeline_label: "ไทม์ไลน์ล่าสุด (เก่าสุดไปใหม่สุด):",
            no_response: "ไม่มีคำตอบ",
            happy: "มีความสุข",
            okay: "ปกติ",
            not_great: "ไม่ค่อยดี",
            hover_load_happiness: "วางเคอร์เซอร์เพื่อโหลดข้อมูลความสุข",
            happiness_icon_title: "ดูเส้นทางความสุข 90 วัน พร้อมข้อมูลความเสี่ยงและการฟื้นตัว",
            star_performance_tooltip: "ผลงานโดดเด่นจากการอยู่ใน 15% แรกของผู้ที่ได้รับการชื่นชมในสัปดาห์นั้น",
            no_recent_data: "ไม่มีข้อมูลล่าสุด",
            top_skills: "ทักษะเด่น",
            top_skills_subtitle: "การรับรองจากฟีดแบ็กของเพื่อนร่วมงานที่ไม่ซ้ำกัน",
            culture_add: "การส่งเสริมวัฒนธรรม",
            culture_add_subtitle: "การสนับสนุนค่านิยมผ่านการชื่นชม",
            view_all: "ดูทั้งหมด",
            recognition_given: "การชื่นชมที่ส่งให้",
            recognition_received: "การชื่นชมที่ได้รับ",
            give_to_receive_ratio: "อัตราส่วนการให้ต่อการรับ",
            alignment_rating_score: "คะแนนความสอดคล้อง",
            is_a_top: "อยู่ในกลุ่มท็อป",
            culture_add_contributor_suffix: "% ของผู้ส่งเสริมวัฒนธรรม",
        },
    },
    pincode: {
        your_verification: "การยืนยันของคุณ",
        enter_the_four: "กรอกรหัส 4 หลักที่ส่งไปยังกล่องจดหมายของคุณ",
        your_code_is: "รหัสของคุณไม่ถูกต้อง กรุณาลองอีกครั้ง…",
        you_have: "คุณมี",
        attempts_remaining: "ครั้งที่เหลือ",
    },
    powerUp: {
        EXPORT: "ส่งออก",
        Recognition_trends: "แนวโน้มการชื่นชม",
        PARTICIPATION_RATE: "อัตราการมีส่วนร่วม",
        No_Filter: "ไม่มีตัวกรอง",
        Select_all: "เลือกทั้งหมด",
        Clear: "ล้าง",
        Filter_power_up: "กรองกิจกรรม Power-Ups ตามค่านิยมการชื่นชม",
        Cancel: "ยกเลิก",
        Okay: "ตกลง",
        results_from: "ผลลัพธ์จาก",
        results: "ผลลัพธ์",
        Export_Power_up_Activity: "ส่งออกกิจกรรม Power-Ups",
        Date_Range: "เลือกวันที่เริ่มต้นและสิ้นสุด",
        Start_Date: "วันที่เริ่มต้น",
        End_Date: "วันที่สิ้นสุด",
        Recipient: "ผู้รับ",
        From: "จาก",
        For: "สำหรับ",
        Reward: "รางวัล",
        Sent_on: "ส่งเมื่อ",
        Automations: "ระบบอัตโนมัติ",
        Preset_Library: "คลังค่าที่ตั้งไว้",
        By_Month: "รายเดือน",
        Automate: "ตั้งอัตโนมัติ",
        By_Quarter: "รายไตรมาส",
        By_Year: "รายปี",
        Create_your_own: "สร้างของคุณเอง",
        Recognition: "การชื่นชม",
        Power_up_Recipients: "ผู้รับ Power-Ups",
        based_on_your_selection: "ตามการเลือกของคุณ",
        Preview_on_Mobile_Layout: "ดูตัวอย่างบนมือถือ",
        got: "ได้รับ",
        for: "สำหรับ",
        This_power_up_automation_has: "Power-Ups อัตโนมัตินี้ยังไม่ได้เปิดใช้งาน",
        This_power_up_automation_has_been: "Power-Ups อัตโนมัตินี้เปิดใช้งานแล้ว",
        Recipients: "ผู้รับ",
        recipients: "ผู้รับ",
        Autogenerated: "สร้างอัตโนมัติ",
        for_showing_time_period: "สำหรับแสดงช่วงเวลา",
        Add: "เพิ่ม",
        Values_optional: "ค่านิยม (ไม่บังคับ)",
        Select_values_optional: "เลือกค่านิยม (ไม่บังคับ)",
        Schedule: "กำหนดเวลา",
        Following_work_day: "วันทำการถัดไป",
        Time: "เวลา",
        Select_time: "เลือกเวลา",
        Now: "ทันที",
        Name_of_Recipient: "ชื่อผู้รับ",
        Name_of_Recipient_s: "ชื่อผู้รับ",
        Reason_for_recognition: "เหตุผลในการชื่นชม",
        Reward_Type: "ประเภทรางวัล",
        Medal_Design: "ดีไซน์เหรียญ",
        Coin_Medal_or_Gem: "Coins, เหรียญ, หรือ Gems",
        Amount: "จำนวน",
        Number_of_coins: "จำนวน Coins",
        Number_of_gems: "จำนวน Gems",
        Share_on_Activity_Feed: "แชร์ไปยังฟีดกิจกรรม",
        SAVE_CHANGES: "บันทึก",
        DE_ACTIVATE_AUTOMATION: "ปิดใช้งานอัตโนมัติ",
        ACTIVATE_AUTOMATION: "เปิดใช้งานอัตโนมัติ",
        SEND: "ส่ง",
        RESET: "รีเซ็ต",
        Duplicate: "ทำซ้ำ",
        Delete: "ลบ",
        performance: {
            select_teams: "เลือกทีม",
            select_time_period: "เลือกช่วงเวลา",
            performance_presets: "ค่าที่ตั้งไว้สำหรับ Performance",
            performance_tracker: "ตัวติดตาม Performance",
            boosts_status: "สถานะ Boosts",
            culture_add: "Culture Add",
            goal_progress: "ความคืบหน้าเป้าหมาย",
            active_filter: "ตัวกรองที่ใช้งาน",
            clear_filter: "ล้างตัวกรอง",
            export: "ส่งออก",
            no_matching_results: "ไม่พบผลลัพธ์ที่ตรงกัน",
            no_matching_results_desc: "ไม่พบข้อมูลที่ตรงกับตัวกรองที่เลือก",
            try_one_of_these: "ลองสิ่งเหล่านี้:",
            clear_all_filters: "ล้างตัวกรองทั้งหมด",
            manager: "ผู้จัดการ",
            boosts_on_track: "Boosts ที่ไม่เกินกำหนด",
            both: "ทั้งสอง",
            team_member: "สมาชิกทีม",
            goal_follow_up: "การติดตามเป้าหมาย",
            per_goal_ratings: "คะแนนแต่ละเป้าหมาย",
            culture_follow_up: "การติดตามวัฒนธรรม",
            preset_name: "ชื่อค่าที่ตั้งไว้",
            review_questions: "คำถามการรีวิว",
            goal_performance: "Performance ของเป้าหมาย",
            culture_contribution: "การมีส่วนร่วมด้านวัฒนธรรม",
            scheduling: "การกำหนดเวลา",
            next_review_period: "ช่วงรีวิวถัดไป",
            assignments: "การมอบหมาย",
            assign_to_teams: "มอบหมายให้ทีม",
            assign_members: "มอบหมายให้สมาชิก",
            boost_preview: "ตัวอย่าง Boost",
        },
        activity: {
            total_recognition: "การชื่นชมทั้งหมด",
            value_aligned: "สอดคล้องค่านิยม",
            pct_value_aligned: "% สอดคล้องค่านิยม",
            participation_rate: "อัตราการมีส่วนร่วม",
            recognition_trends: "แนวโน้มการชื่นชม",
            last_12_months: "12 เดือนล่าสุด",
            total: "รวม",
            values_aligned_hash: "#สอดคล้องค่านิยม",
            values_heatmap: "Heatmap ค่านิยม",
            show_all: "แสดงทั้งหมด",
            use: "ใช้",
            window: "ช่วงเวลา",
            values: "ค่านิยม",
            recognition_trends_data: "ข้อมูลแนวโน้มการชื่นชม",
            month: "เดือน",
            values_aligned: "สอดคล้องค่านิยม",
            pct_values_aligned: "% สอดคล้องค่านิยม",
            export_csv: "ส่งออก CSV",
        },
        outbox_multiple: "หลายคน",
        leaderboards: {
            all_recognition: "การชื่นชมทั้งหมด",
            recognition_metrics: "เมตริกการชื่นชม",
            recognition_metrics_sub: "กิจกรรมการชื่นชมระหว่างเพื่อนร่วมงาน",
            most_recognition_given: "ให้การชื่นชมมากที่สุด",
            most_recognition_given_sub: "ผู้ให้การชื่นชมเพื่อนร่วมงานยอดเยี่ยม",
            most_recognition_received: "ได้รับการชื่นชมมากที่สุด",
            most_recognition_received_sub: "ผู้ได้รับการชื่นชมจากเพื่อนร่วมงานยอดเยี่ยม",
            give_receive_ratio: "อัตราส่วนการให้ต่อการรับสูงสุด",
            give_receive_ratio_sub: "ให้การชื่นชมต่อการรับมากที่สุด",
            alignment_metrics: "เมตริกความสอดคล้อง",
            alignment_metrics_sub: "ประสิทธิภาพความสอดคล้องค่านิยม",
            alignment_given: "ให้ความสอดคล้องสูงสุด",
            alignment_given_sub: "มีประสิทธิภาพสูงสุดในการเสริมค่านิยม",
            alignment_received: "ได้รับความสอดคล้องสูงสุด",
            alignment_received_sub: "การกระทำที่สอดคล้องค่านิยมสูงสุด",
            alignment_overall: "ความสอดคล้องโดยรวมสูงสุด",
            alignment_overall_sub: "ทูตวัฒนธรรมและค่านิยมยอดเยี่ยม",
            see_full_list: "ดูรายการทั้งหมด",
        },
    },
    questions: {
        add_a_question: "เพิ่มคำถาม",
        preview_of_daily: "ตัวอย่างอินไซต์รายวันสำหรับหัวหน้า",
        summary_of_insights: "สรุปอินไซต์จากลูกทีมของคุณ",
        of_ten_direct: "จากลูกทีม 10 คน",
        responded: "ตอบกลับ",
        yes: "ใช่",
        average_rating_out: "คะแนนเฉลี่ยจาก 10",
        english: "อังกฤษ",
        thai: "ไทย",
        add_option: "เพิ่มตัวเลือก",
        open_ended: "ปลายเปิด",
        yes_or_no: "ใช่/ไม่",
        multiple_choice: "หลายตัวเลือก",
        question: "คำถาม",
        option: "ตัวเลือก",
        positive: "เชิงบวก",
        neutral: "เป็นกลาง",
        negative: "เชิงลบ",
        min_label: "ป้ายต่ำสุด",
        max_label: "ป้ายสูงสุด",
        reward: "รางวัล",
        power_skill: "Power Skill",
        frequency: "ความถี่",
        day_of_week: "วันในสัปดาห์",
        schedule: "กำหนดการ",
        please_select_frequency: "กรุณาเลือกความถี่",
        and_when: "และเมื่อใด",
        more: "เพิ่มเติม",
        assign_a_sentiment: "กำหนดความรู้สึก",
        coins: "Coins",
        select_power_skill: "เลือก power skill (ไม่บังคับ)",
        how_often_do: "คุณต้องการถามคำถามนี้บ่อยแค่ไหน?",
        what_day_of: "คุณต้องการถามคำถามนี้ในวันใดของสัปดาห์?",
        CALENDAR_VIEW: "มุมมองปฏิทิน",
        Audience: "กลุ่มเป้าหมาย",
        Active: "ใช้งาน",
        Inactive: "ไม่ได้ใช้งาน",
        Show_All: "แสดงทั้งหมด",
        View: "ดู",
        Preview_of_Daily_Insights: "ตัวอย่างอินไซต์รายวันสำหรับหัวหน้า",
        Summary_of_insights_from: "สรุปอินไซต์จากลูกทีมของคุณ",
        of_ten_direct_reports: "จากลูกทีม 10 คน",
        responded_Yes: "ตอบว่า “ใช่”",
        average_rating_out_of: "คะแนนเฉลี่ยจาก 10",
        of_fifty_overal: "จาก 50 โดยรวม",
        English: "อังกฤษ",
        Thai: "ไทย",
        Positive: "เชิงบวก",
        Neutral: "เป็นกลาง",
        Negative: "เชิงลบ",
        Add_Option: "เพิ่มตัวเลือก",
        Min_label: "ป้ายต่ำสุด",
        Max_label: "ป้ายสูงสุด",
        Reward: "รางวัล",
        Power_Skill: "Power Skill",
        Select_power_skill: "เลือก power skill (ไม่บังคับ)",
        Day_of_Week: "วันในสัปดาห์",
        Please_select_frequency: "กรุณาเลือกความถี่",
        Schedule: "กำหนดการ",
        Type: "ประเภท",
        Select_Dimension: "เลือกมิติ",
        Question_Format: "รูปแบบคำถาม",
        Open_ended: "ปลายเปิด",
        Yes_or_No: "ใช่/ไม่",
        Multiple_Choice: "หลายตัวเลือก",
        Scale: "มาตรวัด",
        Question: "คำถาม",
        Option: "ตัวเลือก",
        Frequency: "ความถี่",
        Very_important: "สำคัญมาก",
        Coins: "Coins",
        Status: "สถานะ",
        Action: "การดำเนินการ",
        How_often__you: "คุณต้องการถามคำถามนี้บ่อยแค่ไหน?",
        What_day_of_week: "คุณต้องการถามคำถามนี้ในวันใดของสัปดาห์?",
        Not_at_all: "ไม่เลย",
        QUESTION_DETAILS: "รายละเอียดคำถาม",
        Search: "ค้นหา",
        Assign_a_Sentiment: "กำหนดความรู้สึก",
        Category: "หมวดหมู่",
        Row_Header: "หัวข้อแถว",
        Row_Header_Placeholder: "หัวข้อที่แสดงถึงอินไซต์จากคำถามนี้",
        preview_for_managers: "ตัวอย่างสำหรับผู้จัดการ",
        email_subject_today: "อินไซต์ของทีมวันนี้",
        today: "วันนี้",
        three_insights: "3 อินไซต์",
        email_intro_shared: "สิ่งที่ทีมของคุณแบ่งปันวันนี้",
        caption_of_four_direct: "จากลูกทีม 4 คน",
        caption_of_fourteen_overall: "จากทั้งหมด 14 คน",
        responded_word: "ตอบว่า",
        view_details: "ดูรายละเอียด",
        sample_response_placeholder: "ตัวอย่างคำตอบจากสมาชิกในทีมจะปรากฏที่นี่เมื่อมีคำตอบเข้ามา",
        youve_replied: "คุณตอบแล้ว",
        view_full_daily_report: "ดูรายงานประจำวันทั้งหมด",
        generate_placeholder: "ฉันต้องการเข้าใจว่าพนักงานเข้าใจค่านิยม #excellence ของเราดีแค่ไหน",
        generate_question: "สร้างคำถาม",
        send_to: "ส่งถึง",
        follow_up: "คำถามต่อเนื่อง",
        program_only: "Program only",
        response_settings: "การตั้งค่าคำตอบ",
        rolling_response: "คำตอบต่อเนื่อง",
        rolling_response_tooltip: "ส่งคำถามนี้ต่อไปจนกว่าจะมีคำตอบ หรือจนถึงรอบถัดไปของคำถามนี้",
        submit_responses_to_managers: "ส่งคำตอบให้ผู้จัดการ",
        private_feedback_mode: "โหมดฟีดแบ็กแบบไม่เปิดเผย",
        private_feedback_hint: "คำตอบจะซ่อนจากผู้จัดการและดูได้เฉพาะในรูปแบบฟีดแบ็กแบบไม่เปิดเผยตัวตน",
        report_card_analytics: "การวิเคราะห์ Report Card",
        include_in_report_card: "รวมในอินไซต์ → Report Card",
        include_in_culture_index: "รวมใน Culture Index",
        culture_index_tooltip: "รวมคำถามนี้ในการคำนวณ Culture Index ที่แสดงในแดชบอร์ดอินไซต์",
        refreshing: "กำลังรีเฟรช...",
        refresh_calendar_title: "รีเฟรชปฏิทินและเลือกวันนี้",
        legend_heavy_load: "โหลดหนัก (มากกว่า 5 คำถาม)",
        legend_light_load: "โหลดเบา (น้อยกว่า 4 คำถาม)",
        legend_open_ended_questions: "คำถามปลายเปิด",
        dimension: "มิติ",
        delivery: "การส่ง",
        essential_question_tooltip: "คำถามนี้จำเป็นสำหรับการวิเคราะห์และรายงาน สามารถปิดได้ในหน้ารายการคำถามแต่ต้องยืนยันก่อน",
        toggle_off_tooltip: "ปิดเพื่อนำคำถามนี้ออกจากชุดคำถามประจำวัน (มีผลต่อรอบถัดไป)",
        bi_weekly: "รายสองสัปดาห์",
        question_recipients: "ผู้รับคำถาม",
        team_label: "ทีม",
        includes_child_teams: "รวมคำตอบจากทีมย่อย",
        all_teams: "ทุกทีม",
        filter_by_team: "กรองตามทีม",
        search_teams_placeholder: "ค้นหาทีม...",
        no_teams_found: "ไม่พบทีม",
        combined_responses_prefix: "แสดงคำตอบรวมจาก",
        combined_responses_suffix: "และทีมย่อย",
        no_responses_available: "ยังไม่มีคำตอบ",
        no_responses_for_team: "ยังไม่มีคำตอบสำหรับทีมที่เลือก",
        summary: "สรุป",
        ai_generated_note: "สร้างโดย AI จากฟีดแบ็กที่แบ่งปันภายใน 3 เดือนของวันที่เลือก",
        responses_label: "คำตอบ",
        add_follow_up_question: "เพิ่มคำถามต่อเนื่อง",
        select_placeholder: "เลือก",
        SUBMIT: "ส่ง",
        toast_include_row_header: "กรุณาระบุ Row Header สำหรับคำถาม",
        toast_input_option_prefix: "กรุณากรอกตัวเลือก",
        toast_include_version_prefix: "กรุณาระบุเวอร์ชัน",
        toast_include_version_suffix: "สำหรับคำถาม",
        toast_select_dimension: "กรุณาเลือกมิติ",
        toast_select_question_format: "กรุณาเลือกรูปแบบคำถาม",
        toast_input_coins: "กรุณากรอก Coins",
        toast_select_frequency: "กรุณาเลือกความถี่",
        toast_select_day_of_week: "กรุณาเลือกวันในสัปดาห์",
        toast_select_schedule: "กรุณาเลือกกำหนดการ",
        toast_custom_question_created: "สร้างคำถามของคุณเรียบร้อยแล้ว",
        question_saved: "บันทึกคำถามแล้ว",
        saved_follow_up_question: "บันทึกคำถามต่อเนื่องแล้ว",
        saved_question_calendar_hint: "อัปเดตปฏิทินด้วยคำถามนี้แล้ว คุณสามารถดูตำแหน่งที่จะแสดง เพิ่มคำถามใหม่ หรือปิดหน้าต่างนี้ได้",
        saved_follow_up_question_hint: "บันทึกเป็นคำถามต่อเนื่องแล้ว จึงจะแสดงเมื่อเชื่อมจากตัวเลือกคำตอบหลัก ไม่ได้แสดงบนปฏิทิน",
        saved_program_only_question: "Program-only question saved",
        saved_program_only_question_hint: "This was saved as a program-only question, so it will only fire when a program references it — not on the calendar.",
        view_in_calendar: "ดูในปฏิทิน",
        add_another_question: "เพิ่มคำถามอีกข้อ",
        done: "เสร็จสิ้น",
        saving_question: "กำลังบันทึก...",
        toast_custom_question_create_failed: "ไม่สามารถบันทึกคำถามนี้ได้ กรุณาลองอีกครั้ง",
        toast_open_calendar_failed: "ไม่สามารถเปิดปฏิทินสำหรับคำถามนี้ได้ กรุณาลองอีกครั้ง",
        every: "ทุก",
        of_each_month: "ของทุกเดือน",
        first: "แรก",
        second: "ที่สอง",
        third: "ที่สาม",
        fourth: "ที่สี่",
        fifth: "ที่ห้า",
        toast_yes_no_assignment_required: "คำถามแบบ Yes หรือ No ต้องกำหนด Positive และ Negative ให้กับตัวเลือก \"Yes\" หรือ \"No\" หรือกำหนด Neutral ให้ทั้งสองตัวเลือก",
        toast_multi_choice_assignment_required: "คำถามแบบหลายตัวเลือกต้องมี Positive อย่างน้อยหนึ่งและ Negative อย่างน้อยหนึ่ง หรือกำหนด Neutral ให้ทุกตัวเลือก",
        toast_input_min_max_label: "กรุณากรอกป้ายกำกับ min/max",
    },
    register: {
        get_started_with: "เริ่มต้นใช้งาน Happily",
        set_up_one: "ตั้งค่า 1 ทีม",
        FREE: "ฟรี",
        BOOK_A_TIME: "จองเวลานัดหมาย",
        set_up_a: "ตั้งค่าทดลองใช้ฟรี 21 วันสำหรับหนึ่งทีมพร้อม",
        up_to_twenty: "ผู้ใช้สูงสุด 20 คน",
        set_up_many: "ตั้งค่าหลายทีม",
        schedule_a_one: "นัดหมายแบบ 1:1 กับทีมของเรา",
        team_who_will: "ทีมที่จะดูแลให้คุณได้รับ",
        the_most_out: "ประโยชน์สูงสุดจาก Happily",
        Setting_up_your: "กำลังตั้งค่าบัญชีของคุณ",
        help_us_get: "ช่วยให้เรารู้จักคุณและบริษัทของคุณมากขึ้น",
        your_name: "ชื่อของคุณ",
        please_input_your_name: "กรุณากรอกชื่อของคุณ",
        your_work_email: "อีเมลที่ทำงานของคุณ",
        please_input_your_work: "กรุณากรอกอีเมลที่ทำงานของคุณ",
        please_input_correct_email: "กรุณากรอกอีเมลให้ถูกต้อง",
        your_phone_number: "เบอร์โทรศัพท์ของคุณ",
        please_input_your_phone: "กรุณากรอกเบอร์โทรศัพท์ของคุณ",
        please_input_only_number: "กรุณากรอกเฉพาะตัวเลข",
        company_name: "ชื่อบริษัท",
        please_input_company: "กรุณากรอกชื่อบริษัท",
        Location: "ที่ตั้ง",
        please_input_Location: "กรุณากรอกที่ตั้ง",
        Time_Zone: "เขตเวลา",
        please_input_Time_Zonen: "กรุณากรอกเขตเวลา",
        language_preference: "ภาษาที่ต้องการ",
        how_many_people: "จำนวนพนักงาน",
        please_input_number_of: "กรุณากรอกจำนวนพนักงาน",
        please_input_language: "กรุณากรอกภาษาที่ต้องการ",
        what_would_you_like: "คุณต้องการบรรลุอะไรด้วย Happily",
        please_input_your_achieve: "กรุณากรอกเป้าหมายของคุณ",
        i_agree_to: "ฉันยอมรับ",
        terms_and_conditions: "ข้อกำหนดและเงื่อนไข",
        verify_my_email: "ยืนยันอีเมลของฉัน",
        confirm_your_email: "ยืนยันอีเมลของคุณ",
        we_sent_you: "เราได้ส่งรหัสยืนยันอีเมลให้คุณที่ ",
        the_email_may: "อีเมลอาจใช้เวลา 15-20 วินาทีในการส่งถึงคุณ และจะหมดอายุภายใน 15 นาที",
        resend_code: "ส่งรหัสอีกครั้ง",
        go_back: "ย้อนกลับ",
        book_a_meeting: "จองการประชุม",
        i_want_to: "ฉันต้องการสร้างที่ทำงานที่มีความสุขมากขึ้น",
        Schedule_a_time_with: "นัดหมายเวลากับเรา",
        Setting_up_multiple_teams: "การตั้งค่าหลายทีมจะง่ายขึ้นผ่านกระบวนการนำเข้าที่ทีมของเราสามารถช่วยแนะนำได้ จองการประชุมกับเราและเราจะติดต่อกลับ (โดยทั่วไปภายในหนึ่งชั่วโมง สูงสุด 24 ชั่วโมง) เพื่อให้คุณเริ่มใช้งานได้อย่างรวดเร็ว!",
    },
    reports: {
        DAILY_REPORT_PREVIEW: "ตัวอย่างรายงานรายวัน",
        Select_a_Manager: "เลือกผู้จัดการ",
        Select_date: "เลือกวันที่",
        Delivery_Status: "สถานะการจัดส่ง",
        Undelivered: "ยังไม่ได้จัดส่ง",
        Delivered: "จัดส่งแล้ว",
        Issue: "ปัญหา",
        Read_Status: "สถานะการอ่าน",
        Preview_a_report_by: "ดูตัวอย่างรายงานโดยเลือกผู้จัดการและวันที่",
        from_the_above_menu: "จากเมนูด้านบน",
        Loading: "กำลังโหลด",
        Unable_to_preview_this: "ไม่สามารถดูตัวอย่างรายงานนี้ได้เนื่องจากข้อมูลไม่เพียงพอ",
        MONTHLY_REPORT_PREVIEW: "ตัวอย่างรายงานรายเดือน",
        Select_a_Person: "เลือกบุคคล",
        Select_month: "เลือกเดือน",
        WEEKLY_REPORT_PREVIEW: "ตัวอย่างรายงานรายสัปดาห์",
        quarterly: {
            main: {
                report_generator: "ตัวสร้างรายงาน",
                scope_label: "ขอบเขต",
                scope_placeholder: "เลือกขอบเขต",
                company_wide: "ทั่วทั้งบริษัท",
                quarter_label: "ไตรมาส",
                quarter_placeholder: "เลือกไตรมาส",
                generate_report: "สร้างรายงาน",
                generating: "กำลังสร้าง...",
                loading_title: "กำลังสร้างรายงานของคุณ",
                empty_title: "สร้างงานนำเสนอสไลด์",
                empty_text: "เลือกขอบเขตและไตรมาสด้านบน จากนั้นคลิกสร้างรายงานเพื่อสร้างสไลด์สำหรับผู้บริหาร",
                generated_reports: "รายงานที่สร้างแล้ว",
                search_placeholder: "ค้นหารายงาน...",
                loading_reports: "กำลังโหลดรายงาน...",
                col_report_name: "ชื่อรายงาน",
                col_quarter: "ไตรมาส",
                col_created: "สร้างเมื่อ",
                col_updated: "อัปเดตล่าสุด",
                col_actions: "การดำเนินการ",
                view: "ดู",
                regenerate: "สร้างใหม่",
                delete: "ลบ",
                no_search_results: "ไม่พบรายงานที่ตรงกับการค้นหา",
                no_reports_yet: "ยังไม่มีรายงานที่สร้าง เริ่มสร้างได้จากด้านบน",
                back_to_config: "กลับไปที่การตั้งค่า",
                pdf_title: "กำลังเตรียม PDF ของคุณ",
                pdf_tip: "อาจใช้เวลาสักครู่สำหรับรายงานขนาดใหญ่",
            },
            controls: {
                previous_slide: "สไลด์ก่อนหน้า",
                next_slide: "สไลด์ถัดไป",
                go_to_slide: "ไปที่สไลด์",
                generating_pdf: "กำลังสร้าง PDF...",
                download_pdf: "ดาวน์โหลดเป็น PDF",
                enter_fullscreen: "เข้าสู่โหมดเต็มหน้าจอ",
                exit_fullscreen: "ออกจากโหมดเต็มหน้าจอ",
            },
            viewer: {
                navigate: "นำทาง",
                fullscreen: "เต็มหน้าจอ",
                exit: "ออก",
            },
            title_cover: {
                badge: "การมีส่วนร่วมของพนักงาน",
                title: "รายงานรายไตรมาส",
            },
            closing: {
                contact_label: "คำถามหรือฟีดแบ็ก?",
                contact_text: "ติดต่อทีม HR ของคุณ",
                next_steps: "ขั้นตอนถัดไป",
                generated: "สร้างเมื่อ",
            },
            key_metric: {
                vs_last_quarter: "เทียบกับไตรมาสที่แล้ว",
            },
            highlights: {
                strengths_title: "จุดแข็ง",
                strengths_subtitle: "ด้านที่ทำผลงานได้ดี",
                challenges_title: "ความท้าทาย",
                challenges_subtitle: "ด้านที่ต้องให้ความสนใจ",
                priorities_title: "สิ่งที่ต้องจัดการก่อน",
                priorities_subtitle: "ด้านที่แนะนำให้โฟกัส",
                empty_strengths: "ยังไม่พบจุดแข็ง",
                empty_challenges: "ยังไม่พบความท้าทาย",
                empty_priorities: "ยังไม่พบสิ่งที่ต้องจัดการก่อน",
            },
            chart_callouts: {
                key_insights: "อินไซต์สำคัญ",
                improvements: "การปรับปรุง",
                areas_of_concern: "ด้านที่น่ากังวล",
            },
            focus_alignment: {
                default_title: "โฟกัสตามเป้าหมาย",
                default_subtitle: "ทีมจัดลำดับโฟกัสให้สอดคล้องกับเป้าหมายองค์กรอย่างไร",
                items: "รายการ",
                done: "เสร็จแล้ว",
                open: "ยังไม่เสร็จ",
                people: "คน",
                unmatched_items: "รายการที่ไม่จับคู่",
                not_linked: "ยังไม่ได้เชื่อมกับเป้าหมายใด",
                consider_linking: "ลองเชื่อมรายการเหล่านี้กับเป้าหมาย",
                unknown_items: "ยังไม่ทราบความสอดคล้อง",
                no_goals_set: "ยังไม่ได้ตั้งเป้าหมายสำหรับขอบเขตนี้",
                set_goals_to_assess: "ตั้งเป้าหมายเพื่อประเมินความสอดคล้อง",
                empty_text: "ไม่มีเป้าหมายที่มีโฟกัสในไตรมาสนี้",
            },
            goal_distribution: {
                items: "รายการ",
                done_suffix: "% เสร็จแล้ว",
                legend_completed: "เสร็จแล้ว",
                legend_in_progress: "กำลังดำเนินการ",
                empty_text: "ไม่มีเป้าหมายที่มีโฟกัสในไตรมาสนี้",
            },
            leaderboard: {
                empty_text: "ไม่มีข้อมูลสำหรับช่วงเวลานี้",
            },
            question_scores: {
                legend_excellent: "70%+ ยอดเยี่ยม",
                legend_moderate: "50-69% ปานกลาง",
                legend_attention: "<50% ต้องให้ความสนใจ",
            },
            recommendations: {
                ai_badge: "อินไซต์ขับเคลื่อนโดย AI",
                default_title: "คำแนะนำสำคัญ",
                default_subtitle: "การดำเนินการเชิงกลยุทธ์เพื่อเพิ่มการมีส่วนร่วมและผลงาน",
                high_priority: "สำคัญมาก",
                medium: "ปานกลาง",
                low: "ต่ำ",
                high_impact: "ผลกระทบสูง",
                generated_by: "สร้างโดย Happily.ai",
            },
            who5: {
                label_poor: "ต่ำ",
                label_good: "ดี",
                legend_0: "0 - ไม่เลย",
                legend_1: "1 - บางครั้ง",
                legend_2: "2 - น้อยกว่าครึ่ง",
                legend_3: "3 - มากกว่าครึ่ง",
                legend_4: "4 - ส่วนใหญ่",
                legend_5: "5 - ตลอดเวลา",
            },
        },
    },
    rewards: {
        redeemed: "แลกแล้ว",
        add_a_reward: "เพิ่มรางวัล",
        active: "ใช้งาน",
        inactive: "ไม่ได้ใช้งาน",
        show_all: "แสดงทั้งหมด",
        status: "สถานะ",
        coins: "Coins",
        gems: "Gems",
        edit: "แก้ไข",
        Reward: "รางวัล",
        Activity: "กิจกรรม",
        preview_on_mobile: "ดูตัวอย่างบนมือถือ",
        REDEEM: "แลก",
        REQUEST: "ขอ",
        english: "อังกฤษ",
        thai: "ไทย",
        name: "ชื่อ",
        name_of_reward: "ชื่อรางวัล",
        mame_of_reward_Thai: "ชื่อรางวัล (ไทย)",
        description: "คำอธิบาย",
        description_Thai: "คำอธิบาย (ไทย)",
        cost: "ราคา",
        duration: "ระยะเวลา",
        start_date: "วันที่เริ่มต้น",
        end_date: "วันที่สิ้นสุด",
        gift_cards: "บัตรของขวัญ",
        perks: "สิทธิพิเศษ",
        team_building: "กิจกรรมสร้างทีม",
        doing_good: "ทำความดี",
        settings: "ตั้งค่า",
        country: "ประเทศ",
        all_countries: "ทุกประเทศ",
        limited_qty: "จำนวนจำกัด",
        available: "คงเหลือ",
        no_limit: "ไม่จำกัด",
        monthly_limit: "จำนวนจำกัดต่อเดือน",
        monthly_available: "เหลือ {available} จาก {limit} ในเดือนนี้",
        monthly_resets_on_first: "รีเซ็ตทุกวันที่ 1 ของเดือน",
        limit_quantity: "จำนวนการแลก",
        limit_unlimited: "ไม่จำกัด",
        limit_total: "จำกัดทั้งหมด",
        limit_monthly: "ต่อเดือน",
        limit_unit_total: "รวม",
        limit_unit_per_month: "/ เดือน",
        limit_total_helper: "ขีดจำกัดตลอดอายุ · ตัวนับไม่รีเซ็ต",
        limit_monthly_helper: "เหลือ {available} จาก {limit} ในเดือนนี้ · รีเซ็ตทุกวันที่ 1",
        Require_Approval: "ต้องได้รับการอนุมัติ",
        On: "เปิด",
        Off: "ปิด",
        image: "รูปภาพ",
        upload: "อัปโหลด",
        file_size_should: "ขนาดไฟล์ควรเป็น 600 x 320 px ภาพย่อของรางวัลจะถูกสร้างอัตโนมัติที่กึ่งกลางเป็นสี่เหลี่ยมจัตุรัส",
        reward: "รางวัล",
        processing: "กำลังดำเนินการ",
        sent: "ส่งแล้ว",
        cancel: "ยกเลิก",
        confirm_cancellation: "ยืนยันการยกเลิก",
        are_you_sure: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิก",
        redeemed_by: "แลกโดย (มอบให้)",
        Recipient: "ผู้รับ",
        Value: "มูลค่า",
        Type: "ประเภท",
        Date_and_Time: "วันที่และเวลา",
        Delivered: "ส่งมอบแล้ว",
        no: "ไม่",
        yes_and_refund: "ใช่ และคืนเงิน",
        yes_and_do: "ใช่ และไม่คืนเงิน",
        refund: "ยกเลิกและคืนเงิน",
        all_countries_label: "ทุกประเทศ",
        member_countries_only: "เฉพาะประเทศของสมาชิก",
        enabled: "เปิดใช้งาน",
        disabled: "ปิดใช้งาน",
        show_all_status: "แสดงทุกสถานะ",
        bulk_update_rates: "อัปเดตอัตราหลายรายการ",
        bulk_update_coin_rates: "อัปเดตอัตรา Coins หลายรายการ",
        gem_exchange: "Gem Exchange",
        gem_exchange_editor: {
            title: "Gem Exchange",
            subtitle: "ให้พนักงานแลก Gems เป็น Coins",
            enabled: "เปิดใช้งาน",
            disabled: "ปิดใช้งาน",
            shared_metadata: "ข้อมูลที่ใช้ร่วมกัน",
            display_name: "ชื่อที่แสดง",
            display_name_hint: "สร้างอัตโนมัติ — แก้ไขได้ตามต้องการ",
            image: "รูปภาพ",
            image_default_hint: "ใช้ค่าเริ่มต้น — อัปโหลดเพื่อปรับแต่ง",
            upload_image: "อัปโหลดรูปภาพ",
            replace_image: "เปลี่ยนรูปภาพ",
            use_default: "ใช้ค่าเริ่มต้น",
            image_hint: "JPG หรือ PNG สูงสุด 2MB",
            duration: "ระยะเวลา",
            templates: "เทมเพลต",
            templates_hint_prefix: "ใช้",
            templates_hint_and: "และ",
            templates_hint_suffix: "เพื่อแทรกค่าระดับ",
            exchange_tiers: "ระดับการแลก",
            exchange_tiers_hint: "แต่ละระดับจะกลายเป็นรางวัลหนึ่งในแท็บ Perks",
            col_gems: "Gems",
            col_coins: "Coins",
            col_rate: "อัตรา",
            col_monthly_cap: "จำกัดต่อเดือน",
            col_redemption_limit: "ขีดจำกัด",
            mode_total_short: "ทั้งหมด",
            mode_monthly_short: "/เดือน",
            no_limit: "ไม่จำกัด",
            per_gem: "ต่อ gem",
            best_value: "คุ้มค่าที่สุด",
            add_another_tier: "เพิ่มระดับอื่น",
            employee_preview: "ตัวอย่างสำหรับพนักงาน",
            employee_preview_hint: "การแสดงระดับ 1 ในการแลก",
            save_changes: "บันทึก",
        },
        tiers_active: "ระดับที่ใช้งาน",
        tier_active: "ระดับที่ใช้งาน",
        no_tiers_yet: "ยังไม่มีระดับ",
        off: "ปิด",
        gem_exchange_on_add_tiers: "Gem Exchange เปิดอยู่ เพิ่มระดับเพื่อให้พนักงานแลกได้",
        gem_exchange_intro: "ให้พนักงานแลก Gems เป็น Coins ด้วยระดับที่กำหนดเองได้",
        edit_tiers: "แก้ไขระดับ",
        configure_arrow: "ตั้งค่า →",
        set_up_arrow: "เริ่มตั้งค่า →",
        new_badge: "ใหม่",
        expired_badge: "หมดอายุ",
        managed: "จัดการโดยระบบ",
        managed_by_gem_exchange: "จัดการโดย Gem Exchange",
        edit_a_reward: "แก้ไขรีวอร์ด",
        linked_gem_variant: {
            create_title: "สร้างเวอร์ชันเจม", edit_title: "แก้ไขเวอร์ชันเจม",
            subtitle: "เพิ่มราคาแบบเจม โดยเวอร์ชันคอยน์เดิมยังใช้งานได้",
            provider_linked: "เชื่อมกับผู้ให้บริการ", coin_version_kept: "เวอร์ชันคอยน์ยังเปิดอยู่", gem_version: "เวอร์ชันเจม",
            gem_cost: "จำนวนเจม", gem_cost_placeholder: "กรอกจำนวนเจมที่ต้องใช้",
            gem_cost_help: "สมาชิกใช้เจม ส่วนมูลค่าบัตรและการเรียกเก็บเงินยังอ้างอิงรายการเดิม",
            create_action: "สร้างเวอร์ชันเจม", add_action: "เพิ่มเวอร์ชันเจม", edit_action: "แก้ไขเวอร์ชันเจม",
            keep_coin_help: "เวอร์ชันคอยน์เดิมยังใช้งานได้", created: "สร้างเวอร์ชันเจมแล้ว เวอร์ชันคอยน์ไม่เปลี่ยนแปลง", updated: "อัปเดตเวอร์ชันเจมแล้ว", save_failed: "ไม่สามารถบันทึกเวอร์ชันเจมได้",
            errors: {
                missing_source_reward: "ไม่พบรางวัลของบริษัท", missing_master_reward: "ไม่พบรางวัลต้นฉบับจากผู้ให้บริการ",
                invalid_gem_cost: "กรอกจำนวนเจมเป็นจำนวนเต็มมากกว่าศูนย์", inactive_master_reward: "รางวัลต้นฉบับไม่ได้เปิดใช้งาน",
                missing_reward_name: "รางวัลต้นฉบับไม่มีชื่อ", missing_reward_type: "รางวัลต้นฉบับไม่มีประเภทการจัดส่ง",
                missing_face_value: "รางวัลต้นฉบับไม่มีมูลค่าสำหรับเรียกเก็บเงิน", missing_reward_currency: "รางวัลต้นฉบับไม่มีสกุลเงิน",
                missing_provider_product_id: "ไม่มีรหัสสินค้าของผู้ให้บริการ", unable_to_create_variant_id: "ไม่สามารถสร้างรหัสรางวัลที่ปลอดภัยได้"
            }
        },
        type_placeholder: "ประเภท",
        reward_activity: "กิจกรรมรีวอร์ด",
        reward_activity_view: "มุมมองกิจกรรมรีวอร์ด",
        loading_activity: "กำลังโหลดกิจกรรมรีวอร์ด",
        updating_activity: "กำลังอัปเดตกิจกรรม…",
        loading_activity_hint: "ช่วงวันที่ที่ยาวอาจใช้เวลาโหลดเพิ่มขึ้นเล็กน้อย คุณสามารถปิดหน้าต่างนี้ระหว่างรอได้",
        activity_load_error: "ไม่สามารถโหลดกิจกรรมรีวอร์ดได้",
        activity_load_error_hint: "โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง ข้อมูลรีวอร์ดของคุณยังไม่มีการเปลี่ยนแปลง",
        activity_empty: "ไม่มีกิจกรรมรีวอร์ดในช่วงเวลานี้",
        delivered: "จัดส่งแล้ว",
        recipients: "ผู้รับ",
        members: "สมาชิก",
        pending: "รอดำเนินการ",
        transactions: "รายการ",
        member_spend: "การใช้จ่ายตามสมาชิก",
        member: "สมาชิก",
        redeemed_by_member: "ผู้แลก",
        redemptions: "จำนวนครั้งที่แลก",
        reward_spend: "มูลค่าที่แลก",
        share_of_currency_spend: "สัดส่วนการใช้จ่ายในสกุลเงิน",
        last_activity: "กิจกรรมล่าสุด",
        member_spend_hint: "มูลค่ารางวัลที่จัดส่งแล้วจะนับตามสมาชิกผู้แลก รวมถึงของขวัญที่ส่งให้ผู้อื่น",
        member_spend_empty: "ไม่มีการใช้จ่ายรางวัลที่จัดส่งแล้วในช่วงเวลานี้",
        currency_totals_separate: "แยกยอดตามสกุลเงินเพื่อให้ยอดรวมถูกต้อง",
        currency_count: "{count} สกุลเงิน",
        delivered_reward_spend: "มูลค่ารางวัลที่จัดส่งแล้ว",
        delivered_reward_spend_period: "มูลค่ารางวัลที่จัดส่งแล้ว · {period}",
        custom_date_range: "ช่วงวันที่กำหนดเอง",
        export: "ส่งออก",
        value: "มูลค่า",
        type: "ประเภท",
        date_and_time: "วันที่และเวลา",
        date_range: "ช่วงวันที่",
        to: "ถึง",
        start_date_placeholder: "วันที่เริ่ม",
        end_date_placeholder: "วันที่สิ้นสุด",
        confirm_and_filter: "ยืนยันและกรอง",
        currency: "สกุลเงิน",
        select_currency: "เลือกสกุลเงิน",
        current_rate: "อัตราปัจจุบัน",
        new_rate: "อัตราใหม่",
        preview_changes: "แสดงตัวอย่างการเปลี่ยนแปลง",
        show_only_changes: "แสดงเฉพาะที่เปลี่ยนแปลง",
        reward_name: "ชื่อรีวอร์ด",
        current: "ปัจจุบัน",
        new_coins: "Coins ใหม่",
        change: "การเปลี่ยนแปลง",
        no_rewards_for_currency: "ไม่พบรีวอร์ดสำหรับสกุลเงินที่เลือก",
        select_currency_hint: "เลือกสกุลเงินเพื่อดูและอัปเดตรีวอร์ด",
        apply: "ใช้",
        changes_suffix: "การเปลี่ยนแปลง",
        change_singular: "การเปลี่ยนแปลง",
        of: "จาก",
        toast_managed_by_gem_exchange: "จัดการโดย Gem Exchange — ใช้ Edit tiers เพื่อเปิด/ปิดใช้งาน",
        toast_confirm_activate: "ยืนยันการเปิดใช้งานรีวอร์ดนี้หรือไม่?",
        toast_reward_activated: "เปิดใช้งานรีวอร์ดแล้ว",
        toast_canceled: "ยกเลิกแล้ว",
        toast_confirm_disable: "ยืนยันการปิดใช้งานรีวอร์ดนี้หรือไม่?",
        toast_reward_disabled: "ปิดใช้งานรีวอร์ดแล้ว",
        toast_select_valid_date_range: "กรุณาเลือกช่วงวันที่ที่ถูกต้อง",
        toast_confirm_cancel_transaction: "ยืนยันการยกเลิกรายการรีวอร์ดนี้หรือไม่?",
        toast_transaction_canceled: "ยกเลิกรีวอร์ดเรียบร้อยแล้ว",
        toast_coins_gems_refunded_prefix: "Coins หรือ Gems จะถูกคืนให้กับ",
        toast_confirm_status_change: "ยืนยันการเปลี่ยนสถานะของรายการนี้หรือไม่?",
        toast_status_updated: "อัปเดตสถานะแล้ว",
        toast_select_image: "กรุณาเลือกรูปภาพ",
        toast_confirm_delete: "ยืนยันการลบรีวอร์ดนี้หรือไม่?",
        toast_reward_deleted: "ลบรีวอร์ดแล้ว",
        toast_reward_added: "เพิ่มรีวอร์ดเรียบร้อยแล้ว",
        toast_reward_updated: "อัปเดตรีวอร์ดแล้ว",
        toast_avatar_format_error: "รูปโปรไฟล์ต้องเป็นไฟล์ JPG เท่านั้น",
        toast_avatar_size_error: "ขนาดรูปโปรไฟล์ต้องไม่เกิน 2MB",
    },
    sparks: {
        custom_sparks: "Sparks ที่กำหนดเอง",
        program_only: "Program only",
        Create_a_Set: "สร้างชุด",
        Set: "ชุด",
        HAPPILY_S_SPARKS: "SPARKS ของ HAPPILY",
        Name_of_Spark_Set: "ชื่อชุด Sparks",
        Please_input_Set_Name: "กรุณากรอกชื่อชุด",
        Display_After: "แสดงหลังจาก",
        Before_Set_one: "ก่อนชุดที่ 1",
        Audience: "ผู้ชม",
        Set_name: "ชื่อชุด",
        Select: "เลือก",
        SAVE_CHANGES: "บันทึก",
        CANCEL: "ยกเลิก",
        DELETE_SPARK_SET: "ลบชุด SPARK",
        CREATE_SET: "สร้างชุด",
        Title: "ชื่อ",
        Edit: "แก้ไข",
        Draft: "ฉบับร่าง",
        Create_a_New_Card: "สร้างการ์ดใหม่",
        Spark_Title: "ชื่อ Spark",
        Please_input_Spark_Title: "กรุณากรอกชื่อ Spark",
        Spark_Icon: "ไอคอน Spark",
        Spark_Content_English: "เนื้อหา Spark - อังกฤษ",
        Spark_Content_Thai: "เนื้อหา Spark - ไทย",
        SAVE_SPARK: "บันทึก SPARK",
        DELETE: "ลบ",
        nudges: "Nudges",
        nudges_col_dimension: "หมวดหมู่",
        nudges_col_nudge: "คำเตือน",
        nudges_col_recipient: "ผู้รับ",
        nudges_col_date_time: "วันและเวลา",
        nudges_expand_all: "ขยายทั้งหมดในชุด",
        nudges_hide_all: "ซ่อนทั้งหมดในชุด",
        nudges_load_more: "โหลดเพิ่มเติม",
        new_spark_set: "Spark Set ใหม่",
        ai_placeholder: "ต้องการสร้าง micro learning เกี่ยวกับทักษะหรือความรู้ใด?",
        generate_spark_set: "สร้าง Spark Set",
        untitled: "ไม่มีชื่อ",
        spark_content_prefix: "เนื้อหา Spark -",
    },
    demomode: {
        demo_on: "เปิดโหมดเดโม",
        demo_tooltip: "ชื่อผู้ใช้และชื่อทีมจะถูกเซ็นเซอร์ หากต้องการปิด ให้กด CTRL + ALT + D หรือ CMD + OPTION + D",
        detected_title: "เราตรวจพบว่าคุณเปิดโหมดเดโมค้างไว้ตั้งแต่การเข้าสู่ระบบครั้งล่าสุด",
        detected_sub: "ไม่ต้องกังวล เราจะเปิดไว้ต่อเนื่องระหว่างการรีเฟรชหน้า",
        warning: "คำเตือน: ชื่อและรายละเอียดที่แสดงในรายงานจะไม่ถูกเซ็นเซอร์",
    },
    sso: {
        your: "ของคุณ",
        this_account: "บัญชีนี้",
        has_been_set: "ได้ถูกตั้งค่าให้ใช้ single sign-on",
        google_sign_In: "Google Sign-In",
        sign_In: "เข้าสู่ระบบ",
        sign_Out: "ออกจากระบบ",
        mobile_welcome_to: "ยินดีต้อนรับสู่",
        mobile_account_set_to_login: "บัญชีของคุณตั้งค่าให้เข้าสู่ระบบผ่าน SSO",
    },
    performance: {
        focus_areas: {
            select_team: "เลือกทีม",
            all_teams: "ทุกทีม",
            search: "ค้นหา",
            without_focus: "ไม่มีโฟกัส",
            with_partners: "มีพาร์ตเนอร์",
            goal_alignment: "การสอดคล้องกับเป้าหมาย",
            all_items: "ทุกรายการ",
            with_goal: "มีเป้าหมาย",
            without_goal: "ไม่มีเป้าหมาย",
            people: "สมาชิก",
            total: "ทั้งหมด",
            with_focus: "มีโฟกัส",
            no_focus: "ไม่มีโฟกัส",
            focus_coverage_trend: "แนวโน้ม Focus Coverage",
            last: "ล่าสุด",
            weeks: "สัปดาห์",
            days: "วัน",
            focus_items: "Focus Items",
            unique: "ไม่ซ้ำ",
            open: "เปิดอยู่",
            done: "เสร็จแล้ว",
            focus_insights: "Focus Insights",
            focus_distribution: "การกระจายของโฟกัส",
            in_progress: "กำลังดำเนินการ",
            completed: "เสร็จสิ้น",
            team_metrics: "เมตริกทีม",
            team: "ทีม",
            tooltip_total_people: "จำนวนสมาชิกทั้งหมดในทีมนี้",
            tooltip_focusing: "เปอร์เซ็นต์สมาชิกที่มีอย่างน้อยหนึ่ง focus item",
            focusing: "กำลังโฟกัส",
            tooltip_items_open_done: "จำนวนรายการที่กำลังดำเนินการ / เสร็จสิ้น",
            items_open_done: "รายการ (เปิด / เสร็จ)",
            tooltip_completion: "เปอร์เซ็นต์ของ focus items ที่เสร็จสิ้น",
            completion: "ความสำเร็จ",
            tooltip_partnership: "เปอร์เซ็นต์ของ focus items ที่มีพาร์ตเนอร์อย่างน้อยหนึ่งคน",
            partnership: "ความร่วมมือ",
            no_results_found: "ไม่พบผลลัพธ์",
            no_focus_data_available: "ไม่มีข้อมูลโฟกัส",
            adjust_filters_hint: "ลองปรับตัวกรองหรือคำค้นหา",
            empty_state_hint: "Focus Areas จะแสดงที่นี่เมื่อสมาชิกเริ่มตั้งค่า",
            no_focus_items: "ไม่มี focus items",
            no_items_in_progress: "ไม่มีรายการที่กำลังดำเนินการ",
            no_completed_items: "ไม่มีรายการที่เสร็จสิ้น",
            focus_item_details: "รายละเอียด Focus Item",
            focus_item_label: "FOCUS ITEM",
            description_label: "รายละเอียด",
            status_label: "สถานะ",
            focus_partners: "พาร์ตเนอร์โฟกัส",
            no_partners_for_item: "ไม่มีพาร์ตเนอร์สำหรับ focus item นี้",
            partners_view: "มุมมองของพาร์ตเนอร์:",
            your_view: "มุมมองของคุณ:",
        },
        emergent_goals: {
            discover_goals: "ค้นพบเป้าหมาย",
            header_subtitle: "คำแนะนำจาก AI จากงานที่ยังไม่จับคู่",
            run_fresh_analysis: "วิเคราะห์ด้วย AI ใหม่อีกครั้ง",
            refresh: "รีเฟรช",
            close: "ปิด",
            loading_hint: "โดยปกติใช้เวลา 30-60 วินาที",
            try_again: "ลองอีกครั้ง",
            all_caught_up: "ครบถ้วนแล้ว",
            all_caught_up_desc: "ไม่พบรูปแบบที่ชัดเจนในรายการโฟกัสที่ยังไม่จับคู่ งานของทีมอาจสอดคล้องกับเป้าหมายที่มีอยู่แล้ว",
            auto_matched_desc: "รายการโฟกัสที่จับคู่กับเป้าหมายที่มีอยู่โดยอัตโนมัติ",
            hide: "ซ่อน",
            show: "แสดง",
            review_matches: "ตรวจสอบการจับคู่",
            matches_need_confirmation: "การจับคู่เหล่านี้ต้องการการยืนยันจากคุณ",
            focus_item: "รายการโฟกัส",
            suggested_goal: "เป้าหมายที่แนะนำ",
            accept: "ยอมรับ",
            skip: "ข้าม",
            matched: "จับคู่แล้ว",
            skipped: "ข้ามแล้ว",
            suggested_new_goals: "เป้าหมายใหม่ที่แนะนำ",
            new_goals_desc: "เป้าหมายใหม่จากรูปแบบในงานที่ยังไม่จับคู่",
            team: "ทีม",
            recommended: "แนะนำ",
            select_team: "เลือกทีม",
            link_to_parent: "เชื่อมโยงกับเป้าหมายหลัก",
            optional: "ไม่บังคับ",
            select_parent_goal: "เลือกเป้าหมายหลัก",
            no_ancestor_goals: "ไม่มีเป้าหมายทีมระดับบนให้เลือก",
            create_goal: "สร้างเป้าหมาย",
            created: "สร้างแล้ว",
            done: "เสร็จสิ้น",
        },
        talent_matrix: {
            select_team: "เลือกทีม",
            all_teams: "ทีมทั้งหมด",
            x_axis: "แกน X",
            y_axis: "แกน Y",
            swap_axes: "สลับแกน",
            color_by_talent_type: "ระบายสีตาม Talent Type",
            color_by_team: "ระบายสีตามทีม",
            no_coloring: "ไม่ระบายสี",
            export_csv: "ส่งออก CSV",
            higher_is_better: "ค่าสูงกว่าดีกว่า",
            lower_is_better: "ค่าต่ำกว่าดีกว่า",
            employee_details: "รายละเอียดพนักงาน",
            employees: "พนักงาน",
            employee: "พนักงาน",
            network: "เครือข่าย",
            talent_type: "Talent Type",
            quadrant: "ควอดแรนท์",
            engagement_wellbeing: "การมีส่วนร่วมและความเป็นอยู่",
            happiness_score: "คะแนนความสุข",
            engagement_score: "คะแนนการมีส่วนร่วม",
            flight_risk: "ความเสี่ยงลาออก",
            performance_growth: "ผลงานและการเติบโต",
            impact_rating: "คะแนน Impact",
            performance_score: "คะแนนผลงาน",
            focus_score: "คะแนน Focus",
            goal_alignment: "การสอดคล้องของเป้าหมาย",
            recognition_trust: "การชื่นชมและความไว้วางใจ",
            trust_score: "คะแนนความไว้วางใจ",
            peer_trust_count: "จำนวน Peer Trust",
            giving_recognition: "การให้การชื่นชม",
            receiving_recognition: "การได้รับการชื่นชม",
            medals: "เหรียญรางวัล",
            power_skills_eq: "Power Skills (EQ)",
        },
        goals: {
            search_members: "ค้นหาสมาชิก",
            include_subteams: "รวมทีมย่อย",
            include_subteams_tooltip: "เมื่อเปิดใช้ สถิติการจัดแนวจะรวมทีมย่อยทั้งหมด",
            show_archived: "แสดงที่เก็บถาวร",
            show_archived_tooltip: "แสดงเป้าหมายที่เก็บถาวรซึ่งถูกลบไว้",
            krs_by_team: "KRs ตามทีม",
            krs_by_individual: "KRs ตามบุคคล",
            goal_alignment_tooltip: "เปอร์เซ็นต์ของโฟกัสที่เชื่อมโยงกับเป้าหมายของทีม",
            expand_teams_to_load: "ขยายทีมเพื่อโหลด",
            aligned: "จัดแนวแล้ว",
            unaligned: "ยังไม่จัดแนว",
            unknown: "ไม่ทราบ",
            unknown_items: "รายการโฟกัสที่ยังไม่ทราบความสอดคล้อง",
            focus_items_alignment_unknown: "รายการโฟกัสยังไม่ทราบความสอดคล้อง เพราะยังไม่ได้ตั้งเป้าหมาย",
            focus_items_not_aligned: "รายการโฟกัสไม่สอดคล้องกับเป้าหมายใด",
            no_goals_to_map: "ไม่มีเป้าหมายให้เทียบ",
            members_with_krs: "สมาชิกที่มี KRs",
            total_krs: "KRs ทั้งหมด",
            assigned: "ที่มอบหมาย",
            avg_progress: "ความคืบหน้าเฉลี่ย",
            kr_status: "สถานะ KR",
            on_track: "เป็นไปตามแผน",
            at_risk: "มีความเสี่ยง",
            off_track: "ไม่เป็นไปตามแผน",
            goal_focus_trends: "แนวโน้มโฟกัสตามเป้าหมาย",
            hide_items: "ซ่อนรายการ",
            view_items: "ดูรายการ",
            has_value: "มีค่า",
            no_value: "ไม่มีค่า",
            no_teams_found: "ไม่พบทีม",
            no_teams_available: "ไม่มีทีม",
            no_teams_adjust_filters: "ลองปรับคำค้นหรือตัวกรอง",
            no_teams_empty_hint: "ทีมจะปรากฏที่นี่เมื่อถูกสร้าง",
            col_team: "ทีม",
            col_goals: "เป้าหมาย",
            goal_name_placeholder: "ชื่อเป้าหมาย",
            save_changes: "บันทึก",
            archived: "เก็บถาวร",
            edit_goal: "แก้ไขเป้าหมาย",
            archive_goal: "เก็บเป้าหมาย",
            restore_goal: "กู้คืนเป้าหมาย",
            delete_permanently: "ลบถาวร",
            no_focus_on_goal_tooltip: "ไม่มีใครโฟกัสเป้าหมายนี้",
            linked_to_parent_goals: "เชื่อมกับเป้าหมายหลัก:",
            goal_description_placeholder: "คำอธิบายเป้าหมาย",
            goal_edit_hint: "แก้ไขคำอธิบายเป้าหมายด้านบน ใช้ปุ่มบันทึกในส่วนหัวเพื่อยืนยันการเปลี่ยนแปลง",
            key_results: "Key Results",
            ai_suggest_krs_tooltip: "ให้ AI แนะนำ Key Results ที่วัดผลได้",
            add_kr_manually_tooltip: "เพิ่ม Key Result ด้วยตนเอง",
            no_kr_empty_hint: "เพิ่ม Key Results ที่วัดผลได้เพื่อติดตามความคืบหน้า",
            new_key_result: "Key Result ใหม่",
            kr_title_placeholder: "ชื่อ Key Result",
            start: "เริ่มต้น",
            target: "เป้าหมาย",
            unit: "หน่วย",
            unit_placeholder: "เช่น %",
            owners: "ผู้รับผิดชอบ",
            assign_members_placeholder: "มอบหมายสมาชิกทีม",
            teams_group_label: "ทีม",
            people_group_label: "บุคคล",
            tracking_mode: "โหมดการติดตาม",
            tracking_collaborative: "ร่วมกัน — ความคืบหน้าที่แชร์",
            tracking_individual: "รายบุคคล — ต่อคน",
            tracking_collaborative_hint: "ทุกคนมีส่วนร่วมในตัวเลขเดียวกัน",
            tracking_individual_hint: "แต่ละคนติดตามความคืบหน้าของตนเอง",
            tracking_individual_decreasing_warning: "การติดตามรายบุคคลจะรวมค่าของแต่ละคน ซึ่งใช้ไม่ได้เมื่อเป้าหมายต่ำกว่าจุดเริ่มต้น",
            tracking_decreasing_reframe_hint: "ลองปรับเป็นตัวชี้วัดที่เพิ่มขึ้นแทน — เช่น \"เพิ่มอัตราการคงอยู่เป็น 80%\" แทน \"ลดอัตราการลาออกเป็น 20%\"",
            targets_per_owner: "เป้าหมายต่อคน",
            owner_targets_match: "เป้าหมายรายบุคคลรวม {sum} / เป้าหมายทีม {team}",
            owner_targets_short: "เป้าหมายรายบุคคลรวม {sum} — เป้าหมายทีม {team} (ขาด {delta})",
            owner_targets_over: "เป้าหมายรายบุคคลรวม {sum} — เป้าหมายทีม {team} (เกิน {delta})",
            owner_target_reset_tooltip: "รีเซ็ตเป็นส่วนแบ่งเริ่มต้น",
            owner_target_customized_hint: "เป้าหมายกำหนดเอง",
            owner_target_customized_tag: "กำหนดเอง",
            owner_targets_match_action: "ตั้งเป้าหมายทีมเป็น {sum}",
            cycle: "รอบ",
            cycle_placeholder: "ต่อเนื่อง (ไม่มีรอบ)",
            add_key_result: "เพิ่ม Key Result",
            parent_goal_links: "ลิงก์เป้าหมายหลัก",
            edit_links: "แก้ไขลิงก์",
            add_links: "เพิ่มลิงก์",
            no_parent_links_yet: "ยังไม่มีเป้าหมายหลักที่เชื่อม",
            people_focusing_on_goal: "ผู้ที่โฟกัสเป้าหมายนี้:",
            no_members_found: "ไม่พบสมาชิก",
            no_members_available: "ไม่มีสมาชิก",
            select_team_to_view: "เลือกทีมเพื่อดู KRs ของสมาชิก",
            krs_label: "KRs",
            no_krs_assigned: "ไม่มี KRs ที่มอบหมาย",
            tab_freeform: "ฟรีฟอร์ม",
            tab_advanced: "ขั้นสูง",
            freeform_description: "ใส่เป้าหมายเป็นข้อความอิสระ AI จะจัดรูปแบบเป็นเป้าหมายแต่ละข้อพร้อมคำอธิบาย",
            advanced_description_existing: "แก้ไขเป้าหมายที่มีอยู่หรือเพิ่มเป้าหมายใหม่",
            advanced_description_new: "เพิ่มเป้าหมายพร้อมชื่อและคำอธิบายโดยตรง ไม่ต้องใช้ AI",
            goal_label: "เป้าหมาย",
            existing: "มีอยู่",
            new: "ใหม่",
            goal_title_placeholder: "ชื่อเป้าหมาย (เช่น เพิ่มความพึงพอใจของลูกค้า)",
            goal_description_optional_placeholder: "คำอธิบาย (ไม่บังคับ - ใส่รายละเอียดเพิ่มเติมของเป้าหมายนี้)",
            link_to_parent_goals: "เชื่อมกับเป้าหมายหลัก",
            linked: "เชื่อมแล้ว",
            select_parent_goals_placeholder: "เลือกเป้าหมายหลักเพื่อจัดแนว...",
            no_parent_team_goals: "ไม่มีเป้าหมายทีมหลักให้เชื่อม",
            add_another_goal: "เพิ่มเป้าหมายอีก",
            link_subtitle: "จัดแนวเป้าหมายนี้กับวัตถุประสงค์ระดับที่สูงกว่า",
            current_goal: "เป้าหมายปัจจุบัน",
            no_parent_goals_available: "ไม่มีเป้าหมายหลัก",
            no_parent_goals_desc: "ทีมหลักต้องมีเป้าหมายก่อนจึงจะสร้างลิงก์จัดแนวได้",
            select_parent_goals: "เลือกเป้าหมายหลัก",
            links: "ลิงก์",
            link_noun: "ลิงก์",
            remove_all_links: "ลบลิงก์ทั้งหมด",
            toast_updated: "อัปเดตเป้าหมายสำเร็จ",
            toast_update_failed: "อัปเดตเป้าหมายไม่สำเร็จ",
            toast_archived: "เก็บเป้าหมายสำเร็จ",
            toast_archive_failed: "เก็บเป้าหมายไม่สำเร็จ",
            toast_restored: "กู้คืนเป้าหมายสำเร็จ",
            toast_restore_failed: "กู้คืนเป้าหมายไม่สำเร็จ",
            toast_deleted: "ลบเป้าหมายถาวรสำเร็จ",
            toast_delete_failed: "ลบเป้าหมายไม่สำเร็จ",
            kr_cycle: "รอบ",
            kr_cycle_placeholder: "ต่อเนื่อง",
            kr_start: "เริ่มต้น",
            kr_target: "เป้าหมาย",
            kr_unit: "หน่วย",
            kr_collaborative: "ร่วมกัน",
            kr_individual: "รายบุคคล",
            kr_status_on_track: "ตามแผน",
            kr_status_at_risk: "มีความเสี่ยง",
            kr_status_off_track: "ออกนอกแผน",
            kr_status_completed: "เสร็จสมบูรณ์",
            kr_search_team_or_member: "ค้นหาทีมหรือสมาชิก",
            kr_teams_section: "ทีม",
            kr_people_section: "คน",
            kr_no_members_found: "ไม่พบสมาชิก",
            kr_clear_all: "ล้างทั้งหมด",
            kr_note_placeholder: "หมายเหตุ (ไม่บังคับ)",
            kr_status_auto: "อัตโนมัติ (ตามความคืบหน้า)",
            kr_status_manual_dot_tooltip: "สถานะถูกกำหนดด้วยตนเองโดย {name}",
            kr_status_manual_dot_tooltip_unknown: "สถานะถูกกำหนดด้วยตนเอง",
            kr_meta_updated_by: "อัปเดต {time} โดย {name}",
            kr_meta_updated_auto: "อัปเดต {time} โดยอัตโนมัติ",
            kr_meta_updated: "อัปเดต {time}",
            kr_history_title: "ประวัติการอัปเดต",
            kr_history_empty: "ยังไม่มีการอัปเดต",
            kr_history_show_all: "แสดงการอัปเดตทั้งหมด {count} รายการ",
            kr_history_automation_actor: "ระบบอัตโนมัติ",
            kr_history_team_total: "ยอดรวมทีม {value}",
            kr_history_unknown_actor: "ไม่ทราบ",
            kr_detail_eyebrow: "Key Result",
            kr_detail_of_target: "ของเป้าหมาย",
            kr_detail_delta_since: "{delta} จากการอัปเดตครั้งก่อน",
            kr_detail_chart_title: "ความคืบหน้าตามช่วงเวลา",
            kr_detail_chart_empty: "ยังมีการอัปเดตไม่พอที่จะแสดงกราฟ — การอัปเดตแต่ละครั้งจะแสดงที่นี่",
            kr_detail_target_label: "เป้าหมาย",
            kr_detail_owners: "ผู้รับผิดชอบ",
            kr_detail_no_owners: "ยังไม่มีผู้รับผิดชอบ",
            kr_detail_automation: "ระบบอัตโนมัติ",
            kr_detail_last_synced: "ซิงค์ล่าสุด {time}",
            kr_detail_last_checked: "ตรวจสอบล่าสุด {time}",
            kr_detail_awaiting_sync: "รอการซิงค์ครั้งแรก",
            kr_detail_automation_paused: "ระบบอัตโนมัติหยุดชั่วคราว",
            kr_detail_cadence_daily: "ทำงานทุกวันเวลา {time}",
            kr_detail_cadence_weekly: "ทำงานทุกสัปดาห์วัน{day} เวลา {time}",
            kr_detail_cadence_monthly: "ทำงานทุกเดือนวันที่ {dayOfMonth} เวลา {time}",
            kr_detail_reconnect: "เชื่อมต่อใหม่",
            kr_detail_edit_automation: "แก้ไขระบบอัตโนมัติ",
            kr_detail_pause_automation: "หยุดชั่วคราว",
            kr_detail_resume_automation: "ทำงานต่อ",
            kr_detail_delete_automation: "ลบ",
            kr_detail_update_progress: "อัปเดตความคืบหน้า",
            kr_detail_edit_kr: "แก้ไข Key Result",
            kr_detail_save_update: "บันทึกการอัปเดต",
            suggest_kr_title: "แนะนำ Key Results",
            suggest_kr_subtitle: "ผลลัพธ์ที่วัดได้ด้วย AI สำหรับเป้าหมายของคุณ",
            run_fresh_ai_analysis: "วิเคราะห์ AI ใหม่",
            refresh: "รีเฟรช",
            kr_loading_hint: "โดยปกติใช้เวลา 15-30 วินาที",
            try_again: "ลองอีกครั้ง",
            no_suggestions_title: "ไม่มีคำแนะนำ",
            no_suggestions_desc: "ลองเพิ่มรายละเอียดให้เป้าหมายหรือเชื่อมโยงรายการโฟกัสเพิ่มเติมกับเป้าหมายนี้",
            goal_context: "บริบทเป้าหมาย",
            kr_added: "เพิ่มแล้ว",
            kr_skipped: "ข้ามแล้ว",
            kr_confidence: "ความมั่นใจ",
            kr_ai_reasoning: "การให้เหตุผลของ AI",
            kr_owner: "เจ้าของ",
            kr_assign_later: "กำหนดภายหลัง",
            kr_skip: "ข้าม",
            kr_accept: "ยอมรับ",
            toast_confirm_delete_kr: "ลบ key result นี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
            toast_delete_kr_title: "ลบ Key Result",
            toast_confirm_delete_automation: "ลบระบบอัตโนมัตินี้หรือไม่? Key Result และประวัติการอัปเดตจะยังคงอยู่ แต่การอัปเดตอัตโนมัติจะหยุดลง",
            toast_delete_automation_title: "ลบระบบอัตโนมัติ",
            toast_automation_paused: "หยุดระบบอัตโนมัติชั่วคราวแล้ว",
            toast_automation_resumed: "ระบบอัตโนมัติทำงานต่อแล้ว",
            toast_automation_deleted: "ลบระบบอัตโนมัติแล้ว",
            toast_automation_update_failed: "ไม่สามารถอัปเดตระบบอัตโนมัติได้",
            toast_automation_delete_failed: "ไม่สามารถลบระบบอัตโนมัติได้",
            toast_add_at_least_one_goal: "กรุณาเพิ่มเป้าหมายอย่างน้อยหนึ่งรายการพร้อมชื่อ",
            toast_goal_title_too_long: "ชื่อเป้าหมายต้องมีความยาวไม่เกิน 30 ตัวอักษร",
            toast_goals_saved_successfully: "บันทึกเป้าหมายเรียบร้อยแล้ว",
            toast_no_data_to_export: "ไม่มีข้อมูลให้ส่งออก",
            toast_goal_title_too_long_single: "ชื่อเป้าหมายต้องมีความยาวไม่เกิน 30 ตัวอักษร",
            toast_confirm_save_changes: "ยืนยันการบันทึกการเปลี่ยนแปลงของเป้าหมายนี้หรือไม่?",
            toast_confirm_changes_title: "ยืนยันการเปลี่ยนแปลง",
            toast_failed_to_update_goal: "อัปเดตเป้าหมายไม่สำเร็จ",
            toast_confirm_archive: "ยืนยันการเก็บถาวรเป้าหมายนี้หรือไม่? สามารถกู้คืนได้ภายหลังจากมุมมอง \"Show Archived\"",
            toast_archive_title: "เก็บถาวรเป้าหมาย",
            toast_confirm_restore: "ยืนยันการกู้คืนเป้าหมายนี้หรือไม่? จะแสดงในรายการเป้าหมายที่ใช้งาน",
            toast_restore_title: "กู้คืนเป้าหมาย",
            toast_confirm_delete_goal: "ยืนยันการลบเป้าหมายนี้ถาวรหรือไม่? การกระทำนี้ไม่สามารถย้อนกลับได้",
            toast_delete_goal_title: "ลบเป้าหมาย",
            toast_goal_linked_prefix: "เชื่อมโยงเป้าหมายกับ",
            toast_goal_linked_suffix: "เป้าหมายหลัก",
            toast_parent_links_removed: "ลบการเชื่อมโยงเป้าหมายหลักแล้ว",
            toast_failed_update_goal_links: "อัปเดตการเชื่อมโยงเป้าหมายไม่สำเร็จ",
        },
    },
    settings: {
        page_title: "ตั้งค่า",
        page_description: "จัดการฟีเจอร์ การสื่อสาร และประสบการณ์ของทั้งบริษัท",
        save_changes: "บันทึก",
        undo: "เลิกทำ",
        changes_banner: "คุณได้แก้ไขการตั้งค่าแล้ว",
        tab_general: "การตั้งค่าทั่วไป",
        tab_performance: "การประเมินผลงาน",
        tab_values: "ทักษะและค่านิยม",
        tab_village: "Happily Village",
        tab_email_notifications: "การแจ้งเตือนทางอีเมล",
        section_general: "บริษัทและการสื่อสาร",
        section_general_description: "จัดการข้อมูลบริษัท กำหนดการส่ง วันหยุด การแสดงผลฟีด ความเป็นส่วนตัว และสิทธิ์การเข้าถึงเพื่อรับความช่วยเหลือ",
        company_name: "ชื่อบริษัท",
        pulse_report_schedule: "กำหนดการ Pulse และรายงาน",
        pulse_report_schedule_description: "กำหนดเวลาที่จะส่งคำถามและรายงานให้ทีมของคุณ",
        daily_pulse: "Daily Pulse",
        daily_insights: "อินไซต์รายวัน",
        weekly_insights: "อินไซต์รายสัปดาห์",
        monthly_insights: "อินไซต์รายเดือน",
        company_holidays: "วันหยุดบริษัท",
        company_holidays_description: "คำถาม Daily Pulse จะหยุดในวันหยุดบริษัทที่กำลังจะถึง",
        add_holidays: "เพิ่มวันหยุด",
        personal_holiday_presets: "พรีเซ็ตวันหยุดส่วนตัว",
        personal_holiday_presets_description: "สร้างตารางวันหยุดเฉพาะทีมหรือสมาชิก เพื่อหยุดคำถาม Daily Pulse ในวันหยุดส่วนตัว",
        set_personal_holiday: "ตั้งวันหยุดส่วนตัว",
        activity_feed_names: "ชื่อใน Activity Feed",
        activity_feed_names_description: "เมื่อเปิดใช้งาน Activity Feed จะแสดงชื่อเล่นหากมี หากปิดจะแสดงชื่อจริงแทน",
        use_nicknames_in_activity_feed: "ใช้ชื่อเล่นใน Activity Feed",
        activity_feed_rewards: "กิจกรรมแลกรางวัล",
        activity_feed_rewards_description: "เมื่อเปิดใช้งาน รายการแลกรางวัลจะแสดงใน Activity Feed ปิดเพื่อซ่อนกิจกรรมการแลกรางวัล",
        show_reward_redemptions_in_activity_feed: "แสดงการแลกรางวัลใน Activity Feed",
        allow_cross_location_gift_rewards: "อนุญาตให้ส่งของขวัญรางวัลข้ามประเทศหรือสถานที่",
        allow_cross_location_gift_rewards_description: "ให้พนักงานส่งของขวัญรางวัลให้เพื่อนร่วมงานในประเทศหรือสถานที่อื่นได้ รางวัลท้องถิ่นอาจยังแสดงคำเตือนหากผู้รับอาจไม่สามารถแลกใช้ได้",
        happily_assistance: "Happily Assistance",
        happily_assistance_description: "อนุญาตให้ทีม Happily เข้าถึงคอนโซลเพื่อช่วยดูแลบัญชีและให้คำแนะนำ",
        happily_assist_access: "การเข้าถึง Happily Assist",
        demo_mode: "โหมดเดโม",
        demo_mode_description: "ชื่อผู้ใช้ อีเมล ทีม และรูปโปรไฟล์ของสมาชิกจะถูกเบลอทุกหน้าเมื่อเปิดโหมดเดโม ควรใช้อย่างระมัดระวัง เนื่องจากบางส่วนอาจไม่ถูกเบลอ",
        enable_demo_mode: "เปิดใช้งานโหมดเดโม",
        section_performance: "การประเมินและฟีดแบ็ก",
        section_performance_description: "ควบคุมเครื่องมือประเมินของผู้จัดการ ระยะเวลาสถานะการประเมิน และคำถามชวนสะท้อน",
        enable_performance_boosts: "เปิดใช้งาน Performance Boosts",
        enable_performance_boosts_description: "Performance Boosts ให้ผู้จัดการมอบฟีดแบ็กและการชื่นชมผ่านรางวัล Gems ข้อมูลนี้จะนำไปรวมใน Impact Ratings ของพนักงาน",
        performance_boosts: "Performance Boosts",
        performance_boost_notice: "การแจ้งเตือน Performance Boost",
        performance_boost_notice_description: "ตั้งกำหนดการประเมินที่เหมาะสมสำหรับผู้จัดการในการประเมินผลงาน",
        pending_after: "ค้างหลังจาก",
        overdue_after: "เกินกำหนดหลังจาก",
        ai_reviewed_feedback: "ฟีดแบ็กตรวจสอบโดย AI",
        reset_monthly: "รีเซ็ตรายเดือน",
        section_values: "การชื่นชมและฟีดแบ็กจากเพื่อนร่วมงาน",
        section_values_description: "กำหนดค่านิยมและทักษะที่ใช้ในการชื่นชมเพื่อนร่วมงานและให้ฟีดแบ็ก",
        recognition_values: "ค่านิยมการชื่นชม",
        recognition_values_description: "การชื่นชมจากเพื่อนร่วมงานและผู้จัดการสามารถกำหนดให้สอดคล้องกับค่านิยมของบริษัท โดยแสดงเป็นแฮชแท็กในการชื่นชม",
        new_value: "เพิ่มค่านิยม",
        peer_feedback: "ฟีดแบ็กจากเพื่อนร่วมงาน",
        peer_feedback_description: "ในต้นเดือน สมาชิกแต่ละคนสามารถเลือกได้ถึง 2 คนเพื่อขอรับฟีดแบ็ก ผู้ให้ฟีดแบ็กสามารถเลือกแท็กด้านล่างเพื่อระบุสิ่งที่ผู้รับ \"เก่ง\":",
        peer_feedback_interactions: "การให้ฟีดแบ็กจากเพื่อนร่วมงาน",
        new_skill: "เพิ่มทักษะ",
        section_village: "การเข้าถึงและการมีส่วนร่วม",
        section_village_description: "จัดการการเข้าถึง Village การให้คะแนน House สิทธิ์การสนทนา และหัวข้อที่สร้างด้วย AI",
        village_access: "การเข้าถึง Village",
        village_access_description: "สมาชิกทุกคนจะสามารถเข้าถึง Happily Village ที่มีกิจกรรมส่งเสริมความเป็นอยู่ที่ดี การเรียนรู้ และการทำงานร่วมกัน พร้อม Running Track, University, Houses และอื่น ๆ อีกมากมาย",
        happily_village_access: "การเข้าถึง Happily Village",
        fair_play_boost: "Fair Play Boost ของ Battle Stadium",
        fair_play_boost_description: "ปรับสมดุลคะแนน House เมื่อจำนวนสมาชิกแต่ละ House แตกต่างกันมาก โดยไม่ปรับ XP ส่วนบุคคลหรืออันดับในภารกิจ",
        fair_play_boost_enabled_note: "เปิดใช้งานแล้ว ระบบจะตรวจสอบขนาด House เมื่อภารกิจวันจันทร์ถัดไปเริ่มขึ้น ภารกิจที่กำลังดำเนินอยู่จะไม่เปลี่ยนแปลง",
        fair_play_boost_disabled_note: "ปิดใช้งาน คะแนน House จะใช้วิธีคำนวณมาตรฐาน การเปลี่ยนแปลงจะมีผลกับภารกิจวันจันทร์ถัดไป",
        topic_creation_permissions: "สิทธิ์การสร้างหัวข้อ",
        topic_creation_permissions_description: "ควบคุมว่าใครสามารถเริ่มการสนทนาใน Town Hall ได้ หากจำกัดไว้ เฉพาะแอดมินเท่านั้นที่สร้างหัวข้อใหม่ได้ แต่พนักงานทุกคนยังเข้าร่วมการสนทนาที่มีอยู่ได้",
        allow_employee_topic_creation: "อนุญาตให้พนักงานสร้างหัวข้อ",
        town_hall_agent: "Town Hall Agent",
        town_hall_agent_description: "เพิ่มมิติให้การสนทนาในที่ทำงานด้วย AI ที่ช่วยเริ่มบทสนทนา Town Hall Agent สร้างหัวข้อและโพลที่น่าสนใจตามธีมที่คุณเลือก ช่วยกระตุ้นการสนทนาและการมีส่วนร่วมของพนักงาน",
        performance_conversations: "บทสนทนาเรื่องผลงาน",
        performance_conversations_description: "หลังอัปเดต Key Result ชวนพนักงานสะท้อนสั้น ๆ เพื่อเริ่มบทสนทนากับผู้จัดการ ข้อความส่งถึงผู้จัดการเท่านั้น ไทม์ไลน์แสดงเพียงสรุปแบบกลาง ๆ",
        add_theme: "เพิ่มธีม",
        section_email_notifications: "อีเมลสำหรับผู้จัดการและ HR",
        section_email_notifications_description: "เลือกการแจ้งเตือนกิจกรรม รายงานประจำ และรายละเอียดฟีดแบ็กที่จะส่งทางอีเมล",
        cancel: "ยกเลิก",
        confirm: "ยืนยัน",
        toast_valid_data_required: "ต้องระบุข้อมูลที่ถูกต้อง",
        toast_saving_changes: "กำลังบันทึกการเปลี่ยนแปลง...",
        toast_generated_attributes_prefix: "สร้าง",
        toast_generated_attributes_middle: "attributes สำหรับ",
        toast_generate_attributes_failed: "สร้าง attributes ไม่สำเร็จ กรุณาลองอีกครั้ง",
        toast_this_value: "ค่านี้",
        toast_recognition_delete_prefix: "การชื่นชมที่ส่งพร้อมกับ",
        toast_recognition_delete_suffix: "จะสูญเสียความเชื่อมโยงกับค่านี้ การกระทำนี้ไม่สามารถย้อนกลับได้",
        toast_delete_label: "ลบ",
    },
    skills: {
        learning_journeys: {
            select_placeholder: "เลือก",
            overview: "ภาพรวม",
            active_learning_journeys: "Learning Journey ที่กำลังดำเนินการ",
            completed_journeys: "Journey ที่เสร็จสิ้น",
            members_upskilled: "สมาชิกที่พัฒนาทักษะ",
            learning_time: "เวลาการเรียนรู้",
            activation_channel: "ช่องทางการเริ่มต้น",
            activation_channel_description: "Learning Journey ที่เริ่มโดยผู้จัดการ (เน้นผลงาน) หรือเริ่มด้วยตนเอง (การเติบโตส่วนบุคคล)",
            manager: "ผู้จัดการ",
            self: "ตนเอง",
            top_learners: "ผู้เรียนยอดเยี่ยม",
            top_learners_subtitle: "สมาชิกทีมที่มี Learning Journey มากที่สุด",
            view_all: "ดูทั้งหมด",
            learning_journey_progress: "ความคืบหน้า Learning Journey",
            view_skill_category_analytics: "ดูการวิเคราะห์หมวดหมู่ทักษะ",
            status: "สถานะ",
            skill_set: "ชุดทักษะ",
            progress: "ความคืบหน้า",
            initiated_by: "เริ่มโดย",
            assigned_to: "มอบหมายให้",
            date_time: "วันที่และเวลา",
            loading_more_items: "กำลังโหลดรายการเพิ่มเติม...",
            end_of_list: "สิ้นสุดรายการ",
            empty_state: "ไม่พบ Learning Journey ที่ตรงกับตัวกรอง",
            top_learners_explanation: "สมาชิกทีมที่เข้าร่วม Learning Journey มากที่สุดในช่วงเวลาที่เลือก",
            search_member: "ค้นหาสมาชิก",
            no_learners_found: "ไม่พบผู้เรียนที่ตรงกับการค้นหา",
            skill_category_analytics: "การวิเคราะห์หมวดหมู่ทักษะ",
            skill_category_analytics_subtitle: "การกระจาย Learning Journey ตามหมวดหมู่ทักษะ",
            time_period: "ช่วงเวลา:",
            search_category: "ค้นหาหมวดหมู่",
            categories: "หมวดหมู่",
            total_journeys: "Journey ทั้งหมด",
            active: "ใช้งาน",
            completed: "เสร็จสิ้น",
            category: "หมวดหมู่",
            distribution: "การกระจาย",
            total: "ทั้งหมด",
            no_categories_found: "ไม่พบหมวดหมู่ที่ตรงกับการค้นหา",
        },
        power_skills: {
            select_placeholder: "เลือก",
            all_teams: "ทีมทั้งหมด",
            team: "ทีม",
            progress_and_ratings: "ความคืบหน้าและคะแนน Power Skills",
            progress_and_ratings_subtitle: "คะแนนความพยายามโดยรวมในการฝึกทักษะแต่ละด้าน พร้อมแนวโน้มคะแนนและลีดเดอร์บอร์ด 6 เดือนที่ผ่านมา",
            loading: "กำลังโหลดข้อมูล Power Skills…",
            error_title: "ไม่สามารถโหลดข้อมูล Power Skills ได้",
            retry: "ลองอีกครั้ง",
            empty_title: "ไม่มีข้อมูล Power Skills",
            empty_description: "ไม่มีข้อมูลให้แสดงตามเงื่อนไขที่เลือก",
            company_avg: "ค่าเฉลี่ยบริษัท",
            percentile_75th: "75th",
            median: "ค่ากลาง",
            percentile_25th: "25th",
            leaderboard: "ลีดเดอร์บอร์ด",
            sort_by: "เรียงตาม",
            sort_all: "ทั้งหมด",
            ascending_rating: "คะแนนจากน้อยไปมาก",
            ascending_score: "สกอร์จากน้อยไปมาก",
            descending_rating: "คะแนนจากมากไปน้อย",
            descending_score: "สกอร์จากมากไปน้อย",
        },
        development: {
            select_placeholder: "Select a team",
            all_teams: "All Teams",
            search: "Search members",
            members_label: "members",
            vs_prior: "vs prior",
            member: "Member",
            rating_trend: "Rating trend",
            top_strength: "Top strength",
            development_area: "Development area",
            journeys: "Journeys",
            summary: "Summary",
            fresh: "Fresh",
            stale: "Stale",
            needs_data: "Needs data",
            none: "Not generated",
            completed_short: "done",
            active_short: "active",
            evidence: "Evidence",
            peer_count: "{n} peer",
            peers_count: "{n} peers",
            manager_review_count: "{n} manager review",
            manager_reviews_count: "{n} manager reviews",
            no_manager_reviews_short: "No manager reviews",
            no_feedback_yet: "No feedback yet",
            what_changed: "สิ่งที่เปลี่ยนไป",
            vs_previous_months: "เทียบกับ {n} เดือนก่อนหน้า",
            peer_rating: "คะแนนจากเพื่อนร่วมงาน",
            manager_goals: "หัวหน้า · เป้าหมาย",
            manager_culture: "หัวหน้า · วัฒนธรรม",
            mv_improved: "พัฒนาขึ้น",
            mv_new_strength: "จุดแข็งใหม่",
            mv_still_developing: "ยังต้องพัฒนา",
            mv_watch: "ควรจับตา",
            mv_growth_to_strength: "เคยเป็นจุดที่ต้องพัฒนา ×{was} ตอนนี้เป็นจุดแข็ง ×{now}",
            mv_new_strength_detail: "จุดแข็ง ×{now} ในช่วงนี้ ไม่เคยถูกกล่าวถึงมาก่อน",
            mv_still_detail: "เป็นจุดที่ต้องพัฒนาทั้งสองช่วง (×{was} → ×{now})",
            mv_watch_detail: "เคยเป็นจุดแข็ง ตอนนี้เป็นจุดที่ต้องพัฒนา ×{now}",
            consistent_picture: "ภาพรวมคงที่ ไม่มีทักษะที่เปลี่ยนด้าน",
            recognized_for: "ได้รับการยกย่องด้าน:",
            new_short: "ใหม่",
            volume_caption: "อ้างอิงจากฟีดแบ็ก {nowFb} จากเพื่อนร่วมงาน {nowPeers} คน และรีวิวจากหัวหน้า {nowReviews} ครั้ง (เทียบกับ {prevFb} จาก {prevPeers} คน, {prevReviews} ครั้งก่อนหน้า)",
            open_hint: "Click a member to open their development picture",
            back: "Back to roster",
            export: "Export",
            regenerate: "Regenerate",
            generated_on: "Generated",
            development_summary: "Development summary",
            provenance: "Generated from {feedback} feedback events, {journeys} journeys, {reviews} reviews",
            strengths_themes: "Strengths",
            development_areas: "Development areas",
            trajectory_statement: "Trajectory",
            suggested_focus: "Suggested focus",
            summary_unavailable: "Summary unavailable right now.",
            retry: "Retry",
            needs_data_hint: "Not enough feedback in this period to generate a summary. Evidence below shows what exists so far.",
            trajectory: "Trajectory",
            trajectory_hint: "Average peer-feedback rating received per month (1-4)",
            skills_title: "Strengths & development areas",
            skills_hint: "Peer feedback mentions in this period, with change vs the prior period",
            strengths: "Strengths",
            mentions: "mentions",
            evidence_journeys: "Learning journeys",
            evidence_recognition: "Recognition",
            evidence_behaviors: "Feedback behaviors",
            evidence_performance: "Performance",
            journeys_completed: "Completed",
            journeys_active: "In progress",
            learning_time: "Learning time",
            no_journeys: "No journeys in this period",
            received: "Received",
            given: "Given",
            no_recognition: "No recognition in this period",
            requested: "Requested",
            response_rate: "Response rate",
            no_feedback: "No feedback activity in this period",
            no_reviews: "No reviews",
            goal_rating: "Goals",
            culture_rating: "Culture",
            no_ratings: "No ratings yet",
            no_members: "No members match the current filters",
            member_not_found: "This member isn't in the current roster.",
            rating_truly: "Truly Outstanding",
            rating_exceeding: "Exceeding Expectations",
            rating_meeting: "Meeting Expectations",
            rating_needs: "Needs Improvement",
            holding: "holding",
            generate_report: "Generate report",
            generate_hint: "The AI development summary is generated on demand and cached for later visits.",
            generating: "Generating…",
            not_generated: "Not generated",
            deterministic_brief: "Development brief",
            strongest_signal: "Strongest signal",
            most_cited_growth: "Most-cited growth area",
            rating_label: "Rating",
            typically: "typically {label}",
            what_peers_said: "What peers said",
            mentions_count: "{n} mentions",
            mention_count: "{n} mention",
            new_label: "new",
            paraphrased_from: "Paraphrased from {n} comments",
            paraphrased_from_one: "Paraphrased from 1 comment",
            also_growth_note: "Also named a growth area by {n} peers",
            also_praised_note: "Also praised by {n} peers",
            privacy_quotes: "Quotes are AI-paraphrased and anonymous; original comments are never shown.",
            privacy_pre_ai: "Until the AI report is generated, this section lists cited behaviors and counts only.",
            self_reflection: "Self reflection · in their own words",
            own_answer_verbatim: "Their own answer, shown verbatim",
            reflection_source: "From {name}'s answers to Self Awareness reflection questions in this period ({n} total).",
            development_story: "Development story",
            feedback_loops: "Feedback loops — who, and when",
            peer_feedback_received: "Peer feedback received",
            manager_review_boost: "Manager review boost",
            manager_role: "manager",
            others_row: "{n} others",
            other_row: "1 other",
            growth_moments: "Growth moments",
            feedback_from: "Feedback from {names}",
            feedback_from_peers: "Feedback from {n} peers",
            baseline_title: "Baseline",
            now_title: "Now",
            manager_review_title: "Manager review boost",
            goals_label: "Goals",
            culture_label: "Culture",
            journeys_also: "Also this period: {done} journeys completed, {progress} in progress — {cats}.",
            journeys_also_none_progress: "Also this period: {done} journeys completed — {cats}.",
            manager_review_boosts: "Manager review boosts",
            no_manager_reviews: "No manager reviews in this period.",
            from_name: "from {name}",
            skill_balance: "Skill balance",
            activity_footnote: "Feedback activity this period: {received} received from {givers} givers · gave {given} — full activity lives in Proficiencies. Values recognition received: {tags} ({events} events).",
            strengths_cited: "Strengths cited: {names}.",
            growth_cited: "Growth: {names}.",
        },
        proficiencies: {
            select_placeholder: "เลือก",
            all_teams: "ทีมทั้งหมด",
            all_time: "ตลอดเวลา",
            past_year: "ปีที่ผ่านมา",
            past_6_months: "6 เดือนที่ผ่านมา",
            past_3_months: "3 เดือนที่ผ่านมา",
            current_month: "เดือนนี้",
            last_month: "เดือนที่แล้ว",
            overview: "ภาพรวม",
            rating_overview: "ภาพรวมคะแนน",
            rating_overview_description: "การกระจายของคะแนนต่อเป้าหมายบริษัทจากการให้ฟีดแบ็กระหว่างเพื่อนร่วมงาน",
            truly_outstanding: "โดดเด่นอย่างแท้จริง",
            exceeding_expectations: "เกินความคาดหวัง",
            meeting_expectations: "ตรงตามความคาดหวัง",
            needs_improvement: "ต้องพัฒนาเพิ่ม",
            highest_rated: "คะแนนสูงสุด",
            highest_rated_description: "สมาชิกที่ได้คะแนนฟีดแบ็กจากเพื่อนร่วมงานสูงสุด ในระดับ 1 ถึง 4",
            lowest_rated: "คะแนนต่ำสุด",
            lowest_rated_description: "สมาชิกที่ได้คะแนนฟีดแบ็กจากเพื่อนร่วมงานต่ำสุด ในระดับ 1 ถึง 4",
            see_all: "ดูทั้งหมด",
            skills_proficiency: "ความเชี่ยวชาญทักษะ",
            skills_excel_at: "ทักษะที่สมาชิกทำได้ดี",
            skills_improve_at: "ทักษะที่สมาชิกควรพัฒนา",
            skill_selected_description: "จำนวนครั้งที่เลือกทักษะนี้ (เทียบกับช่วงเวลาก่อนหน้า)",
            excels_at: "ทำได้ดีใน",
            could_further_improve: "ควรพัฒนาเพิ่มใน",
            members_excel: "สมาชิกทำได้ดี",
            members_could_improve: "สมาชิกที่ควรพัฒนาเพิ่ม",
            peer_feedback_rating: "คะแนนฟีดแบ็กเพื่อนร่วมงาน",
            rank: "อันดับ",
            average_rating: "คะแนนเฉลี่ย",
            interactions: "การโต้ตอบ",
            peer_feedback: "ฟีดแบ็กจากเพื่อนร่วมงาน",
            behaviors_title: "พฤติกรรมการให้ฟีดแบ็กรายบุคคล",
            behaviors_description: "ระดับการมีส่วนร่วมในฟีดแบ็กของแต่ละคน ตั้งแต่การขอ การได้รับ ไปจนถึงการให้ฟีดแบ็กแก่ผู้อื่น พร้อมคะแนนเฉลี่ยที่ได้รับ",
            loading_behaviors: "กำลังโหลดข้อมูลกิจกรรมฟีดแบ็ก...",
            requests_made: "คำขอฟีดแบ็ก",
            feedback_given: "ฟีดแบ็กที่ให้",
            participation: "การมีส่วนร่วม",
            requested: "ขอ",
            received: "ได้รับ",
            given: "ให้",
            no_behaviors: "ไม่มีกิจกรรมฟีดแบ็กในช่วงเวลานี้",
            strengths_title: "จุดแข็งและด้านที่ควรพัฒนา",
            strengths_description: "ทักษะที่เพื่อนร่วมงานยอมรับว่าเป็นจุดแข็ง และด้านที่มองว่ายังพัฒนาได้ เพื่อช่วยกำหนดลำดับความสำคัญด้านการเรียนรู้และพัฒนา",
            strength_mentions: "การกล่าวถึงจุดแข็ง",
            development_mentions: "การกล่าวถึงด้านที่ควรพัฒนา",
            development_areas: "ด้านที่ควรพัฒนา",
            strengths: "จุดแข็ง",
            mentions_label: "ครั้ง",
            people_label: "คน",
            showing_top_skills: "แสดง 10 ทักษะที่ถูกกล่าวถึงมากที่สุด",
            members_label: "สมาชิก",
            no_skill_mentions: "ไม่มีฟีดแบ็กด้านทักษะในช่วงเวลานี้",
            total_ratings: "การให้คะแนนทั้งหมด",
            ratings_label: "ครั้ง",
            no_ratings: "ไม่มีคะแนนฟีดแบ็กในช่วงเวลานี้",
            asked: "ถูกขอ",
            receiving_feedback: "การรับฟีดแบ็ก",
            giving_feedback: "การให้ฟีดแบ็ก",
            response_rate: "% ตอบกลับ",
            response_rate_hint: "สัดส่วนของคำขอฟีดแบ็กที่เพื่อนร่วมงานส่งถึงคนนี้ ซึ่งคนนี้ได้ให้ฟีดแบ็กกลับ",
            rating_short: "คะแนน",
            requested_hint: "จำนวนคำขอฟีดแบ็กที่คนนี้ส่งถึงเพื่อนร่วมงาน",
            received_hint: "จำนวนฟีดแบ็กที่คนนี้ได้รับจากเพื่อนร่วมงาน",
            asked_hint: "จำนวนคำขอฟีดแบ็กที่เพื่อนร่วมงานส่งถึงคนนี้",
            given_hint: "จำนวนฟีดแบ็กที่คนนี้ให้แก่เพื่อนร่วมงาน",
            average_rating_hint: "คะแนนเฉลี่ยจากเพื่อนร่วมงาน ตั้งแต่ 1 (ต้องพัฒนาเพิ่ม) ถึง 4 (โดดเด่นอย่างแท้จริง)",
            participation_hint: "สัดส่วนของสมาชิกที่ขอหรือให้ฟีดแบ็กในช่วงเวลานี้",
            skill_details: "รายละเอียดทักษะ",
            by_attribute: "ตามคุณลักษณะ",
            attribute_hint: "สัดส่วนของการกล่าวถึงที่ระบุคุณลักษณะนี้",
        },
    },
    focus: {
        last_7_days: "7 วันที่ผ่านมา",
        last_30_days: "30 วันที่ผ่านมา",
        last_60_days: "60 วันที่ผ่านมา",
        last_90_days: "90 วันที่ผ่านมา",
    },
    programs: {
        Completion_reward: "Reward",
        Add_completion_reward: "Add reward",
        Currency_coins: "Coins",
        Currency_gems: "Gems",
        Currency_xp: "XP",
        Reward_needs_value: "1 reward needs a value",
        Reward_reason_placeholder: "Why are they getting this?",
    },
};
